/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

export interface IrDevice {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  mnId?: string;
  /**
   * The PID of the device you want to control
   * @example "000000000000000000000000c3050100"
   */
  pid?: string;
  /**
   * The Onboarding Id, used by mobile phone.
   * @example 100
   */
  onboardingId?: string;
  /**
   * The brand name of the device
   * @example "Samsung"
   */
  brandName?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback","statelessVolumeButtonWithRepetition.volumeUp":4,"statelessVolumeButtonWithRepetition.volumeDown":5}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDevice[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
  /**
   * Room that the device is in
   * @example "244d9196-fc90-4122-9fe8-2343eede60c2"
   */
  roomId?: string;
  /**
   * If this is an Air Conditioner, the minimum temperature allowed
   * @example 0
   */
  minValue?: number;
  /**
   * If this is an Air Conditioner, the maximum temperature allowed
   * @example 30
   */
  maxValue?: number;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

export interface IrChildDevice {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId?: string;
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  mnId?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

/** A paginated array of devices. */
export interface PagedIRDevices {
  items?: IrDevice[];
  _links?: Links;
}

/** A paginated array of devices. */
export interface PagedIRChildDevices {
  items?: IrChildDevice[];
  _links?: Links;
}

/** Creating an IR device. Note - Either (ocfDeviceType) OR (mnId and onboardingId) must be provided. */
export interface CreateIrDevice {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F"
   */
  mnId?: string;
  /**
   * The Onboarding Id, used by mobile phone.
   * @example 100
   */
  onboardingId?: string;
  /**
   * The brand name of the device
   * @example "Samsung"
   */
  brandName?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * Device capabilities associated with IR functions or function key/value pairs
   * @example {"statelessPowerToggleButton.powerToggle":{"power":"toggle"},"statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: object;
    [key: string]: any;
  };
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   * @example {"mac":"00000110","did":"0c0b935d-0616-4441-a0bf-da7aeec3dc0a","pid":"0c0b935d-0616-4441-a0bf-da7aeec3dc0a","cookie":"base64(cookie)"}
   */
  metadata?: Record<string, object>;
  /** The desired state of an Air Conditioner */
  acState?: AcState;
  /**
   * The Room id that the device should be associated with
   * @example "244d9196-fc90-4122-9fe8-2343eede60c2"
   */
  roomId?: string;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

export interface IrUpdateRequest {
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * The brand name of the device
   * @example "Samsung"
   */
  brandName?: string;
  /**
   * Device capabilities associated with IR functions or function key/value pairs.
   * These sholud be comprised of all capabilities of the ir device.
   * All existing values will be overwritten.
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: object;
    [key: string]: any;
  };
  /**
   * Key value pairs stored for the device.
   * All existing values will be overwritten
   */
  metadata?: Record<string, any>;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

export type DevTypes = {
  /**
   * The id of the device type
   * @example "15"
   */
  devTypeId?: string;
  /**
   * The name of the device type
   * @example "DVD播放机"
   */
  devTypeName?: string;
}[];

export type Brands = {
  /**
   * The name of the brand
   * @example "长虹电视"
   */
  brand?: string;
  /**
   * Id for the brand
   * @example "6"
   */
  brandId?: string;
  /**
   * English translation of the brand (This appears to be empty in all examples provided)
   * @example ""
   */
  enBrand?: string;
  /**
   * TODO
   * @example "0"
   */
  famousStatus?: string;
}[];

export type Channels = {
  /**
   * Channel name
   * @example "中央一套"
   */
  name?: string;
  /**
   * Channel serial number
   * @example 1
   */
  serialNum?: number;
}[];

/** The function you are executing. Note - either (irCodeId & function) OR (ircode) are required. irCodeId & function are for preset function, irCode for custom function */
export interface Function {
  /**
   * The PID of the device you want to control
   * @example "000000000000000000000000c3050100"
   */
  pid: string;
  /**
   * The IR code ID of a preset function
   * @example "5681"
   */
  irCodeId?: string;
  /**
   * The preset function (object or string)
   * @example {"function":"ok"}
   */
  function?: object;
  /**
   * The learned custom IR code
   * @example "26009...00029"
   */
  irCode?: string;
  /**
   * The ocf device type of the child device
   * @example "oic.d.airconditioner"
   */
  ocfDeviceType?: string;
  /** The initial state of an AC device */
  initialAcState?: {
    /**
     * Power status of the device
     * @example "ON"
     */
    powerState?: string;
    /**
     * Air Conditioner mode
     * @example "heat"
     */
    mode?: string;
    /**
     * Fan speed
     * @example "auto"
     */
    windSpeed?: string;
    /**
     * The temperature the device should be at
     * @example 19
     */
    fixedTargetTemperature?: number;
  };
}

/** The Function you want to update. */
export interface DevicePatch {
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * Device capabilities associated with IR functions or function key/value pairs
   * These should be comprised of capabilities that will be added to existing capabilities.
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: object;
    [key: string]: any;
  };
  /**
   * Key value pairs stored for the device.
   * @example {"button.color":"blue","button.icon":"button.jpg"}
   */
  metadata?: Record<string, any>;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

/** Data pertaining to the device that will be put in a learning state */
export interface IrLearningRequest {
  /**
   * The PID of the device you want to put in a learning state
   * @example "000000000000000000000000c3050100"
   */
  pid: string;
}

/** The desired state of an Air Conditioner */
export interface AcState {
  /**
   * The maximum temperature setting
   * @example 30
   */
  maxTemp?: number;
  /**
   * The minimum temperature setting
   * @example 16
   */
  minTemp?: number;
  /**
   * The temperature unit
   * @example "C"
   */
  unit?: string;
  /**
   * The temperature increment value
   * @example 1
   */
  step?: number;
  /**
   * The temperature value
   * @example 19
   */
  coolingSetpoint?: number;
  /**
   * The power state of the AC device
   * @example "ON"
   */
  powerState?: 'ON' | 'OFF';
  /**
   * The mode of the AC device
   * @example "AUTO"
   */
  mode?: string;
  /**
   * The fan speed of the AC device
   * @example "AUTO"
   */
  windspeed?: string;
}

export type IrCodes = {
  /** List of IR Codes */
  irCode?: {
    /**
     * The IR Code value
     * @example "26009...00029"
     */
    code?: string;
    /**
     * The description of the IR Code function
     * @example "打开空调，制冷，25度，风速2"
     */
    desc?: string;
    /**
     * The function name
     * @example "powerState"
     */
    function?: string;
    /**
     * Appears to have the same info as 'desc'
     * @example "打开空调"
     */
    name?: string;
  }[];
  /**
   * IR Code Id
   * @example "5789"
   */
  irCodeId?: string;
  /**
   * TODO
   * @example "000000000000000000000000c2050100"
   */
  pid?: string;
  /**
   * TODO
   * @example "1535607964"
   */
  timestamp?: string;
  /** The various possible values for an AC device only. Appears to be an empty object for non-AC devices */
  acState?: {
    /**
     * Max temperature for AC in Celsius
     * @example 30
     */
    maxTemp?: number;
    /**
     * Minimum temperature for AC in Celsius
     * @example 16
     */
    minTemp?: number;
    /**
     * Power states available
     * @example ["ON","OFF"]
     */
    powerState?: string[];
    /**
     * The list of modes of the AC
     * @example ["AUTO","COLD","DEHUMI","VENT","HEAT"]
     */
    model?: string[];
    /**
     * The list of fan speeds of the AC
     * @example ["AUTO","LOW","MEDIUM","HIGH"]
     */
    windspeed?: string[];
  };
  /**
   * A list of all functions for the IR code. Appears to only show up on TVs
   * @example ["power","mute","tv_av","menu","back","exit","0","1","2","3","4","5","6","7","8","9","channel_up","channel_down","volume_up","volume_down","up","down","right","left","ok"]
   */
  allFunction?: string[];
}[];

/** List of IR Codes with names (Just for AC) */
export type MatchIRCode = {
  /**
   * Name
   * @example "科龙_5693"
   */
  name?: string;
  /**
   * IR Id
   * @example 5693
   */
  irid?: number;
}[];

/** List of Provider Brands */
export type ProviderBrands = {
  /**
   * Provider brand name
   * @example "四川电信4K机顶盒 (Google Translated as Sichuan Telecom 4K set top box)"
   */
  brand?: string;
  /**
   * Provider brand id
   * @example "1223"
   */
  brandId?: string;
}[];

/** Providers under a location */
export type Providers = {
  /**
   * Provider's id
   * @example 38
   */
  providerId?: number;
  /**
   * Name of the provider
   * @example "杭州华数"
   */
  providerName?: string;
  /**
   * English name of the provider (again, always appears to be blank)
   * @example ""
   */
  providerNameEn?: string;
  /**
   * Location id associated with the provider
   * @example 0
   */
  locateId?: number;
  /**
   * Initials of the provider
   * @example "H"
   */
  initials?: string;
  /**
   * Whether the provider has a brand associated (0 = false, 1 = true)
   * @example 1
   */
  hasBrand?: number;
}[];

/** Sub areas under a location */
export type SubAreaInfo = {
  /**
   * Location id
   * @example 92
   */
  locateId?: number;
  /**
   * The level of the location (Country = 1, Province = 2, City = 3)
   * @example 3
   */
  levelId?: number;
  /**
   * Name of the location
   * @example "丽水市"
   */
  name?: string;
  /**
   * Indication of whether or not there are any sub areas under this location (0 = false, 1 = true)
   * @example 1
   */
  isLeaf?: number;
  /**
   * Status of the location
   * @example "正常"
   */
  status?: string;
  /**
   * Initials of the location
   * @example "N"
   */
  initials?: string;
}[];

/**
 * All of the OTA Versions
 * @example {"3":{"versions":[{"version":"20029","url":"google.com","date":"2017-02-28","changelog":{"en":"update","cn":"更新内"}}]}}
 */
export type OTAVersions = Record<
  string,
  {
    versions?: OTAVersion[];
  }
>;

/** OTA Version */
export interface OTAVersion {
  /**
   * OTA Version
   * @example "41024"
   */
  version?: string;
  /**
   * Url to download firmware update
   * @example "http://fwversions.ibroadlink.com/firmware/download/30014/41027.bin"
   */
  url?: string;
  /**
   * date of firmware version
   * @example "2018-03-09T00:00:00Z"
   */
  date?: string;
  /** @example {"en":"updating"} */
  changelog?: Record<string, string>;
}

/** Ota Version for Device */
export interface DeviceOTAVersion {
  /**
   * Version of the device
   * @example 50
   */
  version?: string;
  serverversion?: {
    /**
     * URL of the version
     * @example "https://broadlinkversion.com/version"
     */
    url?: string;
    /**
     * Device Type number
     * @example 10039
     */
    devtype?: string;
    /**
     * Version of the server
     * @example 55
     */
    version?: string;
  };
}

export interface OcfRouteRequest {
  /** Device ID of the sender */
  senderDi: string;
  /** Device ID of the receiver */
  receiverDi: string;
  /**
   * A resource identifier of the sender device. Max length of the token is 8 bytes. String presentation in hexadecimal will be 16 characters.
   * @maxLength 16
   * @pattern [0-9a-fA-F]+
   */
  coapToken: string;
  /**
   * Observe option
   * @default "NOTHING"
   */
  observeOption: 'SUBSCRIBE' | 'UNSUBSCRIBE' | 'NOTHING';
  /** Request method */
  method: 'GET' | 'PUT' | 'POST';
  /** Path to the resource */
  path: string;
  /** OCF interface */
  query?: string;
  /** The OCF message body in JSON */
  message?: Record<string, object>;
}

export interface OcfRouteResponse {
  /** Device ID of the sender */
  senderDi: string;
  /** Device ID of the receiver */
  receiverDi: string;
  /**
   * A resource identifier of the sender device. Max length of the token is 8 bytes. String presentation in hexadecimal will be 16 characters.
   * @maxLength 16
   * @pattern [0-9a-fA-F]+
   */
  coapToken: string;
  /** Observe option */
  observeOption?: 'SUBSCRIBE' | 'UNSUBSCRIBE';
  /** The OCF message body in JSON */
  message: object;
  /** Response code from resource server */
  responseCode: string;
  /** Path to the resource */
  path: string;
}

/** something */
export interface DeviceGroupLinks {
  /** @example " /st/devicegroups/6ada44d8-966a-4b7c-9f1c-c028bcde45ee/capability/switch/0" */
  href?: string;
  /** @example "oic.r.switch.binary" */
  rt?: string;
}

/** A group */
export interface DeviceGroupCreateRequest {
  /** Name of the group created */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group */
    components: {
      /** @example "main" */
      id?: string;
    }[];
  }[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
  /**
   * Indicates whether this group is a summary group. Summary groups do not emit events and do not calculate group state, but may be issued commands.
   * @default false
   */
  summaryGroup?: boolean;
}

/** A group */
export interface DeviceGroupUpdateRequest {
  /** Name of the group */
  groupName: string;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group */
    components: {
      /** @example "main" */
      id?: string;
    }[];
  }[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
}

/** A group */
export interface DeviceGroupResponse {
  /**
   * Name of the group created
   * @example "helloWorldGroup"
   */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType: DeviceGroupType;
  /**
   * Location where this group is
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  locationId?: string;
  /** restriction tier of the device group */
  restrictionTier?: number;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
     */
    deviceId?: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
  /**
   * a GUID that identifies a group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  deviceGroupId: string;
  /** Lowest common denominator capability of all the devices in the group */
  deviceGroupCapabilities: DeviceGroupCapability[];
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  roomId?: string;
  /** Indicates whether this group is a summary group. Summary groups do not emit events and do not calculate group state, but may be issued commands. */
  summaryGroup: boolean;
}

/**
 * Room containing this device group
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type RoomId = string;

export interface OcfDeviceGroupsCommandRequest {
  /**
   * Path to the resource
   * @example " /st/devicegroups/6ada44d8-966a-4b7c-9f1c-c028bcde45ee/capability/switch/0"
   */
  path: string;
  /**
   * The OCF message body in JSON
   * @example {"payload":{"value":true}}
   */
  message?: object;
  /**
   * Request menthod
   * @example "POST"
   */
  method: 'GET' | 'POST';
}

/** @example {"rt":["oic.r.switch.binary"],"id":"0","if":["oic.if.baseline","oic.if.r"],"value":true,"dimmingSetting":23} */
export interface OcfDeviceGroupsCommandResponse {
  rt?: string[];
  id?: string;
  if?: string[];
  value?: boolean;
  dimmingSetting?: number;
}

/** A paginated array of device groups */
export interface PagedDeviceGroups {
  items?: DeviceGroupResponse[];
  _links?: Links;
}

export type DeviceGroupDeleteResponse = Record<string, any>;

export interface PaginationRequest {
  /**
   * Paging parameter for going to previous page. Before epoch time (millisecond).
   * Return the nearest records (the immediate previous page) with event time before the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  before?: number;
  /**
   * Paging parameter for going to previous page. Before Hash (long). This needs to be specified when 'before' is specified.
   * Please put in associated hash value of the record specified by the 'before' parameter.
   * @format int64
   */
  beforeHash?: number;
  /**
   * Paging parameter for going to next page. After epoch time (millisecond).
   * Return the nearest records (the immediate next page) with event time after the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  after?: number;
  /**
   * Paging parameter for going to next page. After Hash (long). this needs to be specified when 'after' is specified.
   * Please put in associated hash value of the record specified by the 'after' parameter.
   * @format int64
   */
  afterHash?: number;
  /**
   * Number of records to return.
   * @default 20
   */
  limit?: number;
}

export type ActivitiesRequest = PaginationRequest & {
  /** location IDs */
  location: string[];
  /** device IDs */
  device?: string[];
  /** Parameter to filter by activities type, defaults to include everything. */
  include?: ('device' | 'execution' | 'mode')[];
  /** This controls ordering of results. When not specified or 'oldestFirst=false', server will list newest history first, aka descending order.  */
  oldestFirst?: boolean;
};

export type NotificationRequest = PaginationRequest & {
  /** location IDs */
  location?: string[];
  /** device IDs */
  device?: string[];
  /** Parameter to filter by activities type, defaults to include everything. */
  include?: ('device' | 'others')[];
};

export interface GdprRequest {
  /**
   * GDPR Request ID. Will be echo back in response.
   * @example "request-uuid-1"
   */
  requestId: string;
  /**
   * Service ID for GDPR.
   * @example "gdpr"
   */
  serviceId: string;
  /** The request type. "portability" or "delete". Default is "portability" if not specified */
  event?: 'portability' | 'delete';
  /**
   * Used in portability request. URL to POST response to when portability request is completed. The POST body of the response is defined in GdprResponse.
   * @example "http://gdpr.st.internal/gdpr/response"
   */
  responseUrl?: string;
  /** S3 bucket to upload the file to. */
  bucketname?: string;
  /**
   * Used in portability request. S3 path to upload the file to.
   * @example "/gdpr/data/saguid-1/"
   */
  filePath?: string;
  /**
   * Used in portability request. File name to be stored in S3.
   * @example "historian.csv"
   */
  fileName?: string;
  /** Request channel. Different request channel returns different fields for portability requests */
  channel?: 'CCPA' | 'LGPD' | 'GDPR' | 'SDAP' | 'PDPA' | 'KVKK' | 'CNPP' | 'Others';
  /** portability event allows A or P. delete event allows E, APP or INTERNAL. A - Right to Access; E - Delete request. P - Right to portability. APP - Delete request from ST app. INTERNAL - Delete request from Samsung Account. */
  event_type?: 'A' | 'P' | 'E' | 'APP' | 'INTERNAL';
}

export interface GdprResponse {
  /**
   * The request ID originally sent by GDPR server in the request.
   * @example "request-uuid-1"
   */
  gdpr_id: string;
  /**
   * The service ID of historian.
   * @example "historian"
   */
  service_id: string;
  /** The original request type. "portability" or "delete". */
  event: 'portability' | 'delete';
  /** Request processing status. "accepted", "ok" or "error". */
  event_status: 'accepted' | 'ok' | 'error';
  /** Error message if event_status is "error" */
  error?: string;
  /** Set if user has no PII data. Apply to "portability" response only. */
  noData?: boolean;
}

export interface ActivityHistory {
  /**
   * Deprecated. Translated human readable string (localized)
   * @example "battery of Button is: 89%"
   */
  text?: string;
  /**
   * this event history timestamp in epoch (millisecond). Note: type is a long
   * @format int64
   * @example 1511913638679
   */
  epoch: number;
  /**
   * hash value of this record. Note: type is a long
   * @format int64
   * @example 4080908847
   */
  hash: number;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp: string;
  /** The type of activity. "execution", "device", "locationMode", "nativeApp". */
  activityType: 'EXECUTION' | 'DEVICE' | 'LOCATION_MODE' | 'NATIVE';
  deviceActivity?: DeviceActivity;
  executionActivity?: ExecutionActivity;
  modeActivity?: ModeActivity;
  nativeActivity?: NativeActivity;
}

export interface ThanosEvent {
  /**
   * Event ID (smartthings.event.Event.id)
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6bfb0047-9985-4102-8ecc-ada38ce9a3c5"
   */
  eventId: string;
  /**
   * timestamp in UTC time (smartthings.event.Event.serverTime)
   * @format date-time
   * @example "2020-07-13T22:14:52.714Z"
   */
  timeStamp?: string;
  /**
   * internal field for event ordering
   * @format int64
   * @example 4080908847
   */
  hash: number;
  /**
   * Location ID (gid) (smartthings.event.Event.locationId)
   * @example "location-uuid-1"
   */
  locationId: string;
  /** smartthings.event.Event.name */
  name?: string;
  /** smartthings.event.Event.stateChange */
  isStateChanged?: boolean;
  /** smartthings.event.Event.displayed */
  isDisplayed?: boolean;
  /**
   * smartthings.event.Event.providerTime
   * @format date-time
   * @example "2020-07-13T22:14:52.714Z"
   */
  providerTimeStamp?: string;
  /**
   * smartthings.event.Event.providerEventId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "3ce9c056-9fa8-4534-989f-13f5796356b1"
   */
  providerEventId?: string;
  /** smartthings.event.Event.rawMessage */
  rawMessage?: string;
  /** smartthings.event.Event.schemaUri */
  schemaUri?: string;
  /**
   * smartthings.event.LegacyEvent.deviceId or smartthings.event.DeviceEvent.deviceId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "dbfb7eb0-1b7f-4d83-b90b-15dccaeb0ac3"
   */
  deviceId: string;
  /**
   * Device nick name (only present in device activity event)
   * @example "TV"
   */
  deviceName?: string;
  /** Device type, e.g. device, child, resource_client, mobile, samsungconnect, legacy_da_device, cellrouter, smartthings_device, smartthing_hub, smartwatch, smartphone (only present in device activity event) */
  deviceType?: string;
  /**
   * Location name (only present in device activity event)
   * @example "Home"
   */
  locationName?: string;
  /** Room Id (only present in device activity event) */
  roomId?: string;
  /** Room Name (only present in device activity event) */
  roomName?: string;
  /**
   * smartthings.event.DeviceEvent.component or smartthings.event.LegacyEvent.component
   * @example "main"
   */
  component?: string;
  /**
   * smartthings.event.DeviceEvent.capability or smartthings.event.LegacyEvent.capability
   * @example "battery"
   */
  capability?: string;
  /**
   * smartthings.event.DeviceEvent.attribute or smartthings.event.LegacyEvent.attribute
   * @example "battery"
   */
  attributeName?: string;
  /**
   * smartthings.event.DeviceEvent.value or smartthings.event.LegacyEvent.value
   * @example 89
   */
  attributeValue?: string;
  /** smartthings.event.DeviceEvent.valueJson */
  attributeValueJson?: string;
  /** attribute unit (smartthings.event.DeviceEvent.unit) */
  unit?: string;
  /** default English text for the event (smartthings.event.DeviceEvent.linkText or smartthings.event.LegacyEvent.linkText) */
  text?: string;
  /** smartthings.event.LegacyEvent.source */
  source?: number;
  /** smartthings.event.legacyEvent.type */
  type?: string;
  /** smartthings.event.legacyEvent.data */
  data?: string;
  /** smartthings.event.LegacyEvent.commandId */
  commandId?: number;
  /** smartthings.event.LegacyEvent.hubId */
  hubId?: string;
  /** smartthings.event.LegacyEvent.groupId */
  groupId?: string;
  /** smartthings.event.LegacyEvent.parentDeviceId */
  parentDeviceId?: string;
  /** smartthings.event.LegacyEvent.deviceTypeId */
  deviceTypeId?: string;
  /** smartthings.event.LegacyEvent.installedDeviceId */
  installedDeviceId?: string;
  /** smartthings.event.LegacyEvent.smartAppId */
  smartAppId?: string;
  /** smartthings.event.LegacyEvent.smartAppVersionId */
  smartAppVersionId?: string;
  /** smartthings.event.LegacyEvent.installedSmartAppId */
  installedSmartAppId?: string;
  /** smartthings.event.LegacyEvent.installedSmartAppParentId */
  installedSmartAppParentId?: string;
  /** smartthings.event.LegacyEvent.userId */
  userId?: string;
  /** smartthings.event.LegacyEvent.descriptionText */
  descriptionText?: string;
  /** smartthings.event.LegacyEvent.handlerName */
  handlerName?: string;
  /** smartthings.event.LegacyEvent.triggeredBy */
  triggeredBy?: string;
  /** smartthings.event.LegacyEvent.translatable */
  isTranslatable?: boolean;
  /** smartthings.event.LegacyEvent.messageArgs */
  messageArgs?: string;
  /** smartthings.event.LegacyEvent.triggerEventId */
  triggerEventId?: string;
  /** smartthings.event.LegacyEvent.virtualHub */
  isVirtualHub?: boolean;
  /** smartthings.event.LegacyEvent.accountId */
  accountId?: string;
  /** smartthings.event.LegacyEvent.ephemeral */
  isEphemeral?: boolean;
}

export interface DeviceActivity {
  /**
   * Device ID (did)
   * @example "device-uuid-1"
   */
  deviceId: string;
  /**
   * Device nick name
   * @example "TV"
   */
  deviceName?: string;
  /** Device type, e.g. device, child, resource_client, mobile, samsungconnect, legacy_da_device, cellrouter, smartthings_device, smartthing_hub, smartwatch, smartphone */
  deviceType?: string;
  /**
   * Location ID (gid)
   * @example "location-uuid-1"
   */
  locationId: string;
  /**
   * Location name
   * @example "Home"
   */
  locationName?: string;
  /** Room Id */
  roomId?: string;
  /** Room Name */
  roomName?: string;
  /** Event Name, closely related to attribute name. DEPRECATED, please use capability instead. */
  eventText?: string;
  /**
   * device component ID. Not nullable.
   * @example "main"
   */
  component: string;
  /**
   * device component label. Nullable.
   * @example "left button"
   */
  componentLabel?: string;
  /**
   * capability name
   * @example "battery"
   */
  capability: string;
  /**
   * attribute name
   * @example "battery"
   */
  attributeName?: string;
  /**
   * attribute value
   * @example 89
   */
  attributeValue?: string;
  /** attribute unit */
  unit?: string;
  /**
   * translated attribute name based on 'Accept-Language' requested in header
   * @example "스위치"
   */
  translatedAttributeName?: string;
  /**
   * translated attribute value based on 'Accept-Language' requested in header
   * @example "켜짐"
   */
  translatedAttributeValue?: string;
}

export interface ExecutionActivity {
  /**
   * Location ID (gid)
   * @example "location-uuid-1"
   */
  locationId: string;
  /**
   * Location name
   * @example "Home"
   */
  locationName?: string;
  /**
   * Execution ID
   * @example "execution-uuid-1"
   */
  executionId: string;
  ruleType: 'BEHAVIOR' | 'SCENE' | 'WEBHOOK' | 'LAMBDA' | 'SMARTAPP' | 'OCF_RULE';
  /**
   * ID or the rule. Depending on rule type, the ID could you syndicate scene ID, alliance behavior ID, bookie installedAppId, or ocf rule ID
   * @example "behavior-uuid-1"
   */
  ruleId: string;
  /** Display name of the rule. */
  displayName?: string;
  /** Execution success or not */
  success?: boolean;
  /**
   * *DEPRECATED* - URL of the actions associated with the execution
   * @example "https://historian.samsung.com/v2/activities/location-uuid-1/executions/exec-uuid-1/actions"
   */
  actionsLink?: string;
}

export interface ExecutionActionsResponse {
  actions?: ExecutionAction[];
  _links?: Links;
}

export interface ExecutionAction {
  /** Action type. */
  actionType: 'DEVICE_COMMAND';
  /**
   * This is Execution action ID. Device command action can be multiple per one Execution Action ID.
   * @example "uuid"
   */
  id: string;
  /**
   * this event history timestamp in epoch (millisecond). Note: type is a long
   * @format int64
   * @example 1511913638679
   */
  epoch: number;
  /**
   * hash value of this record. Note: type is a long
   * @format int64
   * @example 4080908847
   */
  hash: number;
  deviceAction?: DeviceAction;
}

export interface DeviceAction {
  /**
   * Device ID (did)
   * @example "device-uuid-1"
   */
  deviceId: string;
  /**
   * Device nick name
   * @example "TV"
   */
  deviceName?: string;
  /**
   * Capability
   * @example "Switch"
   */
  capability: string;
  /**
   * Device command
   * @example true
   */
  command: string;
  /** Device command argument */
  arguments?: string[];
  /**
   * The text to display to user when device command is failure or offline
   * @example "Device disconnected."
   */
  text?: string;
  /**
   * Deprecated - Result code of the action
   * @example 200
   */
  resultCode?: number;
  /** Result of action */
  result: 'Success' | 'Failure' | 'Offline';
}

export interface ModeActivity {
  /**
   * Location ID (gid)
   * @example "location-uuid-1"
   */
  locationId: string;
  /**
   * Location name
   * @example "Home"
   */
  locationName?: string;
  /**
   * Mode ID
   * @example "location-uuid-1"
   */
  modeId: string;
  /**
   * Mode name (eg. Away, Home, Night)
   * @example "Away"
   */
  modeName?: string;
}

export interface NativeActivity {
  /**
   * event ID (eid)
   * @example "b48e24ae-c144-11ec-9d64-0242ac120002"
   */
  eventId: string;
  /**
   * Location ID (gid)
   * @example "abcde07a-1234-5ab6-9d76-e07a16fbfabd"
   */
  locationId: string;
  /**
   * Location Name
   * @example "Living Room"
   */
  locationName: string;
  /**
   * Source Application Name
   * @example "Calendar"
   */
  appName: string;
  /**
   * Optional. Device Status
   * @example "connected"
   */
  deviceStatus?: string;
  /**
   * Mobile Device Name
   * @example "Galaxy S21"
   */
  mobileDeviceName: string;
  /**
   * translated source app name based on 'Accept-Language' requested in header
   * @example "캘린더"
   */
  translatedAppName: string;
  /**
   * translated app name and device status based on 'Accept-Language' requested in header
   * @example "캘린더 has been activated."
   */
  translatedText: string;
}

export interface ActivityHistoryPage {
  items?: ActivityHistory[];
  _links?: Links;
}

export interface ThanosHistoryPage {
  items?: ThanosEvent[];
  _links?: Links;
}

export interface Notification {
  /**
   * unique Id that identifies the notification message.
   * @example "2d542d1d-ede9-4c9a-94c8-9ecd80e16322"
   */
  id: string;
  /**
   * Device ID (did). Optional. The IoT device Id associated with the notification.
   * @example "device-uuid-1"
   */
  deviceId?: string;
  /**
   * The IoT device nick name as defined by the user. Optional.
   * @example "Nick's Air conditioner"
   */
  deviceName?: string;
  /**
   * Device Type, e.g. "samsungconnect", "oic.d.camera", "x.com.st.d.sensor.multifunction"
   * @example "oic.d.airconditioner"
   */
  deviceType?: string;
  /**
   * Location ID (gid)
   * @example "location-uuid-1"
   */
  locationId?: string;
  /**
   * Location name
   * @example "Home"
   */
  locationName?: string;
  /**
   * notification type, 1 to 9. <br/> 1 = alert, <br/> 2 = system level <br/> 3 = event logging <br/> 4 = automation notifications <br/> 5 = warning <br/> 6 = low importance <br/> 7 = hidden api call <br/> 8 = force client refresh to remove warning (not visible to customer) <br/> 9 = suggested action
   * @example "1"
   */
  type: string;
  /**
   * Notification message code. Optional. This might not be there if the notification contains a custom message.
   * @example "VHM_0001"
   */
  code?: string;
  /** Notification message title. Optional. Note: this is not localized. */
  title?: string;
  /**
   * Localized message text associated with code or custom message (not localized).
   * @example "Auto cleaning is completed. Start returning to the charge."
   */
  message?: string;
  /**
   * deep link of push notification, <br/> format: {targetResource}:{targetResourceId} <br/> targetResource - installedappid, deviceid and locationid
   * @example "deviceid:b968e0f3-c542-4256-acfa-e7690dac7ef9"
   */
  deepLink?: string;
  /**
   * The raw push notification payload
   * @example "{"x.org.iotivity.ns.messageid":0,"x.org.iotivity.ns.providerid":"0f5bdefb-bf32-4673-924f-f1650be140b8","x.org.iotivity.ns.type":1,"x.org.iotivity.ns.source":"/oic/acl/group/0f5bdefb-bf32-4673-924f-f1650be140b8","x.org.iotivity.ns.title":"the notification title","x.com.samsung.code":"MO_PHONE_V_0001","x.com.samsung.deeplink":"locationid:0f5bdefb-bf32-4673-924f-f1650be140b8","x.com.samsung.params":[{"n":"%1$s","value":"John"},{"n":"%2$s","value":"Office"}],"x.com.samsung.data":{"et":"external","rep":{"gid":"0f5bdefb-bf32-4673-924f-f1650be140b8"},"dname":null},"x.org.iotivity.ns.contenttext":"John invited you to Office."}"
   */
  rawPayload: string;
  /**
   * When the message was received by the system. This will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp: string;
  /**
   * This event history timestamp in epoch (millisecond). Note: type is a long
   * @format int64
   * @example 1511913638679
   */
  epoch: number;
  /**
   * Hash value of this record. Note: type is a long
   * @format int64
   * @example 4080908847
   */
  hash: number;
  /**
   * Installed App Id associated with the SMS message
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0550c6a2-cf39-49fd-a011-a800c50f3ecf"
   */
  installedAppId?: string;
  /**
   * Template used to generate SMS history, for support use.
   * @example "{"recipients":["sms:+123456789"],"message":{"fallbackLocale":"en","templates":[{"locale":"en","variables":{},"template":"The front door is open "}],"defaultVariables":{}}}"
   */
  smsMessageTemplate?: string;
}

export interface NotificationPage {
  items?: Notification[];
  _links?: Links;
}

/**
 * A typed model which provides information around ownership of a specific domain.
 * @example {"ownerType":"USER","ownerId":"72fd3b54-d243-4bf7-a845-92eb7956b982"}
 */
export interface Owner {
  /**
   * The type of owner that owns this entity. "Account" refers specifically to a coterie account ID.
   * @default "USER"
   */
  ownerType: 'USER' | 'SYSTEM' | 'IMPLICIT' | 'ACCOUNT';
  /** A global identifier for owner. */
  ownerId: string;
}

/**
 * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
 * useful for filtering.
 *
 * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
 * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
 * * Case sensitive
 * * Maximum number of tags per resource: 25
 * * Reserved prefix — `st:`
 * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
 * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
 * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
 * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
 * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
 * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
 */
export type Tags = Record<string, string>;

/** A request object used to update a resource's tags. */
export interface UpdateTagsRequest {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A response object containing the updated tags. */
export interface UpdateTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A request object used to update a resource's tags. */
export interface PatchTagsRequest {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  upserts?: Tags;
  removals?: string[];
}

/** A response object containing the updated tags. */
export interface PatchTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A response object containing the resource's tags. */
export interface GetTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/**
 * * USER_PAUSE - Denotes installed app is paused by the user and user action is required to unpause it.
 * * REVISIT - Denotes installed app is still running and user action may be required to reconcile a configuration.
 * * RECONFIGURE - Denotes installed app is no longer running and user action is required to resolve a configuration issue.
 */
export enum NoticeCode {
  USER_PAUSE = 'USER_PAUSE',
  REVISIT = 'REVISIT',
  RECONFIGURE = 'RECONFIGURE',
}

export interface Notice {
  /**
   * * USER_PAUSE - Denotes installed app is paused by the user and user action is required to unpause it.
   * * REVISIT - Denotes installed app is still running and user action may be required to reconcile a configuration.
   * * RECONFIGURE - Denotes installed app is no longer running and user action is required to resolve a configuration issue.
   */
  code?: NoticeCode;
  /** The url of the badge icon for the notice card */
  badgeUrl?: string;
  /** The localized message to be displayed */
  message?: string;
  /** The action(s) a user can take to resolve this notice */
  actions?: NoticeAction[];
}

/**
 * An action the user can take to resolve a notice
 * @default "none"
 */
export enum NoticeAction {
  DISMISS = 'DISMISS',
  EDIT = 'EDIT',
  NONE = 'NONE',
}

/** @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","permissions":["r:devices:416747c2-ac57-4f49-8d01-aff1094dee61","r:devices:656382bd-b125-4ade-a429-193fb3e7900d","w:devices:656382bd-b125-4ade-a429-193fb3e7900d","l:devices"]} */
export interface InstallConfigurationPermissionResponse {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /** A unique set of the OAuth scope required for a specific install configuration. */
  permissions?: string[];
}

/** @example {"displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","installedAppType":"WEBHOOK_SMART_APP","configurationStatus":"STAGED","config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"paint","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface CreateInstalledAppRequest {
  /**
   * A user defined name for the installed app.
   * @maxLength 100
   */
  displayName?: string;
  /** The ID of the app. */
  appId: string;
  /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. */
  referenceId?: string;
  /**
   * The ID of the location.  A locationId may or may not be required based on the type of install.
   * @format uuid
   */
  locationId: string;
  /** Denotes the type of installed app. */
  installedAppType: InstalledAppType;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus: InstallConfigurationStatus;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

/** @example {"displayName":"Color App"} */
export interface UpdateInstalledAppRequest {
  /**
   * A user defined name for the installed app.
   * @maxLength 100
   */
  displayName?: string;
}

/** @example {"removals":["temperature_controls","some_other_developer_defined_key"],"upserts":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"paint","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface PatchInstalledAppRequest {
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  upserts?: ConfigMap;
  /** An array of config name's to delete. */
  removals?: string[];
}

/**
 * Initialize request.
 * @example {"appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a"}
 */
export interface InitializeRequest {
  /** The ID of the app. */
  appId: string;
  /**
   * A user defined name for the installed app. Only used for a new installed app.
   * @maxLength 100
   */
  displayName?: string;
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
}

/** Initialize response. */
export interface InitializeResponse {
  /** A composite model to provide both the details of an InstalledApp and the current configuration. */
  installedAppComposite?: InstalledAppComposite;
}

export interface CancelRequest {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type CancelResponse = object;

/** @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","installedAppType":"WEBHOOK_SMART_APP","installedAppStatus":"PENDING","displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"notices":["USER_PAUSE","RECONFIGURE"],"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","allowed":["w:installedapps","d:installedapps"]} */
export interface InstalledApp {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId: string;
  /** Denotes the type of installed app. */
  installedAppType: InstalledAppType;
  /**
   * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
   * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
   * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
   * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
   * 'AUTHORIZED' Installed App will not execute.
   */
  installedAppStatus: InstalledAppStatus;
  /**
   * A user defined name for the installed app. May be null.
   * @maxLength 100
   */
  displayName?: string;
  /** The ID of the app. */
  appId: string;
  /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. May be null. */
  referenceId?: string;
  /**
   * The ID of the location to which the installed app may belong.
   * @format uuid
   */
  locationId?: string;
  /** A typed model which provides information around ownership of a specific domain. */
  owner: Owner;
  notices: Notice[];
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
  /**
   * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
   * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
   */
  ui?: {
    /** @format ^[a-zA-Z._]{1,99}$ */
    pluginId?: string;
    /** @format uri */
    pluginUri?: string;
    dashboardCardsEnabled: boolean;
    preInstallDashboardCardsEnabled: boolean;
  };
  /**
   * A default icon image for the app.
   * @example {"url":"https://smart-home-monitor.com/image"}
   */
  iconImage?: {
    /**
     * A default icon image url for an app. https url required.
     * @format uri
     */
    url?: string;
  };
  /**
   * An App maybe associated to many classifications.  A classification drives how the integration is presented
   * to the user in the SmartThings mobile clients.  These classifications include:
   * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
   * * SERVICE - Denotes an integration that is classified as a "Service".
   * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
   * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
   * * HIDDEN - Denotes an integration that should not display in mobile clients
   */
  classifications: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
  /** Denotes the principal type to be used with the app.  Default is LOCATION. */
  principalType: 'LOCATION' | 'USER_LEVEL';
  /** Restriction tier of the install, if any. */
  restrictionTier?: number;
  /**
   * Inform the installation systems that the associated app can only be installed once within a user's account.
   * @default false
   */
  singleInstance: boolean;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   * <ul>
   * <li>`"w:installedapps"` -- the user has update permissions on the installed app</li>
   * <li>`"d:installedapps"` -- the user has delete permissions on the installed app</li>
   * </ul>
   */
  allowed?: string[];
}

/**
 * An configuration instance of an Installed App.
 * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","configurationStatus":"DONE","createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z"}
 */
export interface InstallConfiguration {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus?: InstallConfigurationStatus;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/**
 * Encompasses both a configuration value, and any required permissions that maybe needed.
 * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","configurationStatus":"AUTHORIZED","createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"main","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}}]}}
 */
export interface InstallConfigurationDetail {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus?: InstallConfigurationStatus;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/** @example {"config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface UpdateInstallConfigurationRequest {
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config: ConfigMap;
}

/**
 * An empty object request.
 * @example {}
 */
export type InitializeUpdateFlowRequest = object;

/** Initialize update flow response. */
export interface InitializeUpdateFlowResponse {
  /** A composite model to provide both the details of an InstalledApp and the current configuration. */
  installedAppComposite?: InstalledAppComposite;
}

/**
 * A simple string configuration.
 * @example {"value":"31192dc9-eb45-4d90-b606-21e9b66d8c2b"}
 */
export interface StringConfig {
  /**
   * A config value
   * @maxLength 2048
   */
  value?: string;
}

/**
 * A device and component configuration with any required permissions.
 * @example {"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}
 */
export interface DeviceConfig {
  /**
   * The ID of the device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * The component ID on the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * Required permissions for the installed app.
 * @example {"permissions":["w:notifications","r:devices:*"]}
 */
export interface PermissionConfig {
  /**
   * @maxItems 25
   * @minItems 1
   */
  permissions?: string[];
}

/**
 * A mode configuration.
 * @example {"modeId":"9206ea57-2e2e-414c-a792-9087117ca3d8"}
 */
export interface ModeConfig {
  /**
   * The ID of the mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
}

/**
 * A scene configuration.
 * @example {"sceneId":"9206ea57-2e2e-414c-a792-9087117ca3d8","permissions":["x:scences:9206ea57-2e2e-414c-a792-9087117ca3d8"]}
 */
export interface SceneConfig {
  /**
   * The ID of the scene.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * A message configuration.
 * @example {"messageGroupKey":"leaks"}
 */
export interface MessageConfig {
  /**
   * The key value of the message group.
   * @format ^[a-zA-Z0-9._]{1,36}$
   */
  messageGroupKey?: string;
}

/**
 * A room configuration.
 * @example {"roomId":"9206ea57-2e2e-414c-a792-9087117ca3d8","permissions":["r:locations:9206ea57-2e2e-414c-a792-9087117ca3d8"]}
 */
export interface RoomConfig {
  /**
   * The ID of the room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * A configuration value type and the correspodning configuration.
 * @example {"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}}
 */
export interface ConfigEntry {
  /** The value type. */
  valueType?: 'STRING' | 'DEVICE' | 'PERMISSION' | 'MODE' | 'SCENE' | 'MESSAGE' | 'ROOM';
  /** The config if valueType is STRING, meaningless otherwise */
  stringConfig?: StringConfig;
  /** The config if valueType is DEVICE, meaningless otherwise */
  deviceConfig?: DeviceConfig;
  /** The config if valueType is PERMISSION, meaningless otherwise */
  permissionConfig?: PermissionConfig;
  /** The config if valueType is MODE, meaningless otherwise */
  modeConfig?: ModeConfig;
  /** The config if valueType is SCENE, meaningless otherwise */
  sceneConfig?: SceneConfig;
  /** The config if valueType is MESSAGE, meaningless otherwise */
  messageConfig?: MessageConfig;
  /** The config if valueType is ROOM, meaningless otherwise */
  roomConfig?: RoomConfig;
}

/** A list of available configuration values. */
export type ConfigEntries = ConfigEntry[];

/**
 * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
 * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
 * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
 * @example {"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}]}
 */
export type ConfigMap = Record<string, ConfigEntries>;

/** Denotes the type of installed app. */
export enum InstalledAppType {
  LAMBDA_SMART_APP = 'LAMBDA_SMART_APP',
  WEBHOOK_SMART_APP = 'WEBHOOK_SMART_APP',
  BEHAVIOR = 'BEHAVIOR',
  API_ONLY = 'API_ONLY',
}

/** @example {"removals":["USER_PAUSE"],"upserts":["RECONFIGURE"]} */
export interface PatchInstalledAppNoticeRequest {
  /** An array of app notices to add. */
  upserts?: NoticeCode[];
  /** An array of app notices to delete. */
  removals?: NoticeCode[];
}

/**
 * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
 * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
 * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
 * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
 * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
 */
export enum InstallConfigurationStatus {
  STAGED = 'STAGED',
  DONE = 'DONE',
  AUTHORIZED = 'AUTHORIZED',
  REVOKED = 'REVOKED',
}

export interface InstalledAppLocator {
  appId?: string;
  installedAppId?: string;
  /** Denotes the type of installed app. */
  installedAppType?: InstalledAppType;
  locationId?: string;
  principalType?: string;
  shardId?: string;
}

/**
 * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
 * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
 * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
 * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
 * 'AUTHORIZED' Installed App will not execute.
 */
export enum InstalledAppStatus {
  PENDING = 'PENDING',
  AUTHORIZED = 'AUTHORIZED',
  REVOKED = 'REVOKED',
  DISABLED = 'DISABLED',
}

/** A composite model to provide both the details of an InstalledApp and the current configuration. */
export interface InstalledAppComposite {
  installedApp?: InstalledApp;
  /** Encompasses both a configuration value, and any required permissions that maybe needed. */
  configurationDetail?: InstallConfigurationDetail;
}

/** Represents a single page of InstalledApps available in a user account. */
export interface PagedInstalledApps {
  items?: InstalledApp[];
  _links?: Links;
}

/** Represents a single page of InstallConfiguration models available for an InstalledApp. */
export interface PagedInstallConfigurations {
  items?: InstallConfiguration[];
  _links?: Links;
}

/** The number of deleted installed apps. */
export interface DeleteInstalledAppResponse {
  /** @format int32 */
  count?: number;
}

/**
 * Used to cleanup installed app configuration for either MODE, SCENE or DEVICE.
 * @example {"modeId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","sceneId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","deviceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","installedAppIds":["8885b9c3-a50d-427e-ad07-d7a2f94421af","34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}
 */
export interface CleanupInstalledAppsRequest {
  /**
   * The ID of the scene to remove from the installed app configurations.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /**
   * The ID of the mode to remove from the installed app configurations.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
  /**
   * The ID of the device to remove from the installed app configurations.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * The ID of the installed apps to cleanup.
   * @format uuid
   * @maxItems 25
   * @minItems 1
   */
  installedAppIds: string[];
}

/**
 * The cleaned up installed apps.
 * @example {"items":[{"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","permissions":["r:devices:416747c2-ac57-4f49-8d01-aff1094dee61","w:devices:656382bd-b125-4ade-a429-193fb3e7900d"]},{"installedAppId":"120b2e9e-d26c-489d-befe-14bcea3e20f4","configurationId":"83a4b2a5-7840-4f75-a1a9-bfda9df241b5","permissions":["r:devices:656382bd-b125-4ade-a429-193fb3e7900d","l:devices"]}]}
 */
export interface CleanupInstalledAppsResponse {
  items?: InstallConfigurationPermissionResponse[];
}

/**
 * The patched up app notices.
 * @example {"notices":["USER_PAUSE","RECONFIGURE"]}
 */
export interface PatchInstalledAppNoticeResponse {
  notices?: NoticeCode[];
}

/** @example {"installedAppStatus":"DISABLED"} */
export interface ChangeInstalledAppStatusRequest {
  /**
   * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
   * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
   * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
   * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
   * 'AUTHORIZED' Installed App will not execute.
   */
  installedAppStatus: InstalledAppStatus;
}

/** @example {"installable":true} */
export interface CanInstallAppResponse {
  /**
   * Will be set to true if the provided App can be installed.
   * @default false
   */
  installable?: boolean;
}

export type App = EndpointApp[];

export interface UserIdApp {
  /** UserId */
  userId?: string;
  endpointApps?: EndpointApp[];
}

export interface Isa {
  /** Possible values - __requiresLogin__ or __loggedIn__. These two values determine what fields are returned in this response. If value is "requiresLogin", only "oAuthLink" is returned in the response. If value is "loggedIn", only isaId, partnerName, appName, devices and icons are returned. */
  pageType?: string;
  /** isaId (Installed App Id) */
  isaId?: string;
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** partner or brand name eg LIFX Inc. */
  partnerName?: string;
  /** Connector name. eg Lifx (Connect) */
  appName?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** location of the installed smart app */
  locationId?: string;
  devices?: DeviceResults[];
  /** generated oAuth link for the user to login to partner server. This will only be returned when the user is not logged in. */
  oAuthLink?: string;
  viperAppLinks?: ViperAppLinks;
  /** connection status between partner and ST platform */
  partnerSTConnection?: 'connected' | 'disconnected';
}

export interface LocationIsa {
  installedSmartApps?: IsaResults[];
}

export interface GetOauthCallback200Resp {
  /** Number of new partner devices added */
  devices_added?: number;
  /** Number of existing partner devices */
  existing_devices?: number;
  /** Number of partner devices which Viper failed to create */
  failed_to_create_devices?: number;
}

export interface GetOauthCallback400Resp {
  /** Error sent by partner */
  error?: string;
  /** Error description sent by partner */
  error_description?: string;
  /** Error URI sent by partner */
  error_uri?: string;
  viper_error?:
    | 'missing_required_query_parameters'
    | 'redirect_expired'
    | 'unexpected_redirect_called'
    | 'oauth_state_verification_failed';
}

export interface GetOauthCallback404Resp {
  viper_error?: 'isa_not_found' | 'endpoint_app_not_found';
}

export interface GetOauthCallback424Resp {
  viper_error?:
    | 'access_token_request_failed'
    | 'discovery_request_failed'
    | 'isa_deleted'
    | 'grant_callback_access_failed';
}

export interface GetOauthCallback500Resp {
  viper_error?: 'server_error';
}

export interface OauthCallbackJson {
  /** isaId */
  isaId?: string;
  /** partner or brand name */
  partnerName?: string;
  /** SmartThings Schema App name */
  appName?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  devices?: DeviceResults[];
}

export interface IsaResults {
  /** isaId installed for the user */
  isaId: string;
  /** SmartThings Schema connector name given by partner eg Lifx (Connect) */
  appName: string;
  /** Parnter name eg Lifx Inc */
  partnerName: string;
  /** url of partner icon */
  icon: string;
  /** url of partner icon in 2x dimensions */
  icon2x: string;
  /** url of partner icon in 3x dimensions */
  icon3x: string;
  /** location of the installed smart app */
  locationId: string;
  /** connection status between partner and ST platform */
  partnerSTConnection: 'connected' | 'disconnected';
  /** endpoint app id of the installed smart app */
  endpointAppId: string;
}

export interface PostEndpointApp {
  /** The name of the SmartThings Schema App */
  appName?: string;
  /** The name of the partner/brand */
  partnerName: string;
  /** oAuth authorization url of the partner */
  oAuthAuthorizationUrl: string;
  /** lambda arn of the partner for US region (default) */
  lambdaArn?: string;
  /** lambda arn of the partner for EU region */
  lambdaArnEU?: string;
  /** lambda arn of the partner for AP region */
  lambdaArnAP?: string;
  /** lambda arn of the partner for CN region */
  lambdaArnCN?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** SmartThings Schema App id for the partner */
  endpointAppId?: string;
  /** Client id for the partner oAuth */
  oAuthClientId: string;
  /** Client secret for the partner oAuth */
  oAuthClientSecret: string;
  /** oAuth token refresh url of the partner */
  oAuthTokenUrl: string;
  /** oAuth scope for the partner. Example "remote_control:all" for Lifx */
  oAuthScope?: string;
  /** user id for the partner */
  userId?: string;
  /** Possible values - "lambda" or "webhook" */
  hostingType: string;
  /** Possible values - "alexa-schema", "st-schema", "google-schema" */
  schemaType?: string;
  /** webhook url for the partner */
  webhookUrl?: string;
  /** Possible values - "", "cst", "wwst", "review" */
  certificationStatus?: string;
  /** Email for the partner */
  userEmail?: string;
  viperAppLinks?: ViperAppLinks;
}

export interface EndpointApp {
  /** The name of the SmartThings Schema App */
  appName?: string;
  /** The name of the partner/brand */
  partnerName?: string;
  /** oAuth authorization url of the partner */
  oAuthAuthorizationUrl?: string;
  /** lambda arn of the partner for US region (default) */
  lambdaArn?: string;
  /** lambda arn of the partner for EU region */
  lambdaArnEU?: string;
  /** lambda arn of the partner for AP region */
  lambdaArnAP?: string;
  /** lambda arn of the partner for CN region */
  lambdaArnCN?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** endpoint app id for the partner */
  endpointAppId?: string;
  /** Client id for the partner oAuth */
  oAuthClientId?: string;
  /** Client secret for the partner oAuth */
  oAuthClientSecret?: string;
  /** oAuth token refresh url of the partner */
  oAuthTokenUrl?: string;
  /** oAuth scope for the partner. Example "remote_control:all" for Lifx */
  oAuthScope?: string;
  /** user id for the partner */
  userId?: string;
  /** Possible values - "lambda" or "webhook" */
  hostingType?: string;
  /** Possible values - "alexa-schema", "st-schema", "google-schema" */
  schemaType?: string;
  /** webhook url for the partner */
  webhookUrl?: string;
  /** Possible values - "", "cst", "wwst", "review" */
  certificationStatus?: string;
  /** Email for the partner */
  userEmail?: string;
  viperAppLinks?: ViperAppLinks;
}

export interface ViperAppLinks {
  /** app deep linking to partners in android */
  android?: string;
  /** app deep linking to partners in ios */
  ios?: string;
  /** whether deep app linking is enabled */
  isLinkingEnabled?: boolean;
}

export interface DeviceResults {
  /** deviceId created by DM */
  deviceId?: string;
  /** initial device name from the partner */
  name?: string;
}

export interface CommandResponse {
  success?: string;
}

export interface CommandBody {
  /** deviceId of the device */
  deviceId?: string;
  /** command name to be processed on the device */
  commandName?: string;
  /** Arguments for specific command types like setLevel, colorControl etc. */
  arguments?: CommandArguments[];
}

/** @example 30 */
export type CommandArguments = string;

export interface PostReceipt {
  /**
   * @format uuid
   * @example "viper_9121f970-f503-11e8-a7de-7319cef9605d"
   */
  endpointAppId?: string;
  /**
   * @format uuid
   * @example "e3fd04cb-c488-4bbd-9759-8deb512656a8"
   */
  stClientId?: string;
  /**
   * @format uuid
   * @example "02c75d945e69e167233cb635b1f9be76d97ebb0b04f4e6839f3acfad320bed64ab86838dc6312585b037259e7797bf2bb44b3caa7a60539c1f402abe3bbe9256424615fddc48e76823b9c230b15669901becb33711e48192aa54a31e4e287ff47295c61c15e2e046103f13aa250bb561136625b69304cc31ef5004d267d0847184426144c60a74329bb47e2f773469ebb6a1e585175370fda78e03413abbcafe51665e8cbe51adf37dd5a3ff376300ebdbe2a359589951a72867bd3fcc574bd77b9ac85127023f931de3c5bcb213efeab3d94a7ee4a3d20acc6f6e575755b10bceb74290f4182c9bddc407d4361710492611568ebcb0b2ffac09e70d0c977d5f"
   */
  stClientSecret?: string;
}

export interface GenerateStOauthBody {
  /** SmartThings Schema App id for the partner */
  endpointAppId?: string;
}

/** @example {"invokeType":"email","fromAddress":"example@smartthings.com","toAddresses":["example@smartthings.com"],"ccAddresses":["example@smartthings.com"],"bccAddresses":["example@smartthings.com"],"isTemplatedEmail":false,"emailparams":{"subject":"Example subject.","body":{"text":"Hello. This is the email body.","html":"<div>Hello. This is the email body.</div>"}}} */
export interface EmailBody {
  /**
   * What operation the handler is performing.
   * @example "email"
   */
  invokeType: 'email' | 'createTemplate' | 'updateTemplate' | 'deleteTemplate' | 'verifyEmail';
  /**
   * Required if invokeType is email - This is the address your email will be 'from'. Any email not from the @smartthings.com domain must be verified with the verifyEmail invokeType.
   * @example "example@smartthings.com"
   */
  fromAddress?: string;
  /**
   * Required if invokeType is email - The email addresses you want to send your email to.
   * @example ["example@smartthings.com"]
   */
  toAddresses?: string[];
  /**
   * Not required - The email addresses you want to cc on your email.
   * @example ["example@smartthings.com"]
   */
  ccAddresses?: string[];
  /**
   * Not required - The email addresses you want to bcc on your email.
   * @example ["example@smartthings.com"]
   */
  bccAddresses?: string[];
  /**
   * Required if invokeType is email - Designates whether you are sending a regular email or a templated email.
   * @example true
   */
  isTemplatedEmail?: boolean;
  /** Required if invokeType is email - Contains parameters specific for regular or templated emails. */
  emailParams?: {
    /**
     * Required if isTemplatedEmail is false - The subject your regular email will have.
     * @example "Hello World"
     */
    subject?: string;
    /** Required if isTemplatedEmail is false - Contains any text or html that your email body will have. */
    body?: {
      /**
       * Required if html is not provided, but both text and html can be provided - The text format of your email body.
       * @example "Hello. This is the email body."
       */
      text?: string;
      /**
       * Required if text is not provided, but both text and html can be provided - The html format of your email body.
       * @example "<div>Hello. This is the email body.</div>"
       */
      html?: string;
    };
    /**
     * Required if isTemplatedEmail is true - Contains info needed to send a templated email.
     * @example "MyEmailTemplate"
     */
    template?: string;
    /**
     * Not Required - Contains any data to replace variables in your template. For more info: https://docs.aws.amazon.com/ses/latest/DeveloperGuide/send-personalized-email-api.html
     * @example {"name":"John Doe"}
     */
    templateData?: object;
  };
  /**
   * Required if invokeType is createTemplate or updateTemplate - Contains data about the template. For more info, checkout the value of 'Template' here: https://docs.aws.amazon.com/ses/latest/DeveloperGuide/send-personalized-email-api.html
   * @example {"TemplateName":"MyEmailTemplate","SubjectPart":"Hello {{name}}","HtmlPart":"<h1>Hello {{name}},</h1><p>Your favorite color is {{color}}.</p>","TextPart":"Dear {{name}},\r\nYour favorite color is {{color}}."}
   */
  templateInfo?: {
    /**
     * Required - The name of the template. When you send the email, you refer to this name.
     * @example "MyEmailTemplate"
     */
    TemplateName?: string;
    /**
     * Required - The subject line of the email. This property may contain replacement tags. These tags use the following format: {{tagname}}. When you send the email, you can specify a value for tagname for each destination.
     * @example "Hello {{name}}"
     */
    SubjectPart?: string;
    /**
     * Required if TextPart is not provided, but both can be provided - The HTML body of the email. This property may contain replacement tags.
     * @example "<h1>Hello {{name}},</h1><p>Your favorite color is {{color}}.</p>"
     */
    HtmlPart?: string;
    /**
     * Required if HtmlPart is not provided, but both can be provided - The text body of the email. Recipients whose email clients don't display HTML email see this version of the email. This property may contain replacement tags.
     * @example "Dear {{name}},
     * Your favorite color is {{color}}."
     */
    TextPart?: string;
  };
  /**
   * Required if invokeType is deleteTemplate - The name of the template to delete.
   * @example "MyEmailTemplate"
   */
  templateName?: string;
  /**
   * Required if invokeType is verifyEmail - The email address to verify. All email addresses from @smartthings.com are already verified. this is for external addresses such as @gmail.com
   * @example "example@gmail.com"
   */
  email?: string;
}

export interface PutIsaBody {
  /** Whether the user is required to sign in through oauth flow */
  needsAttention?: boolean;
}

export interface TriggerDiscoveryBody {
  /** @example {"schema":"st-schema","version":"1.0","interactionType":"triggerDiscovery","requestId":"fe09d40d-a55f-4bc0-8b62-2dea171567a6"} */
  headers?: {
    /** st-schema */
    schema?: string;
    /** version 1.0 */
    version?: string;
    /** triggerDiscovery */
    interactionType?: string;
    /** Matching request ID from request */
    requestId?: string;
  };
}

/** @example {"endpointAppId":"viper_86d99e60-aec2-11ec-a1d1-613f85592d17","locationId":"e6c887ac-f293-402a-8335-ee3557a380cd","email":"example@smartthings.com"} */
export interface TriggerPreinstallIsaBody {
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** location id of device location */
  locationId?: string;
  /** user email that is used */
  email?: string;
}

/** @example {"deviceHandlerType":"c2c-rgbw-color-bulb","deviceId":"5e0c20e3-9bb8-4a69-a33e-4c6538cc4143","endpointAppId":"viper_86d99e60-aec2-11ec-a1d1-613f85592d17","isaId":"5e0c20e3-9bb8-4a69-a33e-4c6538cc4143","label":"Color Bulb"} */
export interface PutDeviceBody {
  /** Example-"c2c-rgbw-color-bulb" */
  deviceHandlerType?: string;
  /** deviceId created by ST cloud */
  deviceId?: string;
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** isaId (Installed App Id) */
  isaId?: string;
  /** Example -"Color Bulb" */
  label?: string;
}

export interface FlatDeviceStatus {
  /**
   * The identifier for the device instance.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The ID of the Location with which the device is associated
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The identifier for the device
   * @example "main"
   */
  componentId: string;
  /**
   * The identifier for the capability
   * @example "switchLevel"
   */
  capabilityId: string;
  /**
   * The name of the attribute
   * @example "level"
   */
  attributeName: string;
  /**
   * The value of the attribute
   * @example 75
   */
  value: object;
  /** The type of value */
  valueType: 'number' | 'integer' | 'string' | 'object' | 'array' | 'unknown';
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface FlatDeviceStatusPagedResult {
  items?: FlatDeviceStatus[];
  _links?: Links;
}

/** {"status": "success"} */
export interface StandardSuccessResponse {
  /** @default "success" */
  status?: 'success';
}

export interface ConnectedService {
  /** The name of the Connected Service */
  name?: string;
  /** The id of the Connected Service */
  id?: string;
  /** The id of the location */
  locationId?: string;
  /** The type of Connected Service */
  serviceType?: 'groovy_app' | 'endpoint_app' | 'viper_app' | 'api_only';
  /** URL to the icon that represents the Connected Service */
  iconUrl?: string;
}

export interface FlatDeviceGroupStatus {
  /**
   * The identifier for the device group.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceGroupId: string;
  /**
   * The ID of the Location with which the device is associated
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The identifier for the capability
   * @example "switchLevel"
   */
  capabilityId: string;
  /**
   * The name of the attribute
   * @example "level"
   */
  attributeName: string;
  /**
   * The value of the attribute
   * @example 75
   */
  value: object;
  /** The type of value */
  valueType: 'number' | 'integer' | 'string' | 'object' | 'array' | 'unknown';
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface FlatDeviceGroupStatusPagedResult {
  items?: FlatDeviceGroupStatus[];
  _links?: Links;
}

/**
 * The id of the favorite.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type FavoriteId = string;

/**
 * The id of the location to which the favorite belongs.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type LocationId = string;

/**
 * The id of a Thing the favorite represents.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type MemberId = string;

/** The type of favorite. */
export enum MemberType {
  DEVICE = 'DEVICE',
  CAMERA_GROUP = 'CAMERA_GROUP',
  LIGHTING_GROUP = 'LIGHTING_GROUP',
  SCENE = 'SCENE',
  SMARTAPP = 'SMARTAPP',
}

/**
 * The id of room which this favorite belongs. Nullable.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */

// removed this line because it is a duplicate definition
// export type RoomId = string;

/** The sort order of the favorite. */
export type SortOrder = number;

/** @example {"favoriteId":"6c6eeb4b-ec78-4b54-b057-5d5f79982abc","sortOrder":1} */
export interface FavoriteSortOrderObject {
  /** The id of the favorite. */
  favoriteId: FavoriteId;
  /** The sort order of the favorite. */
  sortOrder: SortOrder;
}

export interface WidgetFavoritePagedResult {
  items?: WidgetFavorite[];
  links?: Links;
}

/** @example {"favoriteId":"c2dda15c-bcc7-4711-a945-f1378bd1ce70","locationId":"020c9fe5-98e2-4919-9603-a20781df25d0","memberId":"f0353f80-64dd-4e03-98be-95f98f0b0a08","memberType":"SCENE","sortOrder":1} */
export interface WidgetFavorite {
  /** The id of the favorite. */
  favoriteId?: FavoriteId;
  /** The id of the location to which the favorite belongs. */
  locationId?: LocationId;
  /** The id of a Thing the favorite represents. */
  memberId?: MemberId;
  /** The type of favorite. */
  memberType?: MemberType;
  /** The sort order of the favorite. */
  sortOrder?: SortOrder;
}

/** @example {"favoriteId":"c2dda15c-bcc7-4711-a945-f1378bd1ce70","sortOrder":1} */
export interface WidgetFavoriteSortOrderObject {
  /** The id of the favorite. */
  favoriteId: FavoriteId;
  /** The sort order of the favorite. */
  sortOrder: SortOrder;
}

/**
 * Thing to be added to widget favorites. Requires a memberId, memberType, and sortOrder.
 * @example {"memberId":"7ffb873c-a155-4c7c-acb3-88c7589bd456","memberType":"DEVICE","sortOrder":1}
 */
export interface WidgetFavoriteBodyObject {
  /** The id of a Thing the favorite represents. */
  memberId: MemberId;
  /** The type of favorite. */
  memberType: MemberType;
  /** The sort order of the favorite. */
  sortOrder: SortOrder;
}

/** room wallpaper info */
export interface RoomWallpaper {
  /** Id of the location */
  locationId: string;
  /** Id of the room */
  roomId: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
}

/** location wallpaper info */
export interface LocationWallpaper {
  /** Id of the location */
  locationId: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
}

export interface UpdateWallpaperBodyObject {
  /** Id of the wallpaper */
  wallpaperId: string;
}

export interface MigrateWallpapersBodyObject {
  /** Id of the location wallpaper */
  wallpaperId: string;
  /** List of rooms with wallpaperIds */
  roomWallpapers?: {
    /** Id of the wallpaper */
    wallpaperId: string;
    /** Id of the room */
    roomId: string;
  }[];
}

export interface InstalledAppSummary {
  /** The type of app. SMARTAPP is a legacy SmartApp, ENDPOINTAPP is a SmartApp from the public API. */
  appType: 'SMARTAPP' | 'ENDPOINTAPP';
  /** This will only be populated when appType is SMARTAPP */
  smartapp?: {
    /** The developer-defined name of the app */
    name: string;
    /** The user-defined label of the installedapp */
    label?: string;
    /** The id of the installed app */
    installedAppId: string;
    /**
     * The id of the location the app is installed
     * @format uuid
     */
    locationId: string;
    /** Whether or not the SmartApp has been completely installed */
    state: 'COMPLETE' | 'INCOMPLETE';
    /**
     * An icon image url for the app
     * @default "https://s3.amazonaws.com/smartapp-icons/Convenience/Cat-Convenience.png"
     */
    iconUrl: string;
    /** @default "NONE" */
    samsungCategory: 'automationApp' | 'setupApp' | 'serviceApp' | 'NONE';
    /**
     * Whether or not the automation can be paused
     * @default false
     */
    pausable: boolean;
    /**
     * Whether or not the automation is paused
     * @default false
     */
    paused: boolean;
    /**
     * Whether or not the automation is maintained by SmartThings or a third party
     * @default false
     */
    usesThirdPartyAuthentication: boolean;
  };
  /**
   * This will only be populated when appType is ENDPOINTAPP
   * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","installedAppType":"WEBHOOK_SMART_APP","installedAppStatus":"PENDING","displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"notices":["USER_PAUSE","RECONFIGURE"],"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","allowed":["w:installedapps","d:installedapps"]}
   */
  endpointapp?: {
    /**
     * The ID of the installed app.
     * @format uuid
     */
    installedAppId: string;
    /** Denotes the type of installed app. */
    installedAppType: InstalledAppType;
    /**
     * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
     * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
     * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
     * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
     * 'AUTHORIZED' Installed App will not execute.
     */
    installedAppStatus: InstalledAppStatus;
    /**
     * A user defined name for the installed app. May be null.
     * @maxLength 100
     */
    displayName?: string;
    /** The ID of the app. */
    appId: string;
    /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. May be null. */
    referenceId?: string;
    /**
     * The ID of the location to which the installed app may belong.
     * @format uuid
     */
    locationId?: string;
    /** A typed model which provides information around ownership of a specific domain. */
    owner: Owner;
    notices: Notice[];
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    createdDate: string;
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    lastUpdatedDate: string;
    /**
     * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
     * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
     */
    ui?: {
      /** @format ^[a-zA-Z._]{1,99}$ */
      pluginId?: string;
      /** @format uri */
      pluginUri?: string;
      dashboardCardsEnabled: boolean;
      preInstallDashboardCardsEnabled: boolean;
    };
    /**
     * A default icon image for the app.
     * @example {"url":"https://smart-home-monitor.com/image"}
     */
    iconImage?: {
      /**
       * A default icon image url for an app. https url required.
       * @format uri
       */
      url?: string;
    };
    /**
     * An App maybe associated to many classifications.  A classification drives how the integration is presented
     * to the user in the SmartThings mobile clients.  These classifications include:
     * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
     * * SERVICE - Denotes an integration that is classified as a "Service".
     * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
     * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
     * * HIDDEN - Denotes an integration that should not display in mobile clients
     */
    classifications: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
    /** Denotes the principal type to be used with the app.  Default is LOCATION. */
    principalType: 'LOCATION' | 'USER_LEVEL';
    /** Restriction tier of the install, if any. */
    restrictionTier?: number;
    /**
     * Inform the installation systems that the associated app can only be installed once within a user's account.
     * @default false
     */
    singleInstance: boolean;
    /**
     * List of client-facing action identifiers that are currently permitted for the user.
     * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
     * If the value of this property is null (or absent), then no permission-related information is being provided.
     * <ul>
     * <li>`"w:installedapps"` -- the user has update permissions on the installed app</li>
     * <li>`"d:installedapps"` -- the user has delete permissions on the installed app</li>
     * </ul>
     */
    allowed?: string[];
  };
}

export interface SceneSummary {
  /** Scene type */
  type?: 'CLASSIC' | 'SEQUENCED';
  /**
   * The unique identifier of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** The user-defined name of the Scene */
  sceneName?: string;
  /** The name of the icon */
  sceneIcon?: string;
  /** The color of the icon */
  sceneColor?: string;
  /** The unique identifier of the backing behavior */
  behaviorId?: string;
  /**
   * Location of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The unique identifier of the user that created the scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  createdBy?: string;
  /**
   * The date the scene was created
   * @format date-time
   */
  createdDate?: string;
  /**
   * The date the scene was last updated
   * @format date-time
   */
  lastUpdatedDate?: string;
  /**
   * The date the scene was last executed
   * @format date-time
   */
  lastExecutedDate?: string;
  /** Whether or not this scene can be edited by the logged in user using the version of the app that made the request */
  editable?: boolean;
  /** Date-based version of the API with which the scene was created in format YYYYMMDD */
  apiVersion?: string;
}

export type Scene = SceneRequest & {
  /**
   * Unique identifier of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /** Owner id */
  ownerId?: string;
  /** The owner of the rule is either a location or user */
  ownerType?: OwnerType;
  /** The creator name who create the behavior */
  creator?: Creator;
  /** Created date time */
  dateCreated?: string;
  /** Last updated date time */
  dateUpdated?: string;
  /** url to the scene icon */
  iconUrl?: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:scenes - the user can edit the scene
   *   <li> x:scenes - the user can execute the scene
   *   <li> d:scenes - the user can delete scene
   *   </ul>
   */
  allowed?: 'w:scenes' | 'x:scenes' | 'd:scenes';
};

export interface SceneDevice {
  /** the id of the device */
  deviceId?: string;
  /** the label of the device */
  deviceLabel?: string;
  /** the name of the device */
  deviceName?: string;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceTypeId?: string;
  components?: SceneComponent[];
  /**
   * Location of the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface SceneDeviceGroup {
  /** the id of the device */
  deviceGroupId?: string;
  /** A device component capability */
  capability?: SceneCapability;
}

/** The mode activated by the Scene */
export interface SceneMode {
  /**
   * the id of the mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
  /** the name of the mode */
  modeName?: string;
}

export interface SceneRequest {
  /** The user-defined name of the Scene */
  name: string;
  /** List of actions (CommandAction + LocationAction) to be executed */
  actions: Action[];
  /** The sequence in which the actions are to be executed i.e. Serial or Parallel (default) */
  sequence?: ActionSequence;
  /** Unstructured object for client to store additional data */
  meta?: object;
}

export type SceneActionSequence = SceneAction[];

/** Possible scene actions, mutually exclusive */
export interface SceneAction {
  /** JSON structure for a device when creating a Scene */
  deviceRequest?: SceneDeviceRequest;
  /** The mode to be activated by the Scene */
  modeRequest?: SceneModeRequest;
  /** Sleep a particular sequence */
  sleepRequest?: SceneSleepRequest;
  /** JSON structure for a device group when creating a Scene */
  deviceGroupRequest?: SceneDeviceGroupRequest;
}

/** JSON structure for a device when creating a Scene */
export interface SceneDeviceRequest {
  /**
   * the id of the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  components?: SceneComponent[];
}

/** JSON structure for a device group when creating a Scene */
export interface SceneDeviceGroupRequest {
  /**
   * the id of the device group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceGroupId: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** A device component capability */
  capability?: SceneCapability;
}

/** The mode to be activated by the Scene */
export interface SceneModeRequest {
  /**
   * The id of the mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** The name of the mode */
  modeName?: string;
}

/** The security mode to be activated by the Scene */
export interface SceneSecurityModeRequest {
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** The id of the security mode */
  security: 'setArmStay' | 'setArmAway' | 'disarm';
  /** Additional query param */
  arguments?: string;
}

/** Sleep a particular sequence */
export interface SceneSleepRequest {
  /** Number of seconds to sleep the sequence */
  seconds: number;
}

/** A component of the scene device */
export interface SceneComponent {
  /** the id of the component */
  componentId?: string;
  capabilities?: SceneCapability[];
}

/** A device component capability */
export interface SceneCapability {
  /** The id of the capability */
  capabilityId?: string;
  /** The status of the capability */
  status?: 'proposed' | 'live' | 'deprecated' | 'dead';
  /** Capability commands */
  commands?: Record<string, SceneCommand>;
}

/** A component capability command */
export interface SceneCommand {
  /** the command arguments */
  arguments?: SceneArgument[];
}

/** A capability command argument */
export interface SceneArgument {
  /** the name of the command */
  name?: string;
  /** the schema of the command */
  schema?: object;
  /** The value being set for the capability command */
  value?: object;
}

/** A tile corresponding to a scene */
export interface SceneTile {
  /** the name of the tile */
  name?: string;
  /** the label of the tile, currently same as name */
  label?: string;
  /**
   * The unique identifier of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  memberId?: string;
  /** The name of the icon */
  iconName?: string;
  /** The color of the icon */
  iconColor?: string;
  /**
   * Location of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Type of the tile. Hardcoded to scene */
  type?: string;
  /** State of the Scene */
  state?: string;
  /** The type of object the tile represents, hardcoded to SCENE */
  memberSource?: string;
  /** SmartApp Id of the Scene */
  installedSmartAppId?: string;
  /** The width of the tile. Hard-coded to 3 */
  width?: number;
  /** The width of the tile. Hard-coded to 3 */
  height?: number;
  /** Indicates whether the scene is editable */
  action?: 'DEFAULT' | 'READ_ONLY';
  /** The url to the icon */
  iconUrl?: string;
  /** The url to the icon */
  iconX2Url?: string;
  /** The url to the icon */
  iconX3Url?: string;
}

export interface ScenePagedResult {
  items: Scene[];
  _links?: Links;
}

export interface SceneDevicePagedResult {
  items?: SceneDevice[];
  _links?: Links;
}

export interface SceneTilePagedResult {
  items?: SceneTile[];
  _links?: Links;
}

/** Expected response for a Dashboard lifecycle execution. */
export interface DashboardResponseData {
  /**
   * A unique identifier for a card of service
   * @format some service name
   */
  serviceName?: string;
  /**
   * list of card object
   * @maxItems 5
   * @minItems 1
   */
  cards?: DashboardCard[];
}

/** payload of dashboard card */
export interface DashboardCard {
  /**
   * A directive to the SmartThings client to use a specific template for rendering the dashboard card.
   * Each card template may have a different set requirement for data needs.
   *
   * * BASIC_V1 - The basic / default template.
   * * BASIC_V2 - default template + HTML and body items support.
   * * BASIC_V3 - V2 template + bar graph support.
   * * BASIC_V4 - Template to support Pet care and Kitchen services
   * * BASIC_V5 - Template to support UX2.5 changes
   * * BASIC_V6 - Template to remove dependency on webViews, add talkback fields.
   * * BASIC_V7 - Template to support body image + bg Image + icon.
   * * FREE_FORM - A free form template with minimal constraints.
   */
  templateId: DashboardCardTemplate;
  /**
   * A unique identifier for a card of service
   * @format ^[a-z0-9.-_]{1,36}$
   * @example "some-card-id"
   */
  cardId: string;
  /** card size */
  size?: number;
  /** Data requirements for a Basic V1 card template. */
  basicV1?: BasicCard;
  /** Data requirements for a Basic V2 card template. */
  basicV2?: BasicV2Card;
  /** Data requirements for a Basic V3 card template. */
  basicV3?: BasicV3Card;
  /** Data requirements for a Basic V4 card template. */
  basicV4?: BasicV4Card;
  /** Data requirements for a Basic V5 card template. */
  basicV5?: BasicV5Card;
  /** Data requirements for a Basic V6 card template. */
  basicV6?: BasicV6Card;
  /** Data requirements to support BasicV7 */
  basicV7?: BasicV7Card;
  freeForm?: FreeFormCard;
}

/**
 * A directive to the SmartThings client to use a specific template for rendering the dashboard card.
 * Each card template may have a different set requirement for data needs.
 *
 * * BASIC_V1 - The basic / default template.
 * * BASIC_V2 - default template + HTML and body items support.
 * * BASIC_V3 - V2 template + bar graph support.
 * * BASIC_V4 - Template to support Pet care and Kitchen services
 * * BASIC_V5 - Template to support UX2.5 changes
 * * BASIC_V6 - Template to remove dependency on webViews, add talkback fields.
 * * BASIC_V7 - Template to support body image + bg Image + icon.
 * * FREE_FORM - A free form template with minimal constraints.
 */
export enum DashboardCardTemplate {
  BASICV1 = 'BASIC_V1',
  BASICV2 = 'BASIC_V2',
  BASICV3 = 'BASIC_V3',
  BASICV4 = 'BASIC_V4',
  BASICV5 = 'BASIC_V5',
  BASICV6 = 'BASIC_V6',
  BASICV7 = 'BASIC_V7',
  FREE_FORM = 'FREE_FORM',
}

export interface FreeFormCard {
  /**
   * An arbitrary set of key / value pairs useful for passing any custom metadata.
   *
   * * Supports a maximum of 5 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum value length: 1000 Unicode characters in UTF-8
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding.
   */
  attributes?: Record<string, string>;
}

/** Data requirements for a Basic V1 card template. */
export interface BasicCard {
  /**
   * name of the card
   * @maxLength 100
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * A title icon url for card. Angit  HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image"
   */
  iconUrl?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** Body definition for a Basic V1 template. */
  body?: BasicBody;
  /**
   * A list of buttons to render and buttons must be of the same type.
   * @maxItems 3
   */
  buttons?: BasicButton[];
}

/** Data requirements for a Basic V2 card template. */
export interface BasicV2Card {
  /**
   * An title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** Body definition for a Basic V2 template. */
  body?: BasicV2Body;
  /**
   * A list of buttons to render and buttons must be of the same type.
   * @maxItems 3
   */
  buttons?: BasicV2Button[];
}

/** Body definition for a Basic V2 template. */
export interface BasicV2Body {
  image?: BasicV2Image;
  /** Body item array definition for a Basic V2 template */
  items?: BasicV2Items;
  /** A text object. */
  text?: BasicV2Text;
  /** WebView for service card body */
  webView?: ServiceCardWebView;
}

export interface BasicV2Image {
  /** Position of where the image should be rendered within card. */
  position: BasicImagePosition;
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/**
 * Body item array definition for a Basic V2 template
 * @maxItems 4
 */
export type BasicV2Items = BasicV2Item[];

/** Item in Basic V2 items */
export interface BasicV2Item {
  /** Body item image height */
  height?: number;
  /** Body item object definition for a Basic V2 template */
  item?: BasicV2ImageItem;
}

/** Body item object definition for a Basic V2 template */
export interface BasicV2ImageItem {
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url?: string;
  /**
   * The text that would be shown under image
   * @maxLength 250
   */
  description?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text object. */
export interface BasicV2Text {
  /**
   * Text to display.
   * @maxLength 500
   */
  content?: string;
  /** text alignment */
  position?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A button definition for a Basic V2 template. */
export interface BasicV2Button {
  /**
   * The type of buttons to render.
   *
   * * TEXT - A colored button with a text overrlay.
   * * ICON - A button with an image backgroup and text overrlay.
   */
  type?: BasicButtonType;
  /** A text button definition for a basic V2 template. */
  textButton?: BasicV2TextButton;
  /** A text button definition for a basic V2 template. */
  iconButton?: BasicV2IconButton;
}

/** A text button definition for a basic V2 template. */
export interface BasicV2TextButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text button definition for a basic V2 template. */
export interface BasicV2IconButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /**
   * An icon image url on button-released. HTTPS url required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  releasedIconUrl?: string;
  /**
   * An icon image url on button-pressed. HTTPS url required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  pressedIconUrl?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
export interface ServiceCardBarGraphV2 {
  /** VALUE_UNIT_GRAPH requires value and unit fields, PERCENT_COST_GRAPH and SAME_BASE_GRAPH requires percent and cost fields. */
  type: 'VALUE_UNIT_GRAPH' | 'PERCENT_COST_GRAPH' | 'SAME_BASE_GRAPH';
  /** @minItems 1 */
  list: ServiceCardBarV2[];
}

export interface ServiceCardBarV2 {
  /**
   * Bar header.
   * @maxLength 100
   */
  header: string;
  /** Value of the field. */
  value?: number;
  /** percent of the bar to occupy. */
  percent?: number;
  /** color with alpha */
  color: BasicCardColor;
  /** color with alpha */
  maxBarColor?: BasicCardColor;
  /** units of the field. */
  units?: string;
  /** Bar information. */
  cost?: string;
}

/** Data requirements for a Basic V3 card template. */
export interface BasicV3Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V3 template. */
  body?: BasicV3Body;
  /**
   * A list of buttons to render and buttons must be of the same type.
   * @maxItems 3
   */
  buttons?: BasicV2Button[];
}

/** Body definition for a Basic V3 template. */
export interface BasicV3Body {
  /** WebView for service card body */
  webView?: ServiceCardWebView;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  image?: BasicV2Image;
  /** Body item array definition for a Basic V2 template */
  items?: BasicV2Items;
  /** A text object. */
  text?: BasicV2Text;
}

/**
 * A horizontal comparision bar graph to compare two values.
 * @maxItems 2
 * @minItems 2
 */
export type ServiceCardBarGraph = ServiceCardBar[];

export interface ServiceCardBar {
  /**
   * Bar header.
   * @maxLength 100
   */
  header: string;
  /** Value of the field. */
  value: number;
  /** color with alpha */
  color: BasicCardColor;
  /** units of the field. */
  units: string;
}

/** Data requirements for a Basic V4 card template. */
export interface BasicV4Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  headerIcons?: BasicV4HeaderIcon[];
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V4 template. */
  body?: BasicV4Body;
  /** buttons to render. */
  buttons?: {
    /**
     * A list of icon buttons.
     * @maxItems 5
     */
    iconButtons?: BasicV4IconButton[];
    /**
     * A list of text buttons.
     * @maxItems 3
     */
    textButtons?: BasicV4TextButton[];
  };
}

/** Header icon for Basic V4 template */
export interface BasicV4HeaderIcon {
  /**
   * header icon url. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Body definition for a Basic V4 template. */
export interface BasicV4Body {
  /** Background spacing to show image in the Card's bgImage */
  bgSpacing?: BasicV4BackgroundSpacing;
  /** A text object. */
  description?: BasicV2Text;
  /** A text object. */
  text?: BasicV2Text;
  image?: BasicV2Image;
  /** Switch button in BasicV4 body */
  switch?: BasicV4SwitchButton;
  /** WebView for service card body */
  webView?: ServiceCardWebView;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  items?: ServiceCardItemsV2;
}

/** Background spacing to show image in the Card's bgImage */
export interface BasicV4BackgroundSpacing {
  /** Spacing position */
  position: 'LEFT' | 'RIGHT';
  /** width of spacing in px */
  width: number;
}

/** item in BasicV4, BasicV5, BasicV6 items list. */
export interface BasicV4Item {
  /**
   * Text 1 in the body/header item
   * @maxLength 250
   */
  name?: string;
  /**
   * Text 2 in the body item
   * @maxLength 250
   */
  description?: string;
  /** icon of the body/header item */
  icon?: BasicV4Icon;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** icon of the body/header item */
export interface BasicV4Icon {
  /**
   * icon url for the item. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /** Item alignment */
  align: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Item position */
  position: 'LEFT' | 'CENTER' | 'RIGHT';
  /** Item icon height */
  height?: number;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
}

/** Switch button in BasicV4 body */
export interface BasicV4SwitchButton {
  /** Switch enabled status */
  status: boolean;
  /** color with alpha */
  color: BasicCardColor;
  /** A definition of the action to be taken when button is activated. */
  action: ServiceCardAction;
}

/** BasicV4 icon button */
export interface BasicV4IconButton {
  /**
   * icon url for button. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** BasicV4 text button */
export interface BasicV4TextButton {
  /**
   * text in button
   * @maxLength 250
   * @example "Lock All"
   */
  name: string;
  /** color with alpha */
  color?: BasicCardColor;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Data requirements for a Basic V5 card template. */
export interface BasicV5Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  headerIcons?: BasicV4HeaderIcon[];
  /** header alignment */
  headerAlignment?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V5 template. */
  body?: BasicV5Body;
  /** buttons to render. */
  buttons?: {
    /**
     * A list of icon buttons.
     * @maxItems 5
     */
    iconButtons?: BasicV4IconButton[];
    /**
     * A list of text buttons.
     * @maxItems 3
     */
    textButtons?: BasicV4TextButton[];
  };
}

/** Body definition for a Basic V5 template. */
export interface BasicV5Body {
  /** Body item alignment */
  align?: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Background spacing to show image in the Card's bgImage */
  bgSpacing?: BasicV4BackgroundSpacing;
  /** A text object. */
  description?: BasicV5Text;
  /** A text object. */
  text?: BasicV5Text;
  image?: BasicV2Image;
  /** Switch button in BasicV4 body */
  switch?: BasicV4SwitchButton;
  /** WebView for service card body */
  webView?: ServiceCardWebView;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  items?: ServiceCardItemsV2;
}

/** Data requirements for a Basic V6 card template. */
export interface BasicV6Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  headerIcons?: BasicV6HeaderIcon[];
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  headerItems?: ServiceCardItemsV2;
  /** header alignment */
  headerAlignment?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V6 template. */
  body?: BasicV6Body;
  /** buttons to render. */
  buttons?: {
    /**
     * A list of icon buttons.
     * @maxItems 5
     */
    iconButtons?: BasicV6IconButton[];
    /**
     * A list of text buttons.
     * @maxItems 3
     */
    textButtons?: BasicV6TextButton[];
  };
}

/** Body definition for a Basic V6 template. */
export interface BasicV6Body {
  /** Body item alignment */
  align?: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Background spacing to show image in the Card's bgImage */
  bgSpacing?: BasicV4BackgroundSpacing;
  /** A text object. */
  description?: BasicV5Text;
  /** A text object. */
  text?: BasicV5Text;
  /** Image definition for Basic V6. */
  image?: BasicV6Image;
  /** Switch button in BasicV4 body */
  switch?: BasicV4SwitchButton;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  items?: ServiceCardItemsV2;
}

/** Data requirements to support BasicV7 */
export interface BasicV7Card {
  /** Common properties that shared by entire card in Basic V7. */
  card?: BasicV7CardProperties;
  /** Data requirement to support Basic V7 header types. */
  header?: BasicV7Header;
  /** Data requirement to support Basic V7 body types. */
  body: BasicV7Body;
}

/** Common properties that shared by entire card in Basic V7. */
export interface BasicV7CardProperties {
  /** Background for the entire card. */
  bgImage?: BasicV7Image;
  /** Default action of the card. */
  action: ServiceCardAction;
}

/** Data requirement to support Basic V7 header types. */
export interface BasicV7Header {
  /** Type of header as per GUI naming. */
  headerType: 'STYLE_1' | 'STYLE_2' | 'STYLE_3' | 'STYLE_4';
  /** A title icon url for card. */
  titleIcon?: BasicV7Image;
  /** Text to be shown on header */
  text: BasicV7Text;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  iconsList?: BasicV7Image[];
  /** header items for small device icon and a single line of text. */
  headerItems?: BasicV7ItemGroup;
}

/** Data requirement to support Basic V7 body types. */
export interface BasicV7Body {
  /** Type of body as per GUI naming. */
  bodyType: 'TYPE_1' | 'TYPE_2' | 'TYPE_3' | 'TYPE_4' | 'TYPE_5' | 'TYPE_6';
  /** Data requirements for name for Basic V7. */
  nameGroup?: BasicV7NameGroup;
  /** Text for UI components of Basic V7. */
  name?: BasicV7Text;
  /** Text for UI components of Basic V7. */
  description?: BasicV7Text;
  /** Image definition for Basic V7. */
  image?: BasicV7Image;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraph?: ServiceCardBarGraphV2;
  /** Data requirements for header/body items for Basic V7. */
  items?: BasicV7ItemGroup;
  /** Text to be displayed on button. */
  buttonText?: BasicV7Text;
  /** Image definition for Basic V7. */
  bgImage?: BasicV7Image;
  /** Image definition for Basic V7. */
  icon?: BasicV7Image;
}

/** Text for UI components of Basic V7. */
export interface BasicV7Text {
  /**
   * Text to display.
   * @maxLength 500
   */
  content: string;
  /** Position/Padding of any UI entity. */
  position?: BasicV7Position;
  /** Align/Padding of any UI entity. */
  align?: BasicV7Align;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Defines the dimension of the UI entity. */
  dimension?: BasicV7Dimension;
}

/** Image definition for Basic V7. */
export interface BasicV7Image {
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url: string;
  /**
   * Talkback text for body image.
   * @maxLength 250
   * @example "Tutorial Image"
   */
  talkback?: string;
  /**
   * some color code
   * @format ^[a-fA-F0-9]{6}$
   */
  color?: string;
  /**
   * transparency of the color/image
   * @format ^[0-9]{1,2}$
   */
  alpha?: number;
  /** Position/Padding of any UI entity. */
  position?: BasicV7Position;
  /** Align/Padding of any UI entity. */
  align?: BasicV7Align;
  /** Defines scale type of the image. */
  scaleType?: BasicV7ImageScaleType;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Defines the dimension of the UI entity. */
  dimension?: BasicV7Dimension;
}

/** Defines scale type of the image. */
export enum BasicV7ImageScaleType {
  CENTER_CROP = 'CENTER_CROP',
  FIT_CENTER = 'FIT_CENTER',
  CENTER_INSIDE = 'CENTER_INSIDE',
  FIT_XY = 'FIT_XY',
}

/** Position/Padding of any UI entity. */
export interface BasicV7Position {
  /** General Position */
  position: 'LEFT' | 'CENTER' | 'RIGHT';
  /** Defines left Padding. */
  paddingLeft?: number;
  /** Defines right Padding. */
  paddingRight?: number;
}

/** Align/Padding of any UI entity. */
export interface BasicV7Align {
  /** General Position */
  position: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Defines Top Padding. */
  paddingTop?: number;
  /** Defines Bottom Padding. */
  paddingBottom?: number;
}

/** Defines the dimension of the UI entity. */
export interface BasicV7Dimension {
  width: number;
  height: number;
}

/** Data requirements for header/body items for Basic V7. */
export interface BasicV7ItemGroup {
  /** Image definition for Basic V7. */
  dividerUrl?: BasicV7Image;
  /**
   * @maxItems 3
   * @minItems 1
   */
  items: BasicV7Item[];
}

/** Data requirements for name for Basic V7. */
export interface BasicV7NameGroup {
  /** Text for UI components of Basic V7. */
  mainName: BasicV7Text;
  /** Text for UI components of Basic V7. */
  subName?: BasicV7Text;
  /** Image definition for Basic V7. */
  dividerImage?: BasicV7Image;
}

/** Data requirements for header/body items for Basic V7. */
export interface BasicV7Item {
  /** Type of body as per GUI naming. */
  itemType: 'BODY_TYPE_1' | 'BODY_TYPE_2' | 'HEADER_STYLE_4';
  /** Text for line 1 in the item */
  name?: BasicV7Text;
  /** Text for line 2 in the item */
  description?: BasicV7Text;
  /** Image definition for Basic V7. */
  icon?: BasicV7Image;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Header icon for Basic V6 template */
export interface BasicV6HeaderIcon {
  /**
   * header icon url. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /**
   * Talkback text for icon.
   * @maxLength 250
   * @example "Barcode Scanner"
   */
  talkback?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Basic V6 icon button */
export interface BasicV6IconButton {
  /**
   * icon url for button. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /**
   * Talkback text for Button.
   * @maxLength 250
   * @example "off device"
   */
  talkback?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Image definition for Basic V6. */
export interface BasicV6Image {
  /** Position of where the image should be rendered within card. */
  position: BasicImagePosition;
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url: string;
  /** describes how image should be scaled. */
  scaleType?: 'CENTER_CROP' | 'FIT_CENTER' | 'CENTER_INSIDE' | 'FIT_XY';
  /**
   * Talkback text for body image.
   * @maxLength 250
   * @example "Tutorial Image"
   */
  talkback?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Basic V6 text button */
export interface BasicV6TextButton {
  /**
   * 1st line of text in button
   * @maxLength 250
   * @example "Lock All"
   */
  name: string;
  /**
   * 2nd line of text in button
   * @maxLength 250
   * @example "Locks all devices"
   */
  description?: string;
  /** color with alpha */
  color?: BasicCardColor;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text object. */
export interface BasicV5Text {
  /**
   * Text to display.
   * @maxLength 500
   */
  content?: string;
  /** text vertical alignment. Default CENTER */
  align?: 'TOP' | 'CENTER' | 'BOTTOM';
  /** text horizontal alignment */
  position?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** WebView for service card body */
export interface ServiceCardWebView {
  /**
   * HTML content for the web view
   * @maxLength 10000
   */
  content: string;
  /**
   * CSS styles for the web view
   * @maxLength 5000
   */
  styles?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
export interface ServiceCardItemsV2 {
  /** divider width in dp */
  dividerWidth?: number;
  /**
   * URL of the divider for the items. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  dividerUrl?: string;
  /**
   * A list of items.
   * @maxItems 4
   */
  list: BasicV4Item[];
}

/**
 * color with alpha
 * @format ^[a-fA-F0-9]{8}$
 */
export type BasicCardColor = string;

/** A background image. */
export interface BasicBackgroundImage {
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url?: string;
  /**
   * some color code
   * @format ^[a-fA-F0-9]{6}$
   */
  color?: string;
  /**
   * transparency of the color/image
   * @format ^[0-1]{1}$
   */
  alpha?: number;
}

/** Body definition for a Basic V1 template. */
export interface BasicBody {
  image?: BasicImage;
  /** A text object. */
  text?: BasicText;
}

/** A button definition for a Basic V1 template. */
export interface BasicButton {
  /**
   * The type of buttons to render.
   *
   * * TEXT - A colored button with a text overrlay.
   * * ICON - A button with an image backgroup and text overrlay.
   */
  type?: BasicButtonType;
  /** A text button definition for a basic template. */
  textButton?: BasicTextButton;
  /** A text button definition for a basic template. */
  iconButton?: BasicIconButton;
}

export interface BasicImage {
  /**
   * An icon name.
   * @maxLength 100
   */
  name?: string;
  /** Position of where the image should be rendered within card. */
  position?: BasicImagePosition;
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url?: string;
}

/** A text object. */
export interface BasicText {
  /**
   * Text to display.
   * @maxLength 500
   */
  content?: string;
}

/**
 * The type of buttons to render.
 *
 * * TEXT - A colored button with a text overrlay.
 * * ICON - A button with an image backgroup and text overrlay.
 */
export enum BasicButtonType {
  TEXT = 'TEXT',
  ICON = 'ICON',
}

/** Position of where the image should be rendered within card. */
export enum BasicImagePosition {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

/** A text button definition for a basic template. */
export interface BasicTextButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /** Position of where the button should be rendered within card. */
  position?: BasicButtonPosition;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text button definition for a basic template. */
export interface BasicIconButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /** Position of where the button should be rendered within card. */
  position?: BasicButtonPosition;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /**
   * A default icon image url. HTTPS url required.
   * @format uri
   * @maxLength 250
   */
  iconUrl?: string;
}

/** Position of where the button should be rendered within card. */
export enum BasicButtonPosition {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

/** A definition of the action to be taken when button is activated. */
export interface ServiceCardAction {
  type?: ActionType;
  /** Launch a backing UI plugin in SmartThings Client. */
  launchPlugin?: LaunchPluginAction;
  /** Call the EXECUTE lifecycle on the backing SmartApp. */
  execute?: ExecuteAction;
  /** Launch the SmartApp's configuration page in Strongman */
  launchConfiguration?: LaunchConfiguration;
  /** Launch a service plugin in background. */
  launchPluginService?: LaunchPluginService;
}

export enum ActionType {
  Command = 'command',
  Location = 'location',
  Toggle = 'toggle',
  Notification = 'notification',
}

/** Launch a backing UI plugin in SmartThings Client. */
export interface LaunchPluginAction {
  /**
   * The ID of the plugin to launch.
   * @format ^[a-zA-Z._]{1,99}$
   */
  pluginId?: string;
  /** parameter to be passed to plugin */
  uri?: string;
}

/** Call the EXECUTE lifecycle on the backing SmartApp. */
export interface ExecuteAction {
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

/** Launch the SmartApp's configuration page in Strongman */
export interface LaunchConfiguration {
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

/** Launch a service plugin in background. */
export interface LaunchPluginService {
  /**
   * The ID of the plugin to launch.
   * @format ^[a-zA-Z._]{1,99}$
   */
  pluginId: string;
  /**
   * service component to be launched.
   * @format ^[a-zA-Z._]{1,99}$
   */
  componentId: string;
  /** parameter to be passed to plugin */
  uri?: string;
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

export interface InstalledAppDashboardRequest {
  /**
   * Known details about the client application from which the request was initiated.  This information is provided
   * on best effort basis.  All properties maybe null or empty.
   */
  client?: ClientDetails;
}

/**
 * Known details about the client application from which the request was initiated.  This information is provided
 * on best effort basis.  All properties maybe null or empty.
 */
export interface ClientDetails {
  /**
   * The operating system of the client application initiating the request.
   * @maxLength 16
   */
  os?: string;
  /**
   * The version of the client application initiating the request.
   * @maxLength 16
   */
  version?: string;
  /**
   * Language header representing the client's preferred language. The format of the `Accept-Language` header follows what is defined in [RFC 7231, section 5.3.5](https://tools.ietf.org/html/rfc7231#section-5.3.5)
   * @maxLength 1024
   */
  language?: string;
  /** The display mode of the operating system of the client. */
  displayMode?: 'DARK' | 'LIGHT';
  /** A time zone [UTC offset](https://en.wikipedia.org/wiki/ISO_8601#Time_offsets_from_UTC). Note that a leading zero is required. (e.g. "UTC-06:00", "UTC+09:00" or "UTC-00:00") */
  timeZoneOffset?: string;
  /** Templates that could be renderable in the client */
  supportedTemplates?: ('BASIC_V1' | 'BASIC_V2' | 'BASIC_V3' | 'BASIC_V4' | 'BASIC_V5' | 'BASIC_V6' | 'BASIC_V7')[];
  /**
   * ID for acting user in Samsung Account. Will be null for smartthings only accounts.
   * @example "pcg38apioc"
   */
  samsungAccountId?: string;
  /**
   * ID for acting user's mobile device.
   * @example "d4e53f5c-7eb1-4f7e-a9ff-b908b2a36bf0"
   */
  mobileDeviceId?: string;
}

export interface LegacyInstalledAppSummary {
  /** The developer-defined name of the app */
  name: string;
  /** The user-defined label of the installedapp */
  label?: string;
  /** The id of the installed app */
  installedAppId: string;
  /**
   * The id of the location the app is installed
   * @format uuid
   */
  locationId: string;
  /** Whether or not the SmartApp has been completely installed */
  state: 'COMPLETE' | 'INCOMPLETE';
  /**
   * An icon image url for the app
   * @default "https://s3.amazonaws.com/smartapp-icons/Convenience/Cat-Convenience.png"
   */
  iconUrl: string;
  /** @default "NONE" */
  samsungCategory: 'automationApp' | 'setupApp' | 'serviceApp' | 'NONE';
  /**
   * Whether or not the automation can be paused
   * @default false
   */
  pausable: boolean;
  /**
   * Whether or not the automation is paused
   * @default false
   */
  paused: boolean;
  /**
   * Whether or not the automation is maintained by SmartThings or a third party
   * @default false
   */
  usesThirdPartyAuthentication: boolean;
}

export interface DeviceHealthResponse {
  /** Id of the device */
  deviceId?: string;
  /** Current state of the device */
  state?: 'ONLINE' | 'UNHEALTHY' | 'OFFLINE';
  /**
   * Last reported date/time in UTC in milliseconds since epoch
   * @format int64
   * @example 1511913638679
   */
  lastUpdatedDate?: number;
  /** id of the location the device is in. Will be null for user level devices */
  locationId?: string;
}

/**
 * An object that represents a favorites scene widget
 * @example {"sceneId":"bc2cee1e-60cf-4e3f-813d-1fe836f9e554","sceneName":"Test Scene","sceneIcon":"st.scenes.wand","ocfIconId":"200","locationId":"ece68254-ad83-4c49-9b96-5a723098a118","locationName":"Test Location"}
 */
export interface SceneWidgetFavoriteRepresentation {
  /**
   * The id of the Scene. Not nullable.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** The name of the Scene. Not nullable. */
  sceneName?: string;
  /** The name for the Scene Icon. Nullable. */
  sceneIcon?: string;
  /** The id for the OCF Icon. Not nullable. */
  ocfIconId?: string;
  /**
   * The location id of the Scene. Not nullable.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** The name for the location of the Scene. Not nullable. */
  locationName?: string;
}

/**
 * An object that represents a favorites scene widget
 * @example {"sceneId":"bc2cee1e-60cf-4e3f-813d-1fe836f9e554","locationId":"ece68254-ad83-4c49-9b96-5a723098a118"}
 */
export interface CreateSceneWidgetFavoriteRepresentation {
  /**
   * The id of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
  /**
   * The location id of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface ConnectedServiceSummary {
  /** The type of Connected Service */
  serviceType: 'ENDPOINTAPP' | 'SMARTAPP' | 'VIPER';
  /**
   * This will only be populated when appType is ENDPOINTAPP
   * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","installedAppType":"WEBHOOK_SMART_APP","installedAppStatus":"PENDING","displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"notices":["USER_PAUSE","RECONFIGURE"],"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","allowed":["w:installedapps","d:installedapps"]}
   */
  endpointapp?: {
    /**
     * The ID of the installed app.
     * @format uuid
     */
    installedAppId: string;
    /** Denotes the type of installed app. */
    installedAppType: InstalledAppType;
    /**
     * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
     * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
     * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
     * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
     * 'AUTHORIZED' Installed App will not execute.
     */
    installedAppStatus: InstalledAppStatus;
    /**
     * A user defined name for the installed app. May be null.
     * @maxLength 100
     */
    displayName?: string;
    /** The ID of the app. */
    appId: string;
    /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. May be null. */
    referenceId?: string;
    /**
     * The ID of the location to which the installed app may belong.
     * @format uuid
     */
    locationId?: string;
    /** A typed model which provides information around ownership of a specific domain. */
    owner: Owner;
    notices: Notice[];
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    createdDate: string;
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    lastUpdatedDate: string;
    /**
     * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
     * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
     */
    ui?: {
      /** @format ^[a-zA-Z._]{1,99}$ */
      pluginId?: string;
      /** @format uri */
      pluginUri?: string;
      dashboardCardsEnabled: boolean;
      preInstallDashboardCardsEnabled: boolean;
    };
    /**
     * A default icon image for the app.
     * @example {"url":"https://smart-home-monitor.com/image"}
     */
    iconImage?: {
      /**
       * A default icon image url for an app. https url required.
       * @format uri
       */
      url?: string;
    };
    /**
     * An App maybe associated to many classifications.  A classification drives how the integration is presented
     * to the user in the SmartThings mobile clients.  These classifications include:
     * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
     * * SERVICE - Denotes an integration that is classified as a "Service".
     * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
     * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
     * * HIDDEN - Denotes an integration that should not display in mobile clients
     */
    classifications: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
    /** Denotes the principal type to be used with the app.  Default is LOCATION. */
    principalType: 'LOCATION' | 'USER_LEVEL';
    /** Restriction tier of the install, if any. */
    restrictionTier?: number;
    /**
     * Inform the installation systems that the associated app can only be installed once within a user's account.
     * @default false
     */
    singleInstance: boolean;
    /**
     * List of client-facing action identifiers that are currently permitted for the user.
     * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
     * If the value of this property is null (or absent), then no permission-related information is being provided.
     * <ul>
     * <li>`"w:installedapps"` -- the user has update permissions on the installed app</li>
     * <li>`"d:installedapps"` -- the user has delete permissions on the installed app</li>
     * </ul>
     */
    allowed?: string[];
  };
  /** This will only be populated when appType is SMARTAPP */
  smartapp?: {
    /** The developer-defined name of the app */
    name: string;
    /** The user-defined label of the installedapp */
    label?: string;
    /** The id of the installed app */
    installedAppId: string;
    /**
     * The id of the location the app is installed
     * @format uuid
     */
    locationId: string;
    /** Whether or not the SmartApp has been completely installed */
    state: 'COMPLETE' | 'INCOMPLETE';
    /**
     * An icon image url for the app
     * @default "https://s3.amazonaws.com/smartapp-icons/Convenience/Cat-Convenience.png"
     */
    iconUrl: string;
    /** @default "NONE" */
    samsungCategory: 'automationApp' | 'setupApp' | 'serviceApp' | 'NONE';
    /**
     * Whether or not the automation can be paused
     * @default false
     */
    pausable: boolean;
    /**
     * Whether or not the automation is paused
     * @default false
     */
    paused: boolean;
    /**
     * Whether or not the automation is maintained by SmartThings or a third party
     * @default false
     */
    usesThirdPartyAuthentication: boolean;
  };
  /** This will only be populated when appType is VIPER */
  viper?: {
    /** isaId installed for the user */
    isaId: string;
    /** SmartThings Schema connector name given by partner eg Lifx (Connect) */
    appName: string;
    /** Parnter name eg Lifx Inc */
    partnerName: string;
    /** url of partner icon */
    icon: string;
    /** url of partner icon in 2x dimensions */
    icon2x: string;
    /** url of partner icon in 3x dimensions */
    icon3x: string;
    /** location of the installed smart app */
    locationId: string;
    /** connection status between partner and ST platform */
    partnerSTConnection: 'connected' | 'disconnected';
    /** endpoint app id of the installed smart app */
    endpointAppId: string;
  };
}

export interface VoiceAssistantApp {
  /** The name of the app */
  name: string;
  /** Icon for the app from hawker */
  icon?: string;
  /** localization info */
  localizations: {
    /** metadata display name */
    metadataDisplayName: string;
    /** language string the rest of the data is for */
    language: string;
  }[];
  /** appLinks */
  appLinks: {
    /** ios url */
    ios: string;
    /** android url */
    android: string;
    /** web url */
    web?: string;
    /** activation uri */
    activationUri?: string;
  };
  /** additional metadata for voice app with arbitrary key-value string map */
  voiceAppMetadata?: Record<string, string>;
  /** whether it is connected to the account or not. will be true if locations is not empty */
  connected: boolean;
  /** list of locations where the app is installed */
  locations: VoiceAssistantAppLocation[];
  /** key for pii consent info */
  pii_key?: string;
}

export interface VoiceAssistantAppLocation {
  /** id of the location */
  locationId: string;
  /** name of the location */
  name: string;
}

export interface UserMigrationStatus {
  status?: 'DONE' | 'INCOMPLETE' | 'NOT_STARTED';
  showWelcomeFlow?: boolean;
}

export interface LocationUsersResponse {
  owner?: LocationUser;
  members?: LocationUser[];
}

export interface LocationUser {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "e4190894-6ab2-4c80-a233-29fa9e87ae90"
   */
  uuid?: string;
  /** @example "pcg38apioc" */
  samsungAccountId?: string;
  /** @example "Mickey Mouse" */
  name?: string;
  /** @example "mickey@mouse.com" */
  email?: string;
  /**
   * Phone number or email. If the phone number is present on the User, this will be the phone number, otherwise falls back to email.
   * @example "mickey@mouse.com"
   */
  display?: string;
}

export interface UserToRemove {
  /**
   * The UUID of the user to remove.
   * @format uuid
   * @example "76275c80-21e2-68bb-1ea2-f8b965a38932"
   */
  uuid: string;
}

/** @example {"favoriteId":"6c6eeb4b-ec78-4b54-b057-5d5f79982abc","locationId":"811ba20b-9c6f-4064-851e-53e6fd3985ff","memberId":"7ffb873c-a155-4c7c-acb3-88c7589bd456","memberType":"DEVICE","sortOrder":1,"additionalId":null,"bucket":null} */
export interface Favorite {
  /** The id of the favorite. */
  favoriteId: FavoriteId;
  /** The id of the location to which the favorite belongs. Must match the location the entity belongs to if it's assigned to a location. */
  locationId: FavoriteLocationId;
  /** The id of a Thing the favorite represents. */
  memberId: FavoriteMemberId;
  /** The type of favorite. */
  memberType: FavoriteMemberType;
  /** The sort order of the favorite. Duplicate numbers are allowed to allow clients to group favorites by MemberType. */
  sortOrder: FavoriteSortOrder;
  /** Additional Id used for SERVICE favorites. */
  additionalId?: FavoriteAdditionalId;
  /** The bucket you are requesting favorites for. If present then manipulate the data corresponding to that bucket of favorites, otherwise uses location based favorites. [Max length = 50] */
  bucket?: FavoriteBucket;
  /** The model of device that created the favorite. Used for debugging purposes. */
  deviceModel: FavoriteDeviceModel;
  /**
   * The date the favorite was created.
   * @format date-time
   */
  createdDate: string;
  /**
   * The date the favorite was updated.
   * @format date-time
   */
  lastUpdatedDate: string;
}

/**
 * The id of the location to which the favorite belongs. Must match the location the entity belongs to if it's assigned to a location.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type FavoriteLocationId = string;

/** The id of a Thing the favorite represents. */
export type FavoriteMemberId = string;

/** The type of favorite. */
export enum FavoriteMemberType {
  DEVICE = 'DEVICE',
  DEVICE_GROUP = 'DEVICE_GROUP',
  SCENE = 'SCENE',
  SERVICE = 'SERVICE',
  D2D = 'D2D',
}

/** The sort order of the favorite. Duplicate numbers are allowed to allow clients to group favorites by MemberType. */
export type FavoriteSortOrder = number;

/** Additional Id used for SERVICE favorites. */
export type FavoriteAdditionalId = string;

/** The bucket you are requesting favorites for. If present then manipulate the data corresponding to that bucket of favorites, otherwise uses location based favorites. [Max length = 50] */
export type FavoriteBucket = string;

/** The model of device that created the favorite. Used for debugging purposes. */
export type FavoriteDeviceModel = string;

/** Request body for fade cancellation. */
export interface FadeCancelRequest {
  /**
   * The deviceId for which the fade light effects need to cancelled.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId: string;
}

/** Request body for circadian cancellation. */
export interface CircadianCancelRequest {
  /**
   * The deviceId for which the circadian light effect needs to cancelled.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId: string;
}

/** map view info to update. Will not update the other rooms/devices in location */
export interface RoomsAndDevicesMapViewData {
  rooms?: RoomMapViewData[];
  devices?: DeviceMapViewData[];
}

export interface RoomMapViewData {
  /**
   * The UUID of the room.
   * @format uuid
   * @example "76275c80-21e2-68bb-1ea2-f8b965a38932"
   */
  roomId: string;
  /** Data used for indoor map. */
  indoorMap: {
    /**
     * The reference id for the map room. Setting this key to null deletes the map room from the room.
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
  };
}

export interface DeviceMapViewData {
  /**
   * The UUID of the device
   * @format uuid
   * @example "76275c80-21e2-68bb-1ea2-f8b965a38932"
   */
  deviceId: string;
  /** The location of a device on a floorplan map, if any. */
  indoorMap: IndoorMap;
}

/**
 * The location of a device on a floorplan map, if any.
 * @example {"coordinates":["1.0","2.0","3.0"],"rotation":["0","0","0"],"visible":true,"data":[{"extraData1":"some data"}]}
 */
export interface IndoorMap {
  /**
   * The coordinates to be used to map the device.
   * @maxItems 3
   * @minItems 3
   */
  coordinates?: number[];
  /**
   * The rotational data for the device.
   * @maxItems 3
   * @minItems 3
   */
  rotation?: number[];
  /** Whether or not the device is visible on the map. */
  visible?: boolean;
  /** Key value pairs to place additional information. */
  data?: Record<string, any>;
}

/** The id of SmartApp which this favorite belongs. Nullable. */
export type SmartAppId = string;

/**
 * The id of the container.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type ContainerId = string;

/** The type of container. */
export enum ContainerType {
  CAMERA_GROUPS = 'CAMERA_GROUPS',
  LIGHTING_GROUPS = 'LIGHTING_GROUPS',
  ROOM = 'ROOM',
  SCENES = 'SCENES',
  SMARTAPP = 'SMARTAPP',
  UNASSIGNED = 'UNASSIGNED',
  D2D = 'D2D',
}

/**
 * The id of a Thing the container is associated with.  Nullable.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type ContainerMemberId = string;

/** The sort order of the container */
export type ContainerSortOrder = number;

/** The type of SMARTAPP container */
export enum ContainerSmartappType {
  ENDPOINT = 'ENDPOINT',
  TARIFF = 'TARIFF',
  DEVICE = 'DEVICE',
}

/** Additional Id depending on the type of smartapp container. */
export type ContainerAdditionalId = string;

/** Whether the container should be displayed */
export type ContainerVisible = boolean;

export interface WrappedWallpaper {
  type: WallpaperType;
}

export interface Wallpaper {
  wallpaperId: string;
}

export enum WallpaperType {
  GRADIENT = 'GRADIENT',
  IMAGE = 'IMAGE',
  NOT_SET = 'NOT_SET',
}

/** A gradient wallpaper. */
export type Gradient = WrappedWallpaper & {
  /** A gradient wallpaper */
  gradient: GradientWallpaper;
};

/** A gradient wallpaper */
export type GradientWallpaper = Wallpaper & {
  /** hexadecimal value of start colour */
  startHex: string;
  /** hexadecimal value of end colour */
  endHex: string;
};

/** An image wallpaper. */
export type Image = WrappedWallpaper & {
  /** An image wallpaper */
  image: ImageWallpaper;
};

/** An image wallpaper */
export type ImageWallpaper = Wallpaper & {
  /** urls for wallpaper images */
  imageUrls: ImageUrls;
};

export interface WrappedLocationWallpaper {
  type: WallpaperType;
}

/** A not set wallpaper. */
export type LocationNotSet = WrappedLocationWallpaper & {
  /** A not set wallpaper */
  notSet: NotSetLocationWallpaper;
};

/** A not set wallpaper */
export type NotSetLocationWallpaper = LocationWallpaper;

/** A gradient wallpaper. */
export type LocationGradient = WrappedLocationWallpaper & {
  /** A gradient wallpaper */
  gradient: GradientLocationWallpaper;
};

/** A gradient wallpaper */
export type GradientLocationWallpaper = LocationWallpaper & {
  /** Id of the wallpaper. */
  wallpaperId: string;
  /** hexadecimal value of start colour */
  startHex: string;
  /** hexadecimal value of end colour */
  endHex: string;
};

/** An image wallpaper. */
export type LocationImage = WrappedLocationWallpaper & {
  /** An image wallpaper */
  image: ImageLocationWallpaper;
};

/** An image wallpaper */
export type ImageLocationWallpaper = LocationWallpaper & {
  /** Id of the wallpaper. null if the wallpaper hasn't been set */
  wallpaperId: string;
  /** urls for wallpaper images */
  imageUrls: ImageUrls;
};

export interface WrappedRoomWallpaper {
  type: WallpaperType;
}

/** A gradient wallpaper. */
export type RoomGradient = WrappedRoomWallpaper & {
  /** A gradient wallpaper */
  gradient: GradientRoomWallpaper;
};

/** A not set wallpaper. */
export type RoomNotSet = WrappedRoomWallpaper & {
  /** A not set room wallpaper */
  notSet: NotSetRoomWallpaper;
};

/** A not set room wallpaper */
export type NotSetRoomWallpaper = RoomWallpaper;

/** A gradient wallpaper */
export type GradientRoomWallpaper = RoomWallpaper & {
  /** Id of the wallpaper. */
  wallpaperId: string;
  /** hexadecimal value of start colour */
  startHex: string;
  /** hexadecimal value of end colour */
  endHex: string;
};

/** An image wallpaper. */
export type RoomImage = WrappedRoomWallpaper & {
  /** A image wallpaper */
  image: ImageRoomWallpaper;
};

/** A image wallpaper */
export type ImageRoomWallpaper = RoomWallpaper & {
  /** Id of the wallpaper. null if the wallpaper hasn't been set */
  wallpaperId: string;
  /** urls for wallpaper images */
  imageUrls: ImageUrls;
};

/** urls for wallpaper images */
export interface ImageUrls {
  /** Image urls for iOS */
  ios: IosUrls;
  /** Image urls for Android */
  android: AndroidUrls;
}

/** Image urls for iOS */
export interface IosUrls {
  portrait?: string;
  landscape?: string;
  drawer2x?: string;
  drawer3x?: string;
  listThumbnail2x?: string;
  listThumbnail3x?: string;
  list2x?: string;
  list3x?: string;
  thumbnail2x?: string;
  thumbnail3x?: string;
}

/** Image urls for Android */
export interface AndroidUrls {
  portrait?: string;
  drawer?: string;
  listThumbnail?: string;
  list?: string;
  previewThumbnail?: string;
}

/** Wallpaper for Location and Rooms in the location */
export interface WallpaperForLocationAndRooms {
  locationWallpaper?: WrappedLocationWallpaper;
  roomWallpapers?: WrappedRoomWallpaper[];
}

/** A typed model which describes a restriction pertaining to a platform entity. */
export interface Restriction {
  /** The restriction level of an entity to limit actions it can take. */
  tier: number;
  /** The number of days to retain the state before deletion. */
  historyRetentionTTLDays?: number;
  /**
   * Indicate whether or not the entity is visible when restricted.
   * @default false
   */
  visibleWhenRestricted?: boolean;
}

export interface OcfDeviceProfiles {
  items?: OcfDeviceProfile[];
}

/** @example {"commands":[{"component":"main","capability":"colorTemperature","command":"setColorTemperature","arguments":["30000"]}]} */
export interface DeviceCommandsRequest {
  /** An array of commands to execute on the Device. */
  commands?: DeviceCommand[];
}

export interface DeviceCommand {
  component: string;
  capability: string;
  command: string;
  arguments?: Operand[];
}

export interface BatchDeviceCommandsRequest {
  /** An array of commands to execute on the specified Device. */
  commands?: BatchDeviceCommand[];
}

export type BatchDeviceCommand = {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
} & DeviceCommand;

export interface DeviceEventsRequest {
  /**
   * An array of attribute state updates.
   * @maxItems 8
   * @minItems 1
   */
  deviceEvents?: DeviceStateEvent[];
}

export interface IdLessHealthState {
  /** Current state of the device */
  state?: 'ONLINE' | 'OFFLINE';
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/** A paginated array of Devices. */
export interface PagedDevices {
  items?: Device[];
  _links?: Links;
}

export interface Device {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The identifier for the owner of the device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "color.light.100x"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device manufacturer name.
   * @example "SmartThings"
   */
  manufacturerName: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * An non-unique id that is used to help drive UI information.
   * @example "VD-STV_2018_K"
   */
  presentationId: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /** The IDs of all locations this device is shared with. */
  sharedLocations?: SharedLocation[];
  /** The IDs of all compenents on the device. */
  components?: DeviceComponent[];
  /** The time when the device was created at. */
  createTime?: string;
  healthState?: IdLessHealthState;
  /** The id of the Parent device. */
  parentDeviceId?: string;
  /** Device details for all child devices of the device. */
  childDevices?: ChildDeviceRef[];
  profile?: DeviceProfileReference;
  /** Device Profile information for a SmartApp. This field will be empty if device type is not ENDPOINT_APP. */
  app?: AppDeviceDetails;
  /** Bluetooth device information. This field will be empty if device type is not BLE. */
  ble?: BleDeviceDetails;
  /** Bluetooth device to device information. This field will be empty if device type is not BLE_D2D. */
  bleD2D?: BleD2DDeviceDetails;
  /** Device Profile information for DTH. This field will be empty if device type is not DTH. */
  dth?: DthDeviceDetails;
  /** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
  lan?: LanDeviceDetails;
  /** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
  zigbee?: ZigbeeDeviceDetails;
  /** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
  zwave?: ZwaveDeviceDetails;
  /** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
  matter?: MatterDeviceDetails;
  /** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
  edgeChild?: EdgeChildDeviceDetails;
  /** HUB device information. This field will be empty if the device type is not HUB. */
  hub?: HubDeviceDetails;
  /** MOBILE device information. This field will be empty if the device type is not MOBILE. */
  mobile?: MobileDeviceDetails;
  /** IR device information. This field will be empty if device type is not IR. */
  ir?: IrDeviceDetails;
  /** IR_OCF device information. This field will be empty if device type is not IR_OCF. */
  irOcf?: IrDeviceDetails;
  /** OCF device information. This field will be empty if device type is not OCF. */
  ocf?: OcfDeviceDetails;
  /** Viper device information. This field will be empty if device type is not VIPER. */
  viper?: ViperDeviceDetails;
  /** Group device information. This field will be empty if device type is not GROUP. */
  group?: GroupDeviceDetails;
  /** Virtual device information. This field will be empty if device type is not VIRTUAL. */
  virtual?: VirtualDeviceDetails;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * *DEPRECATED* please use `presentationId`
   * Vendor id of the device, used for UI.
   */
  vid?: string;
  /**
   * *DEPRECATED* please use `manufacturerName`
   * Manufacturer model number, used for UI.
   */
  mnmn?: string;
  /** The OCF device type (resource), used for UI. */
  ocfDeviceType?: string;
  /** Restriction tier of the device, if any. */
  restrictionTier: number;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:devices - the user can change device details
   *   <li> w:devices:locationId - the user can move the device from a location
   *   <li> w:devices:roomId - the user can move or remove the device from a room
   *   <li> x:devices - the user can execute commands on the device
   *   <li> d:devices - the user can uninstall the device
   *   </ul>
   * @uniqueItems true
   */
  allowed?: 'w:devices' | 'w:devices:locationId' | 'w:devices:roomId' | 'x:devices' | 'd:devices';
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
  /** list of possible icon this particular device can have */
  possibleIcons: PossibleIcon[];
  icons: Icons;
  subgroupIcons?: SubGroupIcon[];
  badgeIcons?: BadgeIcons;
  /** the device is movable to other location */
  movable: boolean;
  /** If true the device is marked as hidden for the calling user. */
  hidden: boolean;
}

/**
 * The type of device integration.
 * All types besides ENDPOINT_APP will have profile populated.
 * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
 * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
 * If the type is IR, the details are in the "ir" field.
 * If the type is IR_OCF, the details are in the "irOcf" field.
 * If the type is VIPER, the details are in the "viper" field.
 */
export enum DeviceIntegrationType {
  APP = 'APP',
  BLE = 'BLE',
  BLED2D = 'BLE_D2D',
  DTH = 'DTH',
  ENDPOINT_APP = 'ENDPOINT_APP',
  GROUP = 'GROUP',
  HUB = 'HUB',
  IR = 'IR',
  IR_OCF = 'IR_OCF',
  LAN = 'LAN',
  MATTER = 'MATTER',
  MOBILE = 'MOBILE',
  MQTT = 'MQTT',
  OCF = 'OCF',
  PENGYOU = 'PENGYOU',
  SHP = 'SHP',
  VIDEO = 'VIDEO',
  VIPER = 'VIPER',
  VIRTUAL = 'VIRTUAL',
  WATCH = 'WATCH',
  ZIGBEE = 'ZIGBEE',
  ZWAVE = 'ZWAVE',
  EDGE_CHILD = 'EDGE_CHILD',
}

export interface AppDeviceDetails {
  /**
   * The ID of the installed app that integrates this device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  installedAppId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  profile?: DeviceProfileReference;
}

export type BleDeviceDetails = object;

export interface BleD2DDeviceDetails {
  /**
   * Security encryption key.
   * @example "96012869B606355A1F843B1E19DC31B1"
   */
  encryptionKey?: string;
  /**
   * Key for the decrypt.
   * @example "BMO_256-CBS-PKMS1Padding"
   */
  cipher?: string;
  /**
   * BLE Advertising Id.
   * @example "9C0D4219"
   */
  advertisingId?: string;
  /**
   * Unique device identifier.
   * @example "88-57-1d-0e-53-ab"
   */
  identifier?: string;
  configurationVersion?: string;
  /** @example "https://apisa.samsungiots.com/v1/miniature/profile/e524ceba-93b9-499d-a90a-24214f7f01cb" */
  configurationUrl?: string;
  metadata?: object;
}

export interface DeviceProfileReference {
  /**
   * The device profile Id
   * @example "a7b3c264-2d22-416e-bca1-ca4b59a60aee"
   */
  id?: string;
}

export interface DthDeviceDetails {
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup: boolean;
  /** The device network type. */
  deviceNetworkType?: DeviceNetworkType;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  deviceTypeId: string;
  /**
   * The name for the device's DeviceType.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * The ID of the installed groovy application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8f5ra619-4c05-4a90-a245-cc129b0a8098"
   */
  installedGroovyAppId?: string;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
}

/**
 * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
 * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
 * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
 * @default "UNKNOWN"
 */
export enum DeviceNetworkSecurityLevel {
  UNKNOWN = 'UNKNOWN',
  ZWAVE_LEGACY_NON_SECURE = 'ZWAVE_LEGACY_NON_SECURE',
  ZWAVES0LEGACY = 'ZWAVE_S0_LEGACY',
  ZWAVES0FALLBACK = 'ZWAVE_S0_FALLBACK',
  ZWAVES2UNAUTHENTICATED = 'ZWAVE_S2_UNAUTHENTICATED',
  ZWAVES2AUTHENTICATED = 'ZWAVE_S2_AUTHENTICATED',
  ZWAVES2ACCESSCONTROL = 'ZWAVE_S2_ACCESS_CONTROL',
  ZWAVES2FAILED = 'ZWAVE_S2_FAILED',
  ZWAVES0FAILED = 'ZWAVE_S0_FAILED',
  ZWAVES2DOWNGRADE = 'ZWAVE_S2_DOWNGRADE',
  ZWAVES0DOWNGRADE = 'ZWAVE_S0_DOWNGRADE',
}

/** True if the device is executing locally on the hub */
export type ExecutingLocally = boolean;

/** object to query device components status */
export interface DeviceStatusQuery {
  components?: Record<string, ComponentStatusQuery>;
  healthState?: any;
}

/** object to query component capabilities status */
export interface ComponentStatusQuery {
  capabilities?: Record<string, CapabilityStatusQuery>;
}

/** object to query capability attributes status */
export interface CapabilityStatusQuery {
  attributes?: string[];
}

export interface IrDeviceDetails {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCode?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDeviceDetails[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

export interface OcfDeviceDetails {
  /** OCF device type */
  ocfDeviceType?: string;
  /** Name of the device */
  name?: string;
  /** OCF spec version */
  specVersion?: string;
  /** OCF vertical domain spec version */
  verticalDomainSpecVersion?: string;
  /** OCF manufacturer name */
  manufacturerName?: string;
  /** OCF model number */
  modelNumber?: string;
  /** OCF platform version */
  platformVersion?: string;
  /** OCF platform OS */
  platformOS?: string;
  /** OCF platform H/W version */
  hwVersion?: string;
  /** OCF firmware version */
  firmwareVersion?: string;
  /** OCF vendor ID */
  vendorId?: string;
  /** OCF vendor resource client/server version */
  vendorResourceClientServerVersion?: string;
  /** Language code */
  locale?: string;
  /** The time when the device is signed up lastly */
  lastSignupTime?: string;
}

/** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
export interface LanDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
export interface ZigbeeDeviceDetails {
  /** The EUID of the Zigbee device */
  eui?: DeviceEui;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/**
 * 16-bit manufacturer identifier assigned by the Z-Wave Specification
 * @min 0
 * @max 65535
 * @example 134
 */
export type ZWaveManufacturerId = number;

/**
 * 16-bit manufacturer defined product type
 * @min 0
 * @max 65535
 * @example 17488
 */
export type ZWaveProductType = number;

/**
 * 16-bit manufacturer defined product identifier
 * @min 0
 * @max 65535
 * @example 12336
 */
export type ZWaveProductId = number;

/** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
export interface ZwaveDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product type */
  productType?: ZWaveProductType;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
}

/** Device Profile information for Matter devices. This field will be empty if the device type is not MATTER */
export interface MatterDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** Vendor-supplied unique identifier. Optional. */
  uniqueId?: string;
  /** 16-bit vendor id. Optional. */
  vendorId?: number;
  /** 16-bit product id. Optional. */
  productId?: number;
  /** Listening type for the device. Optional. */
  listeningType?: MatterListeningType;
  /** List of network interfaces. Optional. */
  supportedNetworkInterfaces?: MatterNetworkInterfaces;
  /** Hardware and Software version info for matter devices. Optional. */
  version?: MatterVersion;
  /** Available Matter endpoints */
  endpoints?: MatterEndpoints;
  /** Determines whether or not to sync the child device's driver from its parent. Default is true. */
  syncDrivers?: SyncDrivers;
}

/** Device Profile information for Edge Child devices. This field will be empty if the device type is not EDGE_CHILD */
export interface EdgeChildDeviceDetails {
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The identifier assigned to this edge child device by its parent */
  parentAssignedChildKey?: ParentAssignedChildKey;
}

/** The network-specific identifier of the device on the network */
export type DeviceNetworkId = string;

/**
 * The identifier for the Device instance.
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */
export type DeviceId = string;

/**
 * The EUID of the Zigbee device
 * @example "24FD5B000105DB96"
 */
export type DeviceEui = string;

/**
 * The device network type.
 * @example "ZIGBEE"
 */
export type DeviceNetworkType = string;

/**
 * The ID of the Sprocket driver
 * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
 * @example "9314a926-528c-403f-ae56-4b0d059381dd"
 */
export type DriverId = string;

/** Listening type for the device. Optional. */
export enum MatterListeningType {
  ALWAYS = 'ALWAYS',
  SLEEPY = 'SLEEPY',
}

/** Hardware and Software version info for matter devices. Optional. */
export interface MatterVersion {
  /**
   * 16-bit hardware version. Optional.
   * @min 0
   * @max 65535
   * @example 771
   */
  hardware?: number;
  /** Label for the hardware version. Optional. */
  hardwareLabel?: string;
  /**
   * 32-bit software version. Optional.
   * @min 0
   * @max 4294967295
   * @example 50529027
   */
  software?: number;
  /** Label for the hardware version. Optional. */
  softwareLabel?: string;
}

/** List of network interfaces. Optional. */
export type MatterNetworkInterfaces = MatterNetworkInterface[];

/** Supported Network Interfaces of the Device */
export enum MatterNetworkInterface {
  THREAD = 'THREAD',
  WIFI = 'WIFI',
  ETHERNET = 'ETHERNET',
}

/** Available Matter endpoints */
export type MatterEndpoints = MatterEndpoint[];

/** Matter device endpoint */
export interface MatterEndpoint {
  /**
   * 16-bit identifier for the endpoint
   * @min 0
   * @max 65535
   * @example 771
   */
  endpointId?: number;
  /** List of device types for the endpoint */
  deviceTypes?: MatterEndpointDeviceType[];
}

/** Device type for a matter endpoint */
export interface MatterEndpointDeviceType {
  /**
   * 32-bit identifier for the device type
   * @min 0
   * @max 4294967295
   * @example 197379
   */
  deviceTypeId?: number;
}

/**
 * Determines whether or not to sync the child device's driver from its parent. Default is true.
 * @example true
 */
export type SyncDrivers = boolean;

/** The identifier assigned to this edge child device by its parent */
export type ParentAssignedChildKey = string;

/**
 * The hub that the device is connected to.
 * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
 */
export type HubId = string;

/** Provisioning type for a widget device */
export enum ProvisioningState {
  PROVISIONED = 'PROVISIONED',
  TYPED = 'TYPED',
  DRIVER_SWITCH = 'DRIVER_SWITCH',
  NONFUNCTIONAL = 'NONFUNCTIONAL',
}

/** MOBILE device information. This field will be empty if the device type is not MOBILE. */
export type MobileDeviceDetails = object;

export interface HubDriver {
  /** The version of the driver revision being returned */
  driverVersion?: string;
  /**
   * The identifier of the Sprocket driver
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  driverId: string;
  /**
   * The identifier of the Sprocket channel
   * @format uuid
   * @example "9314a926-528c-403f-ae56-4b0d059381dd"
   */
  channelId?: string;
}

/**
 * Possible Values for Hub Characteristic "Availability" flags
 * @example "Available"
 */
export enum AvailabilityCharacteristic {
  Available = 'Available',
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

/**
 * Describes state of Zigbee OTA.
 * @default "DISABLED"
 */
export enum ZigbeeOta {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  ENABLED_WITH_LIGHTS = 'ENABLED_WITH_LIGHTS',
}

export interface ChildDeviceRef {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  id?: string;
}

export interface SharedLocation {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  locationId?: string;
}

export interface ViperDeviceDetails {
  /** @example "1a-74" */
  uniqueIdentifier?: string;
  /** @example "TP-Link" */
  manufacturerName?: string;
  /** @example "HS101" */
  modelName?: string;
  /** @example "23.123.231" */
  swVersion?: string;
  /** @example "v1 US bulb" */
  hwVersion?: string;
  /** @example "viper_bb238c20-675a-11ed-970f-571777eb58c5" */
  endpointAppId?: string;
}

/** An array of devices in the group */
export interface DeviceGroupDevice {
  /**
   * GUID representing the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
   */
  deviceId: string;
  /** Components to add to the group */
  components?: {
    /** @example "main" */
    id?: string;
    [key: string]: any;
  }[];
}

export interface VirtualDeviceDetails {
  /** Name of the device */
  name?: string;
  /** The hub that the device is connected to. */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  commandMappings?: CommandMappings;
}

export interface CommandMappings {
  commands?: CommandMapping[];
}

/**
 * A mapping of `commandName` to `attribute.value` that will allow users to support complex commands that would otherwise
 * not be determinable simply by the capabililty contract.
 */
export interface CommandMapping {
  /** The Capability ID. */
  capabilityId: string;
  /** The Capability version number. */
  version: number;
  /** The command name to apply the mapping to on the device */
  command: string;
  /** A collection of attribute values, replicator will use these to create device events in serial for the specified command. */
  eventValues: AttributeValue[];
}

/** The description of an attribute value that will be used to populate an event. */
export interface AttributeValue {
  /** The attribute that this command will correspond to */
  attribute?: string;
  /** How will the attribute be provided? Choose either to provide it with a command at runtime or to provide a set value here. */
  inputType?: 'STATIC' | 'ARGUMENT';
  /** The argument to be used automatically for this command mapping. Any simple type is accepted. */
  staticValue?: object;
}

export interface PagedDeviceComponents {
  items?: DeviceComponent[];
  _links?: Links;
}

export interface UpdateDeviceComponent {
  /** @example "main" */
  id: string;
  /**
   * The label for the device component.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light switch 2"
   */
  label?: string;
  /**
   * Identifier allowing the user to pick a custom icon for the device component.
   * The icon of the main component represents the device itself
   * @minLength 1
   * @maxLength 255
   */
  icon?: string;
  /**
   * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). Allows the user to redefine the category of the device from what the manufacturer set by default.
   * @maxItems 1
   * @minItems 1
   */
  categories: string[];
}

export interface UpdateDeviceRequest {
  /**
   * The label for the Device.
   * @minLength 1
   * @maxLength 255
   * @example "Living room light"
   */
  label?: string;
  /**
   * The ID of the Location where the Device should be moved to.
   * Not all Devices support Location moves.
   * Moving between some Locations may be rejected depending on the data region used.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The ID of the Room with which to associate the Device is associated.
   * The Room must be valid for the Location of the Device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /** key of the icon to set on the device */
  iconKey?: string;
  /** The location of a device on a floorplan map, if any. */
  indoorMap?: IndoorMap;
}

/** HUB device information. This field will be empty if the device type is not HUB. */
export interface HubDeviceDetails {
  /**
   * The unique identifier for this manufactured hub.
   * @format ^[0-9A-F]{16}$
   * @example "D053A8B4F6D80001"
   */
  hubEui: string;
  /**
   * The hub's firmware version
   * @format ^[0-9]\.[0-9]\.[0-9]{3}$
   * @example ""
   */
  firmwareVersion: string;
  /** A list of drivers installed on the hub */
  hubDrivers: HubDriver[];
  hubData: {
    /**
     * Zwave static DSK for the hub.
     * @example "21720-31296-41384-03009-58023-25366-38831-43982"
     */
    zwaveStaticDsk?: string;
    /** Whether zwaveS2 is enabled for this hub. */
    zwaveS2: boolean;
    /**
     * The hardwareType for this hub
     * @example "V3_HUB"
     */
    hardwareType: string;
    /**
     * The hub's hardware ID
     * @example "00A2"
     */
    hardwareId?: string;
    /**
     * The Zigbee firmware version for this hub
     * @example "5.4.0"
     */
    zigbeeFirmware?: string;
    /** Whether the hub supports zigbee3 */
    zigbee3: boolean;
    /** Describes state of Zigbee OTA. */
    zigbeeOta?: ZigbeeOta;
    /** Indicates if Zigbee OTA is enabled. */
    otaEnable?: string;
    /** Whether the hub allows zigbee unsecure rejoin */
    zigbeeUnsecureRejoin: boolean;
    /** Possible Values for Hub Characteristic "Availability" flags */
    primarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    secondarySupportAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zigbeeAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    zwaveAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    threadAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    lanAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    matterAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    localVirtualDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    childDeviceAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    edgeDriversAvailability?: AvailabilityCharacteristic;
    /** Possible Values for Hub Characteristic "Availability" flags */
    hubReplaceAvailability?: AvailabilityCharacteristic;
    /** The primary hub device id for this hub. Null/Empty if hub is not a repeater. */
    primaryHubDeviceId?: string;
    /** The Zigbee Channel of the Hub. */
    zigbeeChannel?: string;
    /** The Personal Area Network (PAN) id of the zigbee network the hub is on. */
    zigbeePanId?: string;
    /** The unique identifier for this manufactured hub. */
    zigbeeEui?: string;
    /** The short address of a node in Zigbee network. */
    zigbeeNodeID?: string;
    /** The address of a single node in the network */
    zwaveNodeID?: string;
    /** The common identification of all nodes belonging to one logical Z-Wave network */
    zwaveHomeID?: string;
    zwaveSucID?: string;
    zwaveVersion?: string;
    /** The global region this zwave radio is operating in. */
    zwaveRegion?: string;
    /** MAC address of the hubs network interface. */
    macAddress?: string;
    /** IP address of the hub. */
    localIP?: string;
    /** Whether the hub is zigbee radio functional. */
    zigbeeRadioFunctional?: boolean;
    /** Whether the hub is zwave radio functional. */
    zwaveRadioFunctional?: boolean;
  };
}

export interface DeviceComponent {
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /** UTF-8 label for the component. */
  label?: string;
  capabilities: DeviceCapabilityReference[];
  /** Defines the categories for the device. There can be up to 2, one defined by the manufacturer the other is a user selected value. */
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
  /** A user selected icon value */
  icon?: string;
}

export interface CapabilityConfiguration {
  values: CapabilityConfigurationValue[];
}

export interface CapabilityConfigurationValue {
  /**
   * The path to the preference attribute that is being configured.
   * @example "thermostatMode.value"
   */
  key: string;
  /**
   * The range of values supported by the capability attribute. The range must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @maxItems 2
   * @minItems 2
   * @example "[1, 50]"
   */
  range?: number[];
  /**
   * The list of enumerated values that are supported for the capability attribute. The list of supported value must be a subset of the one defined on the capability. Either `range` OR `enabledValues` must be provided, not both.
   * @example "[ "cooling", "fan only", "heating", "idle" ]"
   */
  enabledValues?: string[];
  /**
   * The incremental step that increases or decreases for numeric values.
   * @format double
   * @default 1
   */
  step?: number;
}

export interface BaseCapabilityReference {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

export type CapabilityReferenceRequest = BaseCapabilityReference & {
  config?: CapabilityConfiguration;
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
};

export type CapabilityReference = CapabilityReferenceRequest & {
  /** @example false */
  ephemeral?: boolean;
};

export type DeviceCapabilityReference = CapabilityReference & {
  /** A map of Attribute name to Attribute state. */
  status?: CapabilityStatus;
};

/** The status of a Device. */
export interface DeviceStatus {
  /**
   * A map of componentId to Component status.
   * @example {"main":{"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}}
   */
  components?: Record<string, ComponentStatus>;
  healthState?: {
    /** Current state of the device */
    state?: 'ONLINE' | 'OFFLINE';
    /**
     * Last reported date/time in UTC
     * @format date-time
     */
    lastUpdatedDate?: string;
  };
}

/**
 * A map of capabilityId to Capability status.
 * @example {"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}
 */
export type ComponentStatus = Record<string, CapabilityStatus>;

/**
 * A map of Attribute name to Attribute state.
 * @example {"switch":{"value":"on"}}
 */
export type CapabilityStatus = Record<string, AttributeState>;

export interface AttributeState {
  /** @example 0 */
  value?: object;
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

/** @example {"component":"main","capability":"switchLevel","attribute":"level","value":0,"unit":null,"data":null} */
export interface DeviceStateEvent {
  /** The name of the component on this device, default is 'main'. */
  component?: string;
  /** Capability that this event relates to. */
  capability?: string;
  /** Name of the capability attribute that this event relates to. */
  attribute?: string;
  /** Value associated with the event. The valid value depends on the capability. */
  value: object;
  /** Unit of the value field. */
  unit?: string;
  /** Key value pairs about the state of the device. Valid values depend on the capability. */
  data?: Record<string, object>;
  /** The id on the command that triggered this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
}

export interface CreateBackendEventsResponse {
  /** The list of state changes for each event created in the order in the create request */
  stateChanges?: boolean[];
}

export type CreateDeviceEventsResponse = object;

export interface DeviceCommandsResponse {
  results?: CommandResult[];
}

export interface CommandResult {
  /**
   * A UUID used for tracking the individual command.
   * @format uuid
   */
  id?: string;
  /**
   * `ACCEPTED`: the command is processing but it's outcome is unknown
   * `COMPLETED`: the command has successfully completed
   * `FAILED`: the command has failed
   */
  status?: CommandStatus;
}

/**
 * `ACCEPTED`: the command is processing but it's outcome is unknown
 * `COMPLETED`: the command has successfully completed
 * `FAILED`: the command has failed
 */
export enum CommandStatus {
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type CreateBatchDeviceCommandsResponse = object;

export interface BackendInstallRequest {
  /**
   * The id that should be used for the device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  deviceId?: string;
  /**
   * The owner id of the device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  ownerId?: string;
  /**
   * The name that the device integration defines for the device.
   * @minLength 1
   * @maxLength 255
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The display label for the device.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @maxLength 255
   */
  label?: string;
  /** The location id that the device will be installed on. */
  locationId: string;
  /**
   * The id of the parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /** The device profile id that describes the components and capabilities. */
  profileId: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * The device manufacturer code.
   * @maxLength 255
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @maxLength 255
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * Key that is used to chose the base url for requests from Gizmo to the backend.
   * @example "eu"
   */
  routingKey?: string;
  /**
   * Room containing this device
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  roomId?: string;
  components?: {
    /** @example "main" */
    id: string;
    /** @example "main" */
    label?: string;
    /**
     * A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories).
     * @maxItems 1
     * @minItems 1
     */
    categories: string[];
  }[];
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * Key value pairs stored in the conductor for the device.
   * These are returned with requests to the backend.
   */
  metadata?: Record<string, object>;
  /** A value that will need to be included in update and event requests in the 'X-ST-DEVICE-SECRET' header */
  secret?: string;
  /** Optional - the definition of the device profile that this device should use. */
  deviceProfileOverride?: DeviceProfile;
}

export interface BackendUpdateRequest {
  /**
   * The owner id of the device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  ownerId?: string;
  /** The device profile id that describes the components and capabilities. */
  profileId?: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * The device manufacturer code.
   * @minLength 1
   * @maxLength 255
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @maxLength 255
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * The name that the device integration defines for the device.
   * @minLength 1
   * @maxLength 255
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @minLength 0
   * @maxLength 255
   * @example "My light"
   */
  label?: string;
  components?: {
    /** @example "main" */
    id: string;
    /** @example "main" */
    label?: string;
  }[];
  /**
   * Key that is used to chose the base url for requests from Gizmo to the backend.
   * @example "eu"
   */
  routingKey?: string;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type?: DeviceIntegrationType;
  /** The parent to associate the device with. This is primarily for migration of devices. */
  parentDeviceId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * Key value pairs stored in the conductor for the device.
   * These are returned with requests to the backend.
   */
  metadata?: Record<string, any>;
  /** A value that will need to be included in update and event requests in the 'X-ST-DEVICE-SECRET' header */
  secret?: string;
  /** Optional - the definition of the device profile that this device should use. */
  deviceProfileOverride?: DeviceProfile;
}

export interface PagedBackendDevices {
  items?: BackendDevice[];
  _links?: Links;
}

export interface BackendDevice {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId?: string;
  /**
   * The identifier for the owner of the device instance.
   * @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc"
   */
  ownerId?: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @format ^([\S]{1}|[\S]+.*?[\S]+)$
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The ID of the Room with which the device is associated. If the device is not associated with any room, then this field will be null.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0fd2b1ef-1b33-4a54-9153-65aca91e9660"
   */
  roomId?: string;
  /**
   * The identifier for the parent device.
   * @example "40cad82b-61a5-4bd8-9161-b06bf51525e7"
   */
  parentDeviceId?: string;
  /** Device ids for all child devices of the device. */
  childDeviceIds?: string[];
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type?: DeviceIntegrationType;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  profileId: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /**
   * Key that is used to chose the base url for requests from Gizmo to the backend.
   * @example "eu"
   */
  routingKey?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  /**
   * Key value pairs that were stored in the conductor for the device.
   * If the metadata contains a "public" key that will be included in the details based on the backend type through
   * the public API, only keys that are defined in the swagger will be populated.
   * If "mnmn", "vid", "ocfDeviceType" keys are present they will override values from the device profile.
   * If the metadata includes "deviceNetworkId" it will be synchronized to DM.
   */
  metadata?: Record<string, object>;
}

export interface BackendDeviceEventsRequest {
  /**
   * An array of attribute state updates.
   * @maxItems 8
   * @minItems 1
   */
  deviceEvents?: DeviceEvent[];
}

export interface DeviceEvent {
  /** @example "main" */
  componentId?: string;
  /** @example "switch" */
  capability?: string;
  /** @example "switch" */
  attribute?: string;
  /** The id on the command that trigged this event, if applicable. Used for correlation of commands to events. */
  commandId?: string;
  state?: AttributeState;
  visibility?: EventVisibilityData;
  providerData?: DeviceEventProviderData;
}

export interface EventVisibilityData {
  /**
   * Indicates whether the event should be displayed in the history feed.
   * This is used because some device attributes are very chatty.
   */
  displayed?: boolean;
  /**
   * Indicates if the event cannot be stored for longer than the standard 7 day recent history.
   * This can be based on legal obligations.
   */
  nonArchivable?: boolean;
  /**
   * Indicates whether the event history should be stored in recent history (7 days).
   * This can be based on legal obligations.
   */
  ephemeral?: boolean;
}

export interface DeviceEventProviderData {
  /**
   * The UNIX time that the event occured according to the provider.
   * @format int64
   */
  timestamp?: number;
  /**
   * An increasing 64 bit (long) number that represents an ordering of events from the producer.
   * Higher numbers represent more recent events. If this is provided it will be taken into
   * consideration in state change determination but will not affect broadcast of the event.
   * There may be gaps in the sequence.
   * @format int64
   * @example 797606
   */
  sequenceNumber?: number;
  /**
   * A foreign event id used to correlate logs.
   * @maxLength 36
   */
  eventId?: string;
  /**
   * If the provider knows if the event represents a state change they may signal that.
   * Even if the event is not considered a state change from the provider the state of the device
   * may be updated if it is out of sync.
   * @default "UNKNOWN"
   */
  stateChange: 'Y' | 'N' | 'UNKNOWN';
  /**
   * Event data that is not translated into SmartThings capabilities.
   * @maxLength 1000
   */
  rawData?: string;
}

/**
 * the status of the requested device group
 * @example {"deviceGroupId":"457d79d1-4685-4852-89b6-e2fc681a590f","devices":{"dev1":{"components":{"main":{"switch":{"switch":{"value":["on"]}}}}},"dev2":{"components":{"subComponent":{"switch":{"switch":{"value":["off"]}}}}}},"groupAggregate":{"switch":{"switch":{"value":["off"]}}}}
 */
export interface DeviceGroupStatusResponse {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  deviceGroupId?: string;
  devices?: Record<
    string,
    {
      /**
       * A map of componentId to Component status.
       * @example {"main":{"switch":{"switch":{"value":"on"}},"switchLevel":{"level":{"value":90}}}}
       */
      components?: Record<string, ComponentStatus>;
      healthState?: {
        /** Current state of the device */
        state?: 'ONLINE' | 'OFFLINE';
        /**
         * Last reported date/time in UTC
         * @format date-time
         */
        lastUpdatedDate?: string;
      };
    }
  >;
  groupAggregate?: Record<string, Record<string, AttributeState>>;
}

export interface InternalDevice {
  /**
   * the device id
   * @example "51b5dc55-f856-49cd-bf89-da6f54e244b2"
   */
  id: string;
  /**
   * The name that the device integration (Device Handler or SmartApp) defines for the device.
   * @example "color.light.100x"
   */
  name: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "Joe's room light"
   */
  label: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  deviceManufacturerCode?: string;
  /**
   * The device model.
   * @example "FGMS-001"
   */
  deviceModel?: string;
  /**
   * Used to communicate a unique identifier to DM so that things like the Alexa integration can recognize the
   * uniqueness of the device. We are using this field because it exists in DM and is not used by profile based
   * devices yet.
   */
  deviceNetworkId?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  mnmn?: string;
  /**
   * The User UUID for the owner of the device when applicable
   * @format uuid
   */
  ownerId?: string;
  vid?: string;
  ocfDeviceType?: string;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  type: DeviceIntegrationType;
  /**
   * Device creation time (since epoch)
   * @format int64
   * @example 1634226746547
   */
  dateCreated?: number;
  /**
   * the external id for the device (foreign system id)
   * @example "switch-123"
   */
  externalId?: string;
  /**
   * the installed app id (owner) for ENDPOINT_APP device type
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  installedAppId?: string;
  /**
   * the device profile id if applicable for the device type
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  profileId?: string;
  /**
   * the Groovy installed app id for DTH device type
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  installedGroovyAppId?: string;
  /** a list of components for DTH (non profile) type devices */
  components?: {
    /** @example "main" */
    id?: string;
    /** @example "comp1" */
    label?: string;
    /**
     * The identifier for the device's DeviceType.
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
     */
    deviceTypeId?: string;
  }[];
  /**
   * The name for the device's DeviceType for DTH type devices.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName?: string;
  /**
   * The device network type if applicable for DTH type devices.
   * @example "ZWAVE"
   */
  deviceNetworkType?: string;
  /**
   * The hub that the device is connected to.
   * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
   */
  hubId?: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: boolean;
  /**
   * The room of the device.
   * @example "f7239728-edb3-48e9-b588-a27f30b968a0"
   */
  roomId?: string;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel: DeviceNetworkSecurityLevel;
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup?: boolean;
  /**
   * A value that will need to be included in update and event requests in the 'X-ST-DEVICE-SECRET' header to Gizmo.
   * This will be used in the migration to Peddler for device events and should be a key for the Hub so only that
   * can cause updates to the device.
   */
  secret?: string;
  /**
   * The id of this device's parent.
   * @example "f7239728-edb3-48e9-b588-a27f30b968a9"
   */
  parentDeviceId?: string;
}

export interface InternalCommands {
  actor?: {
    actorType?: 'GROOVY_APP' | 'USER';
    groovyApp?: {
      installedAppId?: string;
    };
    user?: {
      clientId?: string;
      userId?: string;
    };
  };
  commands?: DeviceCommand[];
}

export type JsonObject = Record<string, object>;

export type DeleteDeviceCommandsResponse = object;

export interface PagedDeviceCategories {
  items?: DeviceCategoryDetails[];
  _links?: Links;
}

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategoryDetails {
  /** @example "Light" */
  name: string;
  /** @example "oic.d.light" */
  resourceType: string;
}

/** A case-sensitive string from the pre-defined list of valid categories [/devicecategories](#/operation/listCategories). */
export interface DeviceCategory {
  /** @example "Light" */
  name: string;
  /** @default "manufacturer" */
  categoryType: 'manufacturer' | 'user';
}

export interface GroupDeviceDetails {
  /** @example "My Group" */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  devices?: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "747d79d3-4685-4852-89b6-e2fc681a590f"
     */
    deviceId: string;
    /** Components to add to the group */
    components?: {
      /** @example "main" */
      id?: string;
      [key: string]: any;
    }[];
  }[];
}

/**
 * The type of the group in question
 *
 * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
 */
export enum DeviceGroupType {
  UNDETERMINED = 'UNDETERMINED',
  GENERIC = 'GENERIC',
  VIDEO_CAMERA = 'VIDEO_CAMERA',
  LIGHTING = 'LIGHTING',
}

/** @example {"groupName":"helloWorldGroup","deviceGroupId":"457d79d1-4685-4852-89b6-e2fc681a590f","devices":{"30d3691f-2416-4cbc-b193-2329581f300d2":{"components":{"main":{"switch":{"switch":{"value":["on"]}}}}},"30d7421f-2416-4cbc-b193-2329581f29d1":{"components":{"subComponent":{"switch":{"switch":{"value":["off"]}}}}}},"groupAggregate":{"switch":{"switch":{"value":["off"]}}}} */
export interface DeviceGroupStatusGizmoResponse {
  /** Name of the group created */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  deviceGroupId?: string;
  devices?: Record<string, DeviceStatus>;
  groupAggregate?: Record<string, CapabilityStatus>;
}

/** @example {"switch":{"switch":{"value":"on","unit":null}}} */
export type DeviceAttributesPerCapability = Record<string, DeviceAttributes>;

/** @example {"switch":{"value":"on","unit":null}} */
export type DeviceAttributes = Record<string, AttributeData>;

export interface AttributeData {
  value?: object;
  unit?: string;
  data?: Record<string, any>;
}

export interface DeviceGroupCommandRequest {
  /** An array of commands to execute on the Device. */
  commands?: DeviceGroupCommand[];
}

/** @example {"capability":"switchLevel","command":"setLevel","arguments":[100,1]} */
export interface DeviceGroupCommand {
  capability?: string;
  command?: string;
  arguments?: object[];
}

export type DeviceGroupCommandResponse = Record<string, any>;

export type DeviceGroupUpdateDeviceRequest = Record<string, any>;

export type DeviceGroupDeleteDeviceResponse = Record<string, any>;

export type DeviceGroupUpdateDeviceResponse = Record<string, any>;

/** The capability that is common to all devices in the group */
export interface DeviceGroupCapability {
  /** @example "switch" */
  id: string;
  /** @example 1 */
  version?: number;
}

/** Internal device group representation */
export interface InternalDeviceGroup {
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "457d79d1-4685-4852-89b6-e2fc681a590f"
   */
  deviceGroupId?: string;
  /** Name of the group created */
  groupName?: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: DeviceGroupType;
}

/**
 * An object to represent a device belonging to room.
 * @example {"deviceId":"30d3691f-2416-4cbc-b193-2329581f29d1"}
 */
export interface AddRoomDeviceInfo {
  /** @example "30d3691f-2416-4cbc-b193-2329581f29d1" */
  deviceId: string;
  /** Future field , currently not used (Device order within the room) */
  sortOrder?: number;
}

/** A request object to add devices to room */
export interface AddDevicesToRoomRequest {
  items: AddRoomDeviceInfo[];
}

/** A request object to update the device profile for a specific device */
export interface UpdateDeviceProfileRequest {
  /**
   * The updated device profile ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  profileId?: string;
}

/** @example {} */
export type AddDevicesToRoomResponse = object;

/** A request object to delete devices from room. */
export interface RemoveDevicesFromRoomRequest {
  devices: string[];
}

/** @example {} */
export type RemoveDevicesFromRoomResponse = object;

export interface PagedRoomDevices {
  items?: Device[];
  _links?: Links;
}

export interface DeviceHealthState {
  /** Id of the device */
  deviceId: string;
  state: HealthState;
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate: string;
}

export interface InternalDeviceHealthRequest {
  /** Id of the device */
  deviceId?: string;
  state: HealthState;
  /**
   * Last reported date/time in UTC
   * @format date-time
   */
  lastUpdatedDate?: string;
}

export interface UpdateDeviceHealthRequest {
  /**
   * Health state to set the root device to.
   * Can be null if descendants value provided, required otherwise.
   */
  state?: HealthState;
  /**
   * Flat list of state updates for descendants anywhere in the subtree.
   *
   * Use this to control the state of a subset of the children at once i.e. a radio is down.
   * Parent being offline still overrules child state.
   */
  descendants?: UpdateChildDeviceHealth[];
}

export interface UpdateChildDeviceHealth {
  deviceId: string;
  /** value to set child devices health state to */
  state: HealthState;
}

export enum HealthState {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export interface DeviceHealthEnrollmentResponse {
  /** The minimum number of seconds between pings to the device. Null when the device is not configured to be monitored. */
  checkInterval?: number;
  /**
   * Flat list of all descendants enrollment data. Only present if children requested.
   * @minItems 0
   */
  descendants?: DescendantDeviceHealthEnrollment[];
}

export interface DescendantDeviceHealthEnrollment {
  deviceId: string;
  /** The number of seconds between pings to the device. Null when the device is not configured to be monitored. */
  checkInterval?: number;
}

export interface DeviceIntegrationProfileKey {
  /**
   * Unique identifier for integration profile.
   * @format uuid
   */
  id: string;
  /**
   * Major Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  majorVersion: number;
  /**
   * Minor Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  minorVersion?: number;
  /**
   * @format uuid
   * @example "a362ddb6-349b-4650-9911-681b51069a57"
   */
  overrideProfileId?: string;
}

export interface DeviceProfile {
  /**
   * A name for the implicit profile. Names have no uniqueness or null constraints.
   * @format ^(?!\s)[-_!.~'() *0-9a-zA-Z\p{L}]{1,100}(?<!\s)$
   * @minLength 1
   * @maxLength 100
   * @example "thermostat1.model1"
   */
  name?: string;
  /**
   * A list of components for this profile. Exactly 1 component ID must be `main`.
   * @maxItems 20
   * @minItems 1
   */
  components: DeviceComponentRequest[];
  /** Additional information about the device profile, limited to 10 entries. */
  metadata?: DeviceProfileMetadata;
  /** The restriction to limit actions a device can take. */
  restrictions?: DeviceRestriction;
  /** A list of preferences for this profile, whether implicit or explicit. */
  preferences?: PreferenceRequest[];
  config?: DeviceProfileConfig;
}

export type DeviceProfileResponse = DeviceProfileBase &
  DeviceProfileMigrationStatus & {
    /**
     * The lifecycle status of a device profile.
     * 'DEVELOPMENT' - Device profile can be modified. The profile is only available to the developer and can only be used with a self-published app.
     * 'PUBLISHED' - Device profile can be shared with other users, but cannot be modified.
     */
    status?: DeviceProfileStatus;
    preferences?: PreferenceResponse[];
    components?: DeviceComponent[];
  };

export interface DeviceProfileBase {
  /** @example "a362ddb6-349b-4650-9911-681b51069a57" */
  id?: string;
  /** @example "thermostat1.model1" */
  name?: string;
  /** Additional information about the device profile, limited to 10 entries. */
  metadata?: DeviceProfileMetadata;
  /** The restriction to limit actions a device can take. */
  restrictions?: DeviceRestriction;
}

/**
 * Additional information about the device profile, limited to 10 entries.
 * @example {"firmWareVersion":"0.2.123","manufacturerName":"SmartThingsCommunity"}
 */
export type DeviceProfileMetadata = any;

/** The restriction to limit actions a device can take. */
export type DeviceRestriction = Restriction;

/** Describes the migration status (from v1 -> v2). This profile will be available in a backwards compatible fashion regardless. */
export interface DeviceProfileMigrationStatus {
  /** @default "NOT_MIGRATED" */
  migrationStatus: 'MIGRATED' | 'NOT_MIGRATED';
}

/**
 * The lifecycle status of a device profile.
 * 'DEVELOPMENT' - Device profile can be modified. The profile is only available to the developer and can only be used with a self-published app.
 * 'PUBLISHED' - Device profile can be shared with other users, but cannot be modified.
 * @default "DEVELOPMENT"
 */
export enum DeviceProfileStatus {
  DEVELOPMENT = 'DEVELOPMENT',
  PUBLISHED = 'PUBLISHED',
}

export type DeviceMigrationResponse = object;

export interface DeviceShareRequest {
  share?: DeviceShare[];
}

export interface DeviceShare {
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  shareType?: 'ADD' | 'REMOVE';
}

export type DeviceShareResponse = object;

/** An OCF device representation that matches the oic/p device representation */
export interface OcfDeviceProfile {
  /**
   * The label for the device
   * @minLength 1
   * @maxLength 255
   * @example "Living room light"
   */
  label?: string;
  /** @format uuid */
  deviceId?: string;
  /** Manufacturer's name */
  mnmn?: string;
  /** Vendor (model) ID */
  vid?: string;
  /** Manufacturer's code */
  mfc?: string;
  /** LocationId for the device */
  locationId?: string;
  /**
   * The User UUID for the owner of the device when applicable
   * @format uuid
   */
  ownerId?: string;
  /**
   * The type of device integration.
   * All types besides ENDPOINT_APP will have profile populated.
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  deviceBackendType?: DeviceIntegrationType;
  /** The device network type */
  deviceNetworkType?: string;
  /** the room that the device is assigned to */
  roomId?: string;
  /** The DTH device type name. This should not be depended on! */
  deviceTypeName?: string;
  /** The DTH device type id. This should not be depended on! */
  deviceTypeId?: string;
  /** The profile Id that the device is using for non-DTH devices. This should not be depended on! It does not work for DIPs */
  deviceProfileId?: string;
  /** The OCF device type assigned to the device */
  ocfDeviceType?: string;
}

export interface PreferenceResponse {
  /** The ID of the preference */
  preferenceId?: string;
  /** An alphanumeric English language name for this preference. */
  name?: string;
  /**
   * A short description for this preference.
   * @example "Temperature Offset"
   */
  title: string;
  /**
   * A long description for this preference.
   * @example "The offset for a particular temperature setting"
   */
  description?: string;
  /**
   * A flag describing whether this property is required or not.
   * @default false
   */
  required?: boolean;
  /**
   * A flag describing whether this preference is explicit, or inline.
   * @default false
   */
  explicit?: boolean;
  /** The type of preference this is. */
  preferenceType: PreferenceType;
}

/**
 * The definition of this preference.
 * @example {"id":"example.colorSelect","name":"colorSelect","title":"Color Select","description":"Select a preset color","required":false,"preferenceType":"enumeration","definition":{"options":{"red":"Red","yellow":"Yellow","lightBlue":"Light Blue"},"default":"red"}}
 */
export type EnumerationPreference = PreferenceResponse & {
  definition: {
    /** The available selections for an `enumeration` preference. */
    options: Record<string, string>;
    /** Default value for a preference. */
    default?: any;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.notificationMessage","name":"notificationMessage","title":"Notification Message","description":"Set the text of the notification message","preferenceType":"string","definition":{"stringType":"text","minLength":1,"maxLength":10}}
 */
export type StringPreference = PreferenceResponse & {
  definition?: {
    /** Minimum length a string may be set to. */
    minLength?: number;
    /** Maximum length a string may be set to. */
    maxLength?: number;
    /**
     * The type of a string preference.
     * `text` is a normal preference, `password` encrypts the values, and `paragraph` is for documentation purposes.
     * @default "text"
     */
    stringType?: 'text' | 'password' | 'paragraph';
    /** Default value for a preference. */
    default?: string;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.tempOffset","name":"tempOffset","title":"Temperature Offset","description":"Set the default temperature offset of this device","required":false,"preferenceType":"integer","definition":{"minimum":-10,"maximum":10,"default":0}}
 */
export type IntegerPreference = PreferenceResponse & {
  definition?: {
    /** Minimum value a preference may be set to. */
    minimum?: number;
    /** Maximum value a preference may be set to. */
    maximum?: number;
    /** Default value for a preference. */
    default?: number;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.lightToggleDelay","name":"lightToggleDelay","title":"Light Toggle Delay","description":"The delay time to toggle a light to turn on or off","required":false,"preferenceType":"number","definition":{"minimum":0,"maximum":1,"default":0.5}}
 */
export type NumberPreference = PreferenceResponse & {
  definition?: {
    /**
     * Minimum value a preference may be set to.
     * @format double
     */
    minimum?: number;
    /**
     * Maximum value a preference may be set to.
     * @format double
     */
    maximum?: number;
    /**
     * Default value for a preference.
     * @format double
     */
    default?: number;
  };
};

/**
 * The definition of this preference.
 * @example {"id":"example.featureEnabled","name":"featureEnabled","title":"Feature Enabled","description":"Set the feature to enabled for this device","required":false,"preferenceType":"boolean","definition":{"default":true}}
 */
export type BooleanPreference = PreferenceResponse & {
  definition?: {
    /** Default value for a preference. */
    default?: boolean;
  };
};

/** The type of preference this is. */
export enum PreferenceType {
  Integer = 'integer',
  Number = 'number',
  Boolean = 'boolean',
  String = 'string',
  Enumeration = 'enumeration',
}

export interface PreferenceValue {
  /** The type of preference this is. */
  preferenceType: PreferenceType;
}

export type IntegerPreferenceValue = PreferenceValue & {
  value: number;
};

export type NumberPreferenceValue = PreferenceValue & {
  value: number;
};

export type BooleanPreferenceValue = PreferenceValue & {
  value: boolean;
};

export type StringPreferenceValue = PreferenceValue & {
  value: string;
};

/** @example {"values":{"temperatureOffset":{"preferenceType":"integer","value":3},"example.lightToggleDelay":{"preferenceType":"number","value":0.68},"example.featureEnabled":{"preferenceType":"boolean","value":false},"example.notificationMessage":{"preferenceType":"string","value":"It is hot"},"example.colorSelect":{"preferenceType":"string","value":"lightBlue"}}} */
export interface DevicePreferenceResponse {
  /** Map of PreferenceId to its stored values */
  values?: Record<string, PreferenceValue>;
}

export type ExtendedDevicePreferenceResponse = DevicePreferenceResponse & {
  /** Map of PreferenceId to its definitions */
  definitions?: Record<string, PreferenceResponse>;
};

/** @example {"value":3} */
export interface UpdateDeviceParameterRequest {
  value: object;
}

export interface AcceptInvitationRequest {
  consent?: ConsentPayload;
}

export interface ConsentPayload {
  agreed: ConsentPayloadAgreed[];
}

export interface ConsentPayloadAgreed {
  country: string;
  /** ISO 8601 date-time */
  updatetime: string;
  version: string;
  isOptional: boolean;
  isAgreed: boolean;
}

/** @example {"entityType":"LOCATION","permissionExpiration":"2023-08-15T00:00:00Z","entityId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","deviceList":["E8DF13FC-318C-42B4-9AA9-B07ADFFE5874","894F1489-EBE9-4C4F-9205-042E74E98D7A"],"deliveryMethods":[{"deliveryType":"EMAIL","deliveryTarget":"example@example.com"}]} */
export interface CreateInvitationRequest {
  /**
   * An ISO 8601 date-time indicating the expiration of permissions for the user.
   * This date must not be more than one year in the future.
   * If not provided, the invited user's permissions will not expire.
   * @format date-time
   */
  permissionExpiration?: string;
  /**
   * List of device UUIDs to be accessible to the invited user.
   * If not provided, all devices will be accessible to the invited user.
   */
  deviceList?: DeviceList;
  /** The entity type you are inviting access to. */
  entityType: EntityTypes;
  /** The identifier for the specific entity you are inviting access to. */
  entityId: string;
  deliveryMethods: DeliveryMethods;
  consent?: ConsentPayload;
  /**
   * Can be set to `restrictedshare` to grant limited permissions to the invitee, or `share` to grant full access.
   * Defaults to `share` if no value is passed in.
   */
  grantType?: string;
}

/** Represents all Locations and Rooms readable by a user. */
export interface InternalLocationsAndRooms {
  items?: InternalLocationAndRooms[];
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","shardId":"na01d","rooms":[{"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200}],"created":1547920800,"lastModified":1548007200,"parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}} */
export interface InternalLocationAndRooms {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId?: string;
  /**
   * A nickname given to the location (eg. Home)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** An ISO Alpha-3 country code.  (i.e. GBR, USA) */
  countryCode?: string;
  /**
   * The OCF Region (based on country code)
   * @minLength 2
   * @maxLength 2
   */
  ocfRegion?: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /** The radius in meters around latitude and longitude which defines this location. */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /** An ID matching the Java Time Zone ID of the location. */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * The shard a legacy location was originally created in.
   * @example "na01d"
   */
  shardId?: string;
  /** A list of all Rooms available for a user. */
  rooms?: InternalRoomResponse[];
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/** @example {"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200} */
export interface InternalRoomResponse {
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId?: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId?: string;
  /** A name for the room (e.g. Living Room) */
  name?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/** Represents a single page of Invitations available in a user account. */
export interface PagedInvitations {
  items?: Invitation[];
  _links?: Links;
}

/** @example {"invitationId":"0dc4abe0-583c-494f-b45c-e4d9776fc1e5","inviterUsername":"john@example.com","entityType":"LOCATION","entityId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","locationName":"Home","countryCode":"USA","deliveryMethods":[{"deliveryType":"EMAIL","deliveryTarget":"example@example.com"}],"status":"PENDING","expiration":"2018-02-14T12:44:18+00:00"} */
export interface Invitation {
  /**
   * The ID of the invitation.
   * @format uuid
   */
  invitationId?: string;
  /** The username for the inviter. */
  inviterUsername?: string;
  /** The name of the location. */
  locationName?: string;
  /** The country code. */
  countryCode?: string;
  /** The entity type you are inviting access to. */
  entityType?: EntityTypes;
  /** The identifier for the specific entity you are inviting access to. */
  entityId?: string;
  deliveryMethods?: DeliveryMethods;
  /** The current status of the invite. */
  status?: StatusTypes;
  /**
   * The IS0-8601 date time string in UTC for the expiration of an invitation.
   * @example "2018-02-14T12:44:18+00:00"
   */
  expiration?: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type AcceptInvitationResponse = object;

/** The entity type you are inviting access to. */
export enum EntityTypes {
  LOCATION = 'LOCATION',
}

/**
 * List of device UUIDs to be accessible to the invited user.
 * If not provided, all devices will be accessible to the invited user.
 */
export type DeviceList = string[];

export type DeliveryMethods = Delivery[];

export interface Delivery {
  /** The delivery type of the invite. */
  deliveryType?: DeliveryType;
  /** Target for the delivery type. */
  deliveryTarget?: string;
}

/** The delivery type of the invite. */
export enum DeliveryType {
  EMAIL = 'EMAIL',
  LOGINID = 'LOGINID',
}

/** The current status of the invite. */
export enum StatusTypes {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
}

export interface Camera {
  /** id of the camera */
  cameraId: string;
  /** name of the camera */
  cameraName: string;
  /** whether clips can be viewed. True for ST cameras, false for others */
  canViewClips: boolean;
  /** Vendor id of the device, used for UI. */
  vid: string;
  /** Manufacturer model number, used for UI. */
  mnmn: string;
  /** Vendor of the device */
  vendor?: string;
}

export interface WeatherData {
  /**
   * The location id of the weather data
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * An ISO Alpha-3 country code. (i.e. USA, CAN)
   * @format ^[A-Z]{3}$
   */
  countryCode?: string;
  /** Description of the weather */
  weather?: string;
  /**
   * (This attribute is not available in Korea and Japan)
   * Descriptive sky cover - based on percentage of cloud cover.
   *
   * Range - Clear: coverage < 0.09375; Partly Cloudy: coverage < .59375; Mostly Cloudy: coverage < .75; Cloudy: coverage >= .75
   */
  cloudCoverPhrase?: string;
  /** The temperature of the location */
  temperature?: {
    /**
     * Temperature value
     * @example -5
     */
    value: number;
    /**
     * Temperature unit
     * @example "C"
     */
    unit: string;
  };
  /** The Air Quality of the location - Korea only */
  airQuality?: {
    /** Amount of PM10 in the air */
    pm10Amount?: {
      /**
       * PM10 value
       * @example 8.26
       */
      value: number;
      /**
       * PM10 unit
       * @example "μg/m^3"
       */
      unit: string;
    };
    /** Amount of PM25 in the air */
    pm25Amount?: {
      /**
       * PM25 value
       * @example 16.94
       */
      value: number;
      /**
       * PM25 unit
       * @example "μg/m^3"
       */
      unit: string;
    };
    /** Air index */
    index?: {
      /**
       * Index value
       * @example 41
       */
      value: number;
      /**
       * Index unit
       * @example "CAQI"
       */
      unit: string;
    };
  };
}

/** Represents a single page of Locations available in a user account. */
export interface PagedPublicLocations {
  items?: PagedPublicLocation[];
  _links?: Links;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","usernames":["example1@example.com","example2@example.com","example3@example.com"],"countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","shardId":"na01d","created":1547920800,"lastModified":1548007200,"parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}} */
export interface InternalLocation {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId?: string;
  usernames?: string[];
  /** Set of Samsung user UUIDs for users that belong to this location. */
  userUuids?: string[];
  /**
   * A nickname given to the location (eg. Home)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** An ISO Alpha-3 country code.  (i.e. GBR, USA) */
  countryCode?: string;
  /**
   * The OCF Region (based on country code)
   * @minLength 2
   * @maxLength 2
   */
  ocfRegion?: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /** The radius in meters around latitude and longitude which defines this location. */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /** An ID matching the Java Time Zone ID of the location. */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * The shard a legacy location was originally created in.
   * @example "na01d"
   */
  shardId?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","usernames":["example1@example.com","example2@example.com","example3@example.com"],"countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","shardId":"na01d","created":1547920800,"lastModified":1548007200,"parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}} */
export interface PagedPublicLocation {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId?: string;
  usernames?: string[];
  /** Set of Samsung user UUIDs for users that belong to this location. */
  userUuids?: string[];
  /**
   * A nickname given to the location (eg. Home)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** An ISO Alpha-3 country code.  (i.e. GBR, USA) */
  countryCode?: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /** The radius in meters around latitude and longitude which defines this location. */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /** An ID matching the Java Time Zone ID of the location. */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * The shard a legacy location was originally created in.
   * @example "na01d"
   */
  shardId?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current mode on the location
   *   <li> w:locations:currentmode - the user can change the current mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/** The parent of a Location */
export interface LocationParent {
  /** The type of the Location's parent. */
  type?: LocationParentTypes;
  /**
   * The ID of the parent
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @minLength 36
   * @maxLength 36
   */
  id?: string;
}

/**
 * The type of the Location's parent.
 * @minLength 7
 * @maxLength 14
 */
export enum LocationParentTypes {
  LOCATIONGROUP = 'LOCATIONGROUP',
  ACCOUNT = 'ACCOUNT',
}

export interface LocationUsersResponseWithLocationId {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId?: string;
  owner?: LocationUser;
  members?: LocationUser[];
}

export interface CreateLocationWithRoomsAndWallpapers {
  /**
   * A name given to the Location (e.g. Home)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /**
   * An ISO Alpha-3 country code (e.g. GBR, USA)
   * @pattern ^[A-Z]{3}$
   */
  countryCode: string;
  /**
   * A geographical latitude.
   * @min -90
   * @max 90
   */
  latitude?: number;
  /**
   * A geographical longitude.
   * @min -180
   * @max 180
   */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this Location.
   * @min 20
   * @max 500000
   */
  regionRadius?: number;
  /** The desired temperature scale used for the Location. Values include F and C. */
  temperatureScale?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /** Additional information about the Location that allows SmartThings to further define your Location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
  /** list of room and wallpaper pairs */
  roomsAndWallpapers?: CreateRoomWithWallpaper[];
  /** id of the wallpaper. If null or invalid it will be set to default */
  wallpaperId?: string;
}

export interface CreateRoomWithWallpaper {
  /**
   * A name given for the room (eg. Living Room)
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /** id of the wallpaper. If null or invalid it will be set to default */
  wallpaperId?: string;
}

export interface LocationWithRoomsAndWallpapers {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId?: string;
  /** A name given for the location (eg. Home) */
  name?: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode?: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** rooms with wallpapers */
  rooms?: RoomWithWallpaper[];
  wallpaper?: WrappedLocationWallpaper;
}

export interface RoomWithWallpaper {
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> d:rooms - the user can delete the room
   *   <li> w:rooms - the user can edit the room
   *   </ul>
   */
  allowed?: string[];
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId?: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId?: string;
  /** A name for the room (e.g. Living Room) */
  name?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
  wallpaper?: WrappedRoomWallpaper;
}

export interface UpdateLocationWithModesAndWallpaperRequest {
  /**
   * A name for the Location.
   * @minLength 1
   * @maxLength 40
   */
  name: string;
  /**
   * A geographical latitude.
   * @min -90
   * @max 90
   */
  latitude?: number;
  /**
   * A geographical longitude.
   * @min -180
   * @max 180
   */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this Location.
   * @min 20
   * @max 500000
   */
  regionRadius?: number;
  /** The desired temperature scale used for the Location. Values include F and C. */
  temperatureScale?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /** Additional information about the Location that allows SmartThings to further define your Location. */
  additionalProperties?: Record<string, string>;
  /** list of modes to create. Existing modes not in the list will be deleted */
  modes?: UpdateOrCreateMode[];
  /** id of the wallpaper. If null or invalid it will be set to default */
  wallpaperId?: string;
}

export interface UpdateOrCreateMode {
  /**
   * Globally unique id for the mode. If null, it is a new mode to be created
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id?: string;
  /**
   * A name provided by the User. Unique per location, updatable.
   * @minLength 1
   * @maxLength 25
   * @example "Our House"
   */
  label: string;
  /** if this mode is currently selected. At most one can be selected in the list. If multiple are selected, the resulting behaviour is undefined. */
  selected?: boolean;
}

export interface LocationWithModesAndWallpaper {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode?: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  modes?: {
    /**
     * List of client-facing action identifiers that are currently permitted for the user.
     * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
     * If the value of this property is null (or absent), then no permission-related information is being provided.
     *   <ul>
     *   <li> w:modes - the user can edit the Mode
     *   <li> d:modes - the user can delete the Mode
     *   </ul>
     */
    allowed?: string[];
    /**
     * Globally unique id for the Mode.
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
     */
    id: string;
    /**
     * A user-readable label used to identify the mode in the app.
     * If the user has not set a label and the name of the mode is one of "Home", "Away", or "Night",
     * then the returned label will be translated from the name based on the `Accept-Language` header.
     * If the user has not set a label and the name of the mode is anything else, then the label will be the same as the name.
     * Unique per Location.
     * @minLength 1
     * @maxLength 25
     * @example "Vacation"
     */
    label: string;
    /**
     * An internal name for the Mode.
     * Unique per Location.
     * @format ^[a-zA-Z0-9.-_]+$
     * @example "Home"
     */
    name: string;
  }[];
  wallpaper?: WrappedLocationWallpaper;
  currentMode?: {
    /**
     * List of client-facing action identifiers that are currently permitted for the user.
     * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
     * If the value of this property is null (or absent), then no permission-related information is being provided.
     *   <ul>
     *   <li> w:modes - the user can edit the Mode
     *   <li> d:modes - the user can delete the Mode
     *   </ul>
     */
    allowed?: string[];
    /**
     * Globally unique id for the Mode.
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
     */
    id: string;
    /**
     * A user-readable label used to identify the mode in the app.
     * If the user has not set a label and the name of the mode is one of "Home", "Away", or "Night",
     * then the returned label will be translated from the name based on the `Accept-Language` header.
     * If the user has not set a label and the name of the mode is anything else, then the label will be the same as the name.
     * Unique per Location.
     * @minLength 1
     * @maxLength 25
     * @example "Vacation"
     */
    label: string;
    /**
     * An internal name for the Mode.
     * Unique per Location.
     * @format ^[a-zA-Z0-9.-_]+$
     * @example "Home"
     */
    name: string;
  };
}

export interface Icons {
  /** url of the colored icon */
  coloredIcon: string;
  /** url of the dimmed icon */
  dimmedIcon: string;
  /** url of the activated icon */
  activatedIcon: string;
  /** url of the inactivated icon */
  inactivatedIcon: string;
  /** url of the disconnected icon */
  disconnectedIcon: string;
  /** url of the running icon */
  runningIcon?: string;
  /** url of the quickBoard icon */
  quickBoardIcon: string;
  /** url of the animation icon */
  animationIcon?: string;
  /** url for the colored auto icon */
  coloredAutoIcon: string;
  /** url for the dimmed auto icon */
  dimmedAutoIcon: string;
  /** url for the running auto icon */
  runningAutoIcon: string;
  /** url of the disconnected auto icon */
  disconnectedAutoIcon: string;
  /** key of the current icon. Will be one of ones in possibleIcons. Can be null if possibleIcons is empty */
  iconKey?: string;
  /**
   * last time any of the icons in the object got updated
   * @format date-time
   */
  lastUpdateDate: string;
}

export interface SubGroupIcon {
  /** name of the group of icons identifying it */
  groupId: any;
  icons: Icons;
}

export interface PossibleIcon {
  /** url of the icon */
  url: string;
  /** key to send to the cloud for updated icon */
  key: string;
  /**
   * last time any of the icons in the object got updated
   * @format date-time
   */
  lastUpdateDate: string;
}

export interface IconData {
  /** key of the icon to set on the device */
  key: string;
}

export type BadgeIcons = BadgeIconData[];

export interface BadgeIconData {
  /** url of the colored badge icon */
  coloredIcon: string;
  /** url of the dimmed badge icon */
  dimmedIcon: string;
  /** url of the activated badge icon */
  activatedIcon: string;
  /** url of the inactivated badge icon */
  inactivatedIcon: string;
  /** url of the disconnected badge icon */
  disconnectedIcon: string;
  /** key of the current badge icon */
  iconKey: string;
  /**
   * last time any of the badge icons in the object got updated
   * @format date-time
   */
  lastUpdateDate: string;
}

export interface DefaultLocation {
  /** The username for the user. */
  username: string;
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
}

/** Represents a single page of Rooms available in a Location. */
export interface PagedRooms {
  items?: {
    /**
     * List of client-facing action identifiers that are currently permitted for the user.
     * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
     * If the value of this property is null (or absent), then no permission-related information is being provided.
     *   <ul>
     *   <li> d:rooms - the user can delete the room
     *   <li> w:rooms - the user can edit the room
     *   </ul>
     */
    allowed?: string[];
    /**
     * The ID of the room.
     * @format uuid
     */
    roomId: string;
    /**
     * The ID of the parent Location.
     * @format uuid
     */
    locationId: string;
    /** A name for the room (e.g. Living Room) */
    name: string;
    /**
     * Not currently in use.
     * @example null
     */
    backgroundImage?: string;
    /**
     * The timestamp of when a room was created in UTC.
     * @format date-time
     */
    created?: string;
    /**
     * The timestamp of when a room was last updated in UTC.
     * @format date-time
     */
    lastModified?: string;
    /** Data used for indoor map */
    indoorMap?: {
      /**
       * The reference id for the room map
       * @minLength 1
       * @maxLength 40
       */
      mapRoomId?: string;
      /**
       * Map Room Color
       * @minLength 1
       * @maxLength 255
       */
      color?: string;
    };
  }[];
  _links?: Links;
}

export interface ModesWithLocationIdResponse {
  /** @maxItems 10 */
  items?: ModeWithLocationId[];
}

export interface ModeWithLocationId {
  /**
   * The ID of the Location this mode corresponds to.
   * @format uuid
   */
  locationId?: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:modes - the user can edit the Mode
   *   <li> d:modes - the user can delete the Mode
   *   </ul>
   */
  allowed?: string[];
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id?: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * If the user has not set a label and the name of the mode is one of "Home", "Away", or "Night",
   * then the returned label will be translated from the name based on the `Accept-Language` header.
   * If the user has not set a label and the name of the mode is anything else, then the label will be the same as the name.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label?: string;
  /**
   * An internal name for the Mode.
   * Unique per Location.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name?: string;
}

export interface SceneIcon {
  /** id of the icon used by client */
  iconId: string;
  /** name of the icon */
  name: string;
  /** url of the icon */
  iconUrl: string;
}

export interface InstallRequest {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface MigrationInstallRequest {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
  /** SMS message groups for the App.  This is optional. */
  smsMessageGroups?: MessageGroup[];
}

export interface MessageGroup {
  /**
   * The message group key for the migrated SHM app
   * @example "message_group_key_leak"
   */
  messageGroupKey: string;
  /**
   * A channel is a compound identifier which combines both the message protocal and destination to which a
   * message should be delivered.  A channel value follows the following format: `<protocol>:<target-destination>`.
   *
   * ## Supported Protocols
   * | Protocol | Channel Format | Restrictions |
   * | -------- | -------------- | ------------ |
   * | SMS      | sms:+19999999999 | Phone Number in E.164 format. Messaging API is only supported for US based phone numbers. |
   */
  recipients: string[];
  /**
   * A user defined name for the message group.
   * @maxLength 100
   */
  displayName?: string;
}

export interface NextPageRequest {
  installInformation?: InstallInformation;
  /** A request for a pages flow to drive app installation.  This will only be available for executions of type "CONFIGURATION". */
  configurationData?: ConfigurationData;
}

export interface InstallInformation {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

export interface InstallSummary {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface StartInstallResponse {
  installSummary?: InstallSummary;
  appSummary?: AppSummary;
  /** The first page for the install. */
  page?: Page;
}

export interface InstallResponse {
  /** The initial setting to be returned when starting a new configuration install. */
  app?: Setting & {
    /**
     * A developer defined page ID of the first page to display. Must be URL safe characters.
     * @format ^[a-zA-Z0-9.-_]{1,36}$
     */
    firstPageId?: string;
    /**
     * A developer defined page ID of any page to display. Must be URL safe characters.
     * @format ^[a-zA-Z0-9.-_]{1,36}$
     */
    customDisplayNamePageId?: string;
    /**
     * Disable the ability for the user to customize the display name.
     * @default false
     */
    disableCustomDisplayName?: boolean;
    /**
     * Disable the ability to remove the app from the configuration flow.
     * @default false
     */
    disableRemoveApp?: boolean;
    permissions?: string[];
  };
  installSummary?: InstallSummary;
  /** The first page for the install. */
  page?: Page;
  /** If the app is preauthorized or not. */
  preauthorized?: boolean;
}

export interface NextPageResponse {
  installSummary?: InstallSummary;
  page?: Page;
}

export interface UpdateInstallRequest {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The new display name. */
  displayName?: string;
}

export interface UpdateInstallResponse {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The new display name. */
  displayName?: string;
}

export interface AppSummary {
  /**
   * Name of the app to be configured.
   * @maxLength 256
   */
  name?: string;
  /**
   * Description of the app to be configured.
   * @maxLength 2048
   */
  description?: string;
  /**
   * A developer defined page ID of the first page to display. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  firstPageId?: string;
  requirements?: Requirement[];
}

export interface Requirement {
  /**
   * A developer defined configuration ID.
   * @format ^[a-zA-Z0-9.-_]+$
   * @maxLength 128
   */
  id?: string;
  /**
   * Value chosen for this configuration setting.
   * @maxLength 2048
   */
  value?: string;
  permissions?: string[];
}

export interface Section {
  /**
   * Name of the section.
   * @maxLength 128
   */
  name?: string;
  /**
   * Whether or not the section can be collapsed
   * @default false
   */
  hideable?: boolean;
  /**
   * If section can be collapsed, whether or not it defaults to hidden
   * @default false
   */
  hidden?: boolean;
  /**
   * Change how the section is presented
   * @default "NORMAL"
   */
  style?: 'NORMAL' | 'FOOTER';
  /**
   * Configuration settings represent the questions asked to the end user installing an integration the answers to
   * which provide the configuration for which the integration will use when executing. Settings follow an inheritance
   * pattern.  The type field dictates the expected instance of setting that is provided.
   */
  settings?: SectionSetting[];
}

export interface Setting {
  /**
   * A developer defined configuration ID.
   * @format ^[a-zA-Z0-9.-_]+$
   * @maxLength 128
   */
  id?: string;
  /**
   * Name of the setting to be configured.
   * @maxLength 128
   */
  name?: string;
  /**
   * Description of the app to be configured.
   * @maxLength 2048
   */
  description?: string;
}

/** Device Setting */
export type DeviceSetting = Setting & {
  /** Indicates if this device setting can have multiple values. */
  multiple?: boolean;
  /** The required capabilities for the device(s) options. */
  capabilities?: string[];
  /** The required permissions for the selected device(s). */
  permissions?: ('READ' | 'EXECUTE' | 'WRITE')[];
  /** The device options for this setting that meet the required cababilities. */
  options?: Device[];
};

/** Enum Setting */
export type EnumSetting = Setting & {
  /** Indicates if this enum setting can have multiple values. */
  multiple?: boolean;
  /** Display the enum options as groups. */
  groupedOptions?: GroupedOption[];
  /** The enum options. */
  options?: Option[];
};

/** Mode Setting */
export type ModeSetting = Setting & {
  /** Indicates if this enum setting can have multiple values. */
  multiple?: boolean;
  /** The mode options. */
  options?: Option[];
};

export interface GroupedOption {
  /**
   * The display name of this group of enum options.
   * @maxLength 128
   */
  name?: string;
  /** The enum options. */
  options?: Option[];
}

export interface Option {
  /**
   * The unique ID for this option.
   * @maxLength 128
   */
  id?: string;
  /**
   * The display name for this option.
   * @maxLength 128
   */
  name?: string;
}

export interface Page {
  /**
   * Name of the page to be configured.
   * @maxLength 128
   */
  name?: string;
  /**
   * A developer defined page ID. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  pageId?: string;
  /**
   * A developer defined page ID for the next page in the configuration process. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  nextPageId?: string;
  /**
   * A developer defined page ID for the previous page in the configuration process. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  previousPageId?: string;
  /**
   * Indicates if this is the last page in the configuration process.
   * @default false
   */
  complete?: boolean;
  /**
   * Change how the page is presented
   * @default "NORMAL"
   */
  style?: 'NORMAL' | 'SPLASH';
  /**
   * The text for the next button. Only applies if style is `SPLASH`
   * @maxLength 128
   */
  nextText?: string;
  /** The display sections for user defined settings. */
  sections?: Section[];
}

/** A request for a pages flow to drive app installation.  This will only be available for executions of type "CONFIGURATION". */
export interface ConfigurationData {
  /** Denotes the current installation phase. */
  phase: 'INITIALIZE' | 'PAGE';
  /**
   * A developer defined page ID. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  pageId?: string;
  /**
   * The previous page the user completed. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  previousPageId?: string;
  /** Settings currently configured by user. */
  config?: ConfigMap;
  /** Global settings as defined on the App. */
  settings?: Record<string, string>;
}

export interface ServiceAppCompleteRequest {
  installInformation?: ServiceInstallInformation;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface ServiceInstallInformation {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

export interface ServiceAppCompleteResponse {
  /**
   * Url that is used to allow/deny permissions and redirect to install/finalize endpoint.
   * @example "https://consigliere-regionald.smartthingsgdev.com/oauth/authorize?response_type=code&principal=installedapp:{{installedAppId}}:{{locationId}}&client_id={{clientId}}&state={{encrypted_state}}&installedAppId={{installedAppId}}&installedAppConfigId={{configurationId}}&language=en&redirect_uri=https://strongman-regionald.smartthingsgdev.com/install/finalize"
   */
  url?: string;
}

export interface SwatchDefinitionResponse {
  /** The type of object: `BUTTON`, `COLOR`, `ENUMERATED`, `SLIDER`, `TOGGLE`, or `VALUE` */
  swatchType: SwatchType;
  capabilityId: string;
  label: string;
  icon: string;
  attributeName?: string;
  command?: string;
  /** A list of arguments to be included in the request to set the color. */
  arguments?: ColorSwatchArgument[];
  /** A list of possible states this Swatch can be in. */
  possibleStates?: EnumeratedSwatchPossibleState[];
  min?: number;
  max?: number;
  step?: number;
  unit?: string;
  /** Data specific to the on or off state of a toggle control. */
  onState?: ToggleState;
  /** Data specific to the on or off state of a toggle control. */
  offState?: ToggleState;
  type?: string;
  appearance?: string;
}

export interface WrappedSwatchItem {
  /** The type of object: `BUTTON`, `COLOR`, `ENUMERATED`, `SLIDER`, `TOGGLE`, or `VALUE` */
  type: SwatchType;
}

/** The type of object: `BUTTON`, `COLOR`, `ENUMERATED`, `SLIDER`, `TOGGLE`, or `VALUE` */
export enum SwatchType {
  BUTTON = 'BUTTON',
  COLOR = 'COLOR',
  ENUMERATED = 'ENUMERATED',
  SLIDER = 'SLIDER',
  TOGGLE = 'TOGGLE',
  VALUE = 'VALUE',
}

export interface Swatch {
  /**
   * Unique Id of a swatch.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  swatchId: string;
  /**
   * The Id of the Component represented by this Swatch.
   * @example "main"
   */
  componentId: string;
  /**
   * The Id of the Capability represented by this Swatch.
   * @example "switchLevel"
   */
  capabilityId: string;
  /** The label to display to the user. */
  label: string;
  /**
   * A url that points to the Swatch Icon.
   * @format uri
   * @example "https://client.smartthings.com/icons/capabilities/switchLevel/level"
   */
  icon: string;
}

/** A stateless control with a command. */
export type BUTTON = WrappedSwatchItem & {
  /** A stateless control with a command. */
  button: ButtonSwatch;
};

/** A stateless control with a command. */
export type ButtonSwatch = Swatch & {
  /** The command to call when the button is pushed. */
  command: string;
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** A control representing a color picker. */
export type COLOR = WrappedSwatchItem & {
  /** A control representing a color picker. */
  color: ColorSwatch;
};

/** A control representing a color picker. */
export type ColorSwatch = Swatch & {
  /** The method to call to set the color after user interaction. */
  command: string;
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** A list of arguments to be included in the request to set the color. */
  arguments: ColorSwatchArgument[];
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** An object describing the argument to be sent when setting the color. */
export interface ColorSwatchArgument {
  /** The name of the argument which coincides with a capability attribute value. */
  name?: string;
  /** The type of value the argument should be. */
  type?: 'number';
  /** The minimum value allowed. */
  min?: number;
  /** The maximum value allowed. */
  max?: number;
  /** Whether or not this argument is required when calling the setter. */
  required?: boolean;
}

/** An enum control. */
export type ENUMERATED = WrappedSwatchItem & {
  /** An enum control. */
  enumerated: EnumeratedSwatch;
};

/** An enum control. */
export type EnumeratedSwatch = Swatch & {
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** A list of possible states this Swatch can be in. */
  possibleStates?: EnumeratedSwatchPossibleState[];
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

export interface EnumeratedSwatchPossibleState {
  /** The device status value this state represents. This is the state to be displayed when the device status value matches. */
  status: string;
  /** The label to display to the user. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** The command to call when the user interacts with this state. */
  command: string;
  /** An icon url for this state. Overrides the icon on the control if present. */
  icon?: string;
}

/** A slider control. */
export type SLIDER = WrappedSwatchItem & {
  /** A slider control. */
  slider: SliderSwatch;
};

/** A slider control. */
export type SliderSwatch = Swatch & {
  /** The minimum value allowed. Type is either `INTEGER` or `NUMBER` and is determined by `type` */
  min: object;
  /** The maximum value allowed. Type is either `INTEGER` or `NUMBER` and is determined by `type` */
  max: object;
  /** The Command to call to set the value after user interaction. */
  command: string;
  /**
   * The Attribute represented by this Swatch.
   * @example "level"
   */
  attributeName: string;
  /** A unit associated with the value to be displayed to the user. The value to be displayed is the actual value of the device status. */
  unit: string;
  /** The number to be added or subtracted to the current setting when incrementing or decrementing the value. Type is either `INTEGER` or `NUMBER` and is determined by `type` */
  step: object;
  /** The type of data this slider represents. */
  type: 'NUMBER' | 'INTEGER';
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** A toggle control. */
export type TOGGLE = WrappedSwatchItem & {
  /** A toggle control. */
  toggle: ToggleSwatch;
};

/** A toggle control. */
export type ToggleSwatch = Swatch & {
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** Data specific to the on or off state of a toggle control. */
  onState: ToggleState;
  /** Data specific to the on or off state of a toggle control. */
  offState: ToggleState;
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
};

/** Data specific to the on or off state of a toggle control. */
export interface ToggleState {
  /** The Command to call when the toggle is flipped to this state. */
  command: string;
  /** The value of the Device status that indicates whether the toggle is in this state. */
  status: string;
  /** The label to display when the the device is in this state. */
  label: string;
  /** A url to the icon that represents the toggle when it is in this state. Overrides the icon on the control if present. */
  icon?: string;
}

/** A control with a value that doesn't have a command. */
export type VALUE = WrappedSwatchItem & {
  /** A control with a value that doesn't have a command. */
  value: ValueSwatch;
};

/** A control with a value that doesn't have a command. */
export type ValueSwatch = Swatch & {
  /**
   * The Attribute represented by this control.
   * @example "level"
   */
  attributeName: string;
  /** A unit associated with the value to be displayed to the user. The value to be displayed is the actual value of the device status. */
  unit?: string;
  /** The type of data this control represents. */
  type: 'NUMBER' | 'INTEGER' | 'STRING';
  /**
   * A way to differentiate appearance without changing functionality.
   * @default "DEFAULT"
   */
  appearance: 'DEFAULT';
  /** A list of possible states this Swatch could be in. */
  possibleStates?: ValueSwatchPossibleState[];
};

export interface ValueSwatchPossibleState {
  /** The device status value this state represents. This is the state to be displayed when the device status value matches. */
  status: string;
  /** The label to display to the user. */
  label: string;
  /** Boolean value stating whether this state should display as "active" to the user. */
  active: boolean;
  /** An icon url for this state. Overrides the icon on the control if present. */
  icon?: string;
}

/** Information about which plugin to display for the details view. If this is present, `detailSwatchIds` will be an empty array. */
export interface SwatchPlugin {
  /** The URI for the plugin in the form `plugin://...` */
  uri?: string;
}

export interface DeviceSwatch {
  /**
   * The id of the Device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /** The label or name of this Device. */
  deviceName: string;
  /**
   * The Location that the Device is in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * Id of the swatch to use in the list view.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  listSwatchId: string;
  /** Ordered list of swatchIds to display on the details view. This will be an empty array if `plugin` is present. */
  detailSwatchIds: string[];
  swatches: WrappedSwatchItem[];
  /**
   * Id of the swatch to use for device health information
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  healthSwatchId: string;
  /**
   * The Room that the Device is in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** Information about which plugin to display for the details view. If this is present, `detailSwatchIds` will be an empty array. */
  plugin?: SwatchPlugin;
}

export interface PartialDeviceSwatchResponse {
  /**
   * A key used by the server to track which updates the client needs.
   * Clients must store the most recently fetched `since` value, and pass it as a query param the next time
   * DeviceSwatches are fetched. It will automatically be added to any paginated `_links` so clients
   * do not need to modify the paginated urls before calling them.
   */
  since: string;
  /**
   * A boolean that indicates whether the client should update their local cache or completely replace it.
   * `incremental: true` indicates that the cache should be updated.
   * `incremental: false` indicates that the cache should be replaced.
   * @default true
   */
  incremental: boolean;
  /**
   * A list of DeviceSwatches that have been added or modified.
   * Any DeviceSwatch in this list should replace any locally cached DeviceSwatches.
   * This is expected to be an idempotent action.
   */
  modified: DeviceSwatch[];
  /**
   * A list of Device Ids that have been deleted. Any locally cached DeviceSwatches should be removed.
   * This is expected to be an idempotent action.
   */
  deleted: string[];
  /**
   * Links to previous and next page if the result is large enough to require pagination.
   * If present, clients must fetch the `next` page by calling the specified url as-is.
   * Clients must continue fetching the `next` page until all pages hav been fetched.
   */
  _links?: Links;
}

export type SwatchStatus = FlatDeviceStatus & {
  /**
   * Unique Id of a swatch.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  swatchId: string;
};

export interface SwatchStatusPagedResult {
  items?: SwatchStatus[];
  _links?: Links;
}

export interface UiMetadata {
  n?: string;
  mnmn?: string;
  vid?: string;
  version?: string;
  type?: string;
  dpResources?: DPResources[];
  dpInfo?: DPInfo[];
  language?: Language[];
  ms?: State[];
  ma?: UiMetadataAction[];
  iconUrl?: IconUrl;
}

export interface DPResources {
  name?: string;
  group?: string;
  controllable?: boolean;
  order?: number;
  link?: MetadataLink;
  property?: string;
  valueType?: string;
  controlType?: string;
  alternatives?: Alternative[];
  range?: number[];
  step?: number;
  iconUrl?: IconUrl;
  label?: Label;
  visible?: UiMetadataVisible;
  emphasis?: boolean;
  ruleEvent?: boolean;
  ruleAction?: boolean;
}

export interface MetadataLink {
  href?: string;
  if?: string;
  rt?: string;
}

export interface DPInfo {
  os?: string;
  dpType?: string;
  dpUri?: string;
}

export interface Language {
  locale?: string;
  version?: string;
  mnmn?: string;
  vid?: string;
  poCodes?: POCodes[];
}

export interface POCodes {
  po?: string;
  label?: string;
}

export interface State {
  name?: string;
  group?: string;
  iconUrl?: string;
  type?: string;
  order?: number;
  label?: Label;
  visible?: string;
  emphasis?: boolean;
}

export interface Label {
  n?: string;
  label?: string;
  arguments?: Argument[];
}

export interface Argument {
  n?: string;
  href?: string;
  property?: string;
  valueType?: string;
  alternatives?: Alternative[];
}

export interface Alternative {
  key?: string;
  value?: string;
  type?: string;
  disabled?: boolean;
}

export interface IconUrl {
  /** Small icon url. */
  small?: string;
  /** Mid icon url. */
  mid?: string;
  /** Large icon url. */
  large?: string;
  /** Vector icon url. */
  vector?: string;
}

export interface UiMetadataVisible {
  href?: string;
  property?: string;
  operand?: string;
  operator?: string;
  source?: string;
}

export interface UiMetadataAction {
  name?: string;
  group?: string;
  type?: string;
  order?: number;
  link?: MetadataLink;
  property?: string;
  valueType?: string;
  controlType?: string;
  alternatives?: Alternative[];
  range?: number[];
  step?: string;
  iconUrl?: IconUrl;
  label?: Label;
  visible?: UiMetadataVisible;
  emphasis?: string;
}

export interface UiMetadataVersionData {
  mnmn?: string;
  vid?: string;
  version?: string;
  resource_type?: string;
}

export interface InstallCompleteRequest {
  installInformation?: AppInstallInformation;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface AppInstallInformation {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

export interface InstallCompleteResponse {
  /**
   * Url that is used to allow/deny permissions and redirect to install/finalize endpoint.
   * @example "https://consigliere-regionald.smartthingsgdev.com/oauth/authorize?response_type=code&principal=installedapp:{{installedAppId}}:{{locationId}}&client_id={{clientId}}&state={{encrypted_state}}&installedAppId={{installedAppId}}&installedAppConfigId={{configurationId}}&language=en&redirect_uri=https://clientd.smartthingsgdev.com/strongman/install/finalize"
   */
  url?: string;
}

export interface InstallInitializeRequest {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
}

export interface InstallInitializeResponse {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the configuration.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  configurationId?: string;
  /** Indicates if the app is certified. */
  certified?: boolean;
  /** The display name of the app. */
  displayName?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
  /** The initial setting to be returned when starting a new configuration install. */
  initializeSetting?: InitializeSetting;
}

/** The initial setting to be returned when starting a new configuration install. */
export type InitializeSetting = Setting & {
  /**
   * A developer defined page ID of the first page to display. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  firstPageId?: string;
  /**
   * A developer defined page ID of any page to display. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  customDisplayNamePageId?: string;
  /**
   * Disable the ability for the user to customize the display name.
   * @default false
   */
  disableCustomDisplayName?: boolean;
  /**
   * Disable the ability to remove the app from the configuration flow.
   * @default false
   */
  disableRemoveApp?: boolean;
  permissions?: string[];
};

export type SectionSetting = Setting & {
  /**
   * Indicates if this setting is required for configuration.
   * @default false
   */
  required?: boolean;
  /**
   * Indicates if this setting should be disabled
   * @default false
   */
  disabled?: boolean;
  /** Denotes the type of setting. */
  type: SettingType;
};

/** Denotes the type of setting. */
export enum SettingType {
  DEVICE = 'DEVICE',
  DATE = 'DATE',
  DAYSOFWEEK = 'DAYSOFWEEK',
  TEXT = 'TEXT',
  PASSWORD = 'PASSWORD',
  BOOLEAN = 'BOOLEAN',
  ENUM = 'ENUM',
  MODE = 'MODE',
  SCENE = 'SCENE',
  LINK = 'LINK',
  PAGE = 'PAGE',
  ANIMATION = 'ANIMATION',
  ANIMATIONS = 'ANIMATIONS',
  IMAGE = 'IMAGE',
  IMAGES = 'IMAGES',
  VIDEO = 'VIDEO',
  GENERIC_MEDIA = 'GENERIC_MEDIA',
  MEDIA_CAROUSEL = 'MEDIA_CAROUSEL',
  TIME = 'TIME',
  PARAGRAPH = 'PARAGRAPH',
  EMAIL = 'EMAIL',
  DECIMAL = 'DECIMAL',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  OAUTH = 'OAUTH',
  SOUND = 'SOUND',
  COLOR = 'COLOR',
  MESSAGE_GROUP = 'MESSAGE_GROUP',
  ROOM = 'ROOM',
}

export interface PiperLogsRequest {
  /**
   * UTC timestamp in milliseconds when the log is sent.
   * @format int64
   * @example 1598304586643
   */
  sentAt: number;
  /** @example "Dalvik/2.1.0 (Linux; U; Android 5.0.2; SM-G901F Build/LRX22G)" */
  userAgent: string;
  /** @example "en-GB" */
  locale?: string;
  /** @example "Asia/Singapore" */
  timezone?: string;
  /** @example "HK|SG" */
  region?: string;
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6c087082-feb9-4687-9f1c-4fab435b6d9b"
   */
  userUuid?: string;
  device?: {
    /** @example "samsung" */
    manufacturer?: string;
    /** @example "SM-G901F" */
    model?: string;
  };
  network?: {
    /** @example "wifi | mobile" */
    connection?: string;
    /** @example "Verizon" */
    carrier?: string;
    /**
     * Combination of Mobile Country Codes (MCC) and Mobile Network Codes (MNC)
     * @example "28988"
     */
    mccMnc?: string;
  };
  /** An array of client logs */
  logs?: ClientLog[];
}

export interface ClientLog {
  /**
   * UTC timestamp in milliseconds for the log.
   * @format int64
   * @example 1598304586643
   */
  timestamp: number;
  /** @example "component.class | microservice name" */
  logger?: string;
  /**
   * unqiue id for the given log
   * @example "412386fb-74b9-46d1-824c-07f4f99b0c95"
   */
  correlationId?: string;
  /**
   * log level
   * @example "ERROR"
   */
  level: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' | 'TRACE';
  /** user readable message */
  message: string;
  /** log details, no more than 32kb */
  details?: string;
  tags?: string[];
  metadata?: Record<string, string>;
}

export interface PiperClicksRequest {
  /**
   * UTC timestamp in milliseconds when the log is sent.
   * @format int64
   * @example 1598304586643
   */
  sentAt: number;
  /** @example "Dalvik/2.1.0 (Linux; U; Android 5.0.2; SM-G901F Build/LRX22G)" */
  userAgent: string;
  /** @example "en-GB" */
  locale?: string;
  /** @example "Asia/Singapore" */
  timezone?: string;
  /** @example "HK|SG" */
  region?: string;
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6c087082-feb9-4687-9f1c-4fab435b6d9b"
   */
  userUuid?: string;
  device?: {
    /** @example "samsung" */
    manufacturer?: string;
    /** @example "SM-G901F" */
    model?: string;
  };
  network?: {
    /** @example "wifi | mobile" */
    connection?: string;
    /** @example "Verizon" */
    carrier?: string;
    /**
     * Combination of Mobile Country Codes (MCC) and Mobile Network Codes (MNC)
     * @example "28988"
     */
    mccMnc?: string;
  };
  /** An array of client screen data */
  screen?: ClientScreen[];
}

export interface ClientScreen {
  /** @example "RECOMMEDATION" */
  category:
    | 'AUTOMATION'
    | 'DASHBOARD'
    | 'DEVICES'
    | 'HISTORY'
    | 'HOW_TO_USE'
    | 'LOCATION'
    | 'MEMBER'
    | 'MENU'
    | 'NOTICES'
    | 'RECIPE'
    | 'RECOMMENDATION'
    | 'ROOMS'
    | 'SCENE'
    | 'SERVICE_PLUGIN'
    | 'SETTINGS'
    | 'SMART_APP';
  /** @example "Add Devices" */
  screenName?: string;
  /**
   * start time of the screen in milliseconds
   * @format int64
   * @example 1598304586643
   */
  startTime?: number;
  /**
   * end time of the screen in milliseconds
   * @format int64
   * @example 1598304586900
   */
  endTime?: number;
  /** An array of client click event */
  clicks?: ClientScreenClick[];
}

export interface ClientScreenClick {
  /**
   * timestamp of the click event in milliseconds
   * @format int64
   * @example 1571874833000
   */
  timestamp: number;
  /** text or toggle that is selected or clicked on */
  label?: string;
  /** @example "RECOMMENDATION_CLICK" */
  action:
    | 'ADD'
    | 'BACK'
    | 'CANCEL'
    | 'CHANGE_VALUE'
    | 'CLOSE'
    | 'DELETE'
    | 'EDIT'
    | 'ITEM_CLICK'
    | 'MANAGE'
    | 'NOTIFICATION_ClICK'
    | 'NOTIFICATION_DISMISS'
    | 'RECOMMENDATION_CLICK'
    | 'RECOMMENDATION_DISMISS'
    | 'SAVE'
    | 'TOGGLE_OFF'
    | 'TOGGLE_ON'
    | 'TURN_OFF'
    | 'TURN_ON';
  /** @example {"recommendationId":"82260271-0b07-49af-85a8-a7b553981543","locationId":"82260271-0b07-49af-85a8-a7b553981543","campaignId":"76660271-0b07-49af-85a8-a7b553981546"} */
  metadata?: Record<string, string>;
}

export interface PiperHubLogsResponse {
  /**
   * unique log ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "4d54a250-ec78-4858-8d28-2ca447ef28a4"
   */
  id: string;
  /**
   * A key that is identified by client as a searching option
   * @maxLength 100
   */
  key: string;
  /**
   * pre-signed URL for uploading logs to S3
   * @format uri
   */
  fileUrl: string;
}

export interface PiperDeviceLogsResponse {
  /**
   * unique log ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "4d54a250-ec78-4858-8d28-2ca447ef28a4"
   */
  id: string;
  /**
   * A key that is identified by client as a searching option
   * @maxLength 100
   */
  key: string;
  /**
   * pre-signed URL for uploading logs to S3
   * @format uri
   */
  fileUrl: string;
}

export interface PagedPiperGetLogsResponse {
  /**
   * Max number of logs in a page
   * @example 25
   */
  pageSize?: number;
  /**
   * Total number of logs
   * @example 145
   */
  totalCount?: number;
  logs?: PiperGetLogResponse[];
}

export interface PiperGetLogResponse {
  /**
   * Unique log Id
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "4bc484fd-50d3-482b-9d95-29d5f6100fe8"
   */
  id?: string;
  /**
   * Unix timestamp in miliseconds when the log is sent
   * @format int64
   * @example 1571960607143
   */
  sentAt?: number;
  /** Log type */
  logType?: 'EASYSETUP' | 'HUB' | 'DEVICE';
  /**
   * pre-signed URL for uploading logs to S3
   * @format uri
   */
  fileUrl?: string;
}

export interface PiperGdprRequest {
  /**
   * SA Guid.
   * @example "xf6slriszg"
   */
  saguid: string;
  /** Unique Id corresponding to the request on GDPR API Server. */
  gdpr_id: string;
  /** The title in the request body. */
  title: PiperGdprTitle;
  /**
   * URL to send callback to.
   * @example "https://sampleCallbackurl.samsung.com/gdpr"
   */
  callback_url?: string;
  /** GDPR S3 base path to upload the generated file. Only required in Access API. */
  file_path?: string;
  /** File name that has to be uploaded. Only required in Access API. */
  file_name?: string;
  /** GDPR bucket_name to upload to data to. Only required in Access API. */
  bucket_name?: string;
  /** S3 region where the bucket exists. Only required in Access API. */
  region?: string;
}

export interface PiperGdprCallback {
  /** Unique Id corresponding to the request on GDPR API Server. */
  gdpr_id: string;
  /**
   * success or failed.
   * @example "success"
   */
  status: string;
  /** Optional, error message in case of failure. */
  error?: string;
  /** Optional, send only if the service is uploading to it's own bucket. */
  fileUrl?: string;
  /** Set to true when no User Pii data is available with the service, empty file should not be uploaded to S3 bucket. */
  noData?: boolean;
}

/** The title in the request body. */
export enum PiperGdprTitle {
  RightToAccess = 'Right to access',
  RightToErasure = 'Right to erasure',
  RightToRestrict = 'Right to restrict',
  RightToPortability = 'Right to portability',
}

export interface PiperDeviceLogsRequest {
  /**
   * A key that is identified by client as a searching option
   * @maxLength 100
   */
  key: string;
}

export interface PiperHubLogsRequest {
  /**
   * A key that is identified by client as a searching option
   * @maxLength 100
   */
  key: string;
}

export interface PostinoRecommendationList {
  /**
   * Recommendation deliver interval.
   * Unit is a second.
   * Client will request recommendation list again at least after ttl time.
   * @format int64
   * @example 1366338021
   */
  ttl: number;
  /**
   * The ID of the location in which the recommendation was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId: string;
  items: PostinoRecommendation[];
}

/**
 * map of filter name and filter string
 * @example {"MinOneUIVersion":"1.0.0","MaxOneUIVersion":"5.4.1","MinSmartThingsKitVersion":"1.0.0","MaxSmartThingsKitVersion":"1.2.3"}
 */
export type ClientFilters = Record<string, string>;

export interface PostinoRecommendation {
  /**
   * Unique identifier of the campaign
   * @example "ST_VISION_RECOMMENDATION"
   */
  campaignId: string;
  /**
   * Unique identifier of the recommendation
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  recommendationId: string;
  /** The Card GUI information */
  template: PostinoRecommendationTemplate;
  /** The action when user clicks on the recommendation card. */
  action: PostinoRecommendationAction;
  /** map of filter name and filter string */
  clientFilters?: ClientFilters;
}

export interface PostinoRecommendationTemplate {
  id: 'TEXT_ONLY' | 'ICON_TEXT' | 'THUMBNAIL_TEXT' | 'BACKGROUND_TYPE';
  textOnly?: PostinoTextOnlyTemplate;
  iconText?: PostinoIconTextTemplate;
  thumbnailText?: PostinoThumbnailTextTemplate;
  backgroundType?: PostinoBackgroundTypeTemplate;
}

export interface PostinoTextOnlyTemplate {
  background: {
    /** @example "ff808080" */
    color: string;
  };
  body: {
    /**
     * The recommendation card text displayed on the client.
     * @example "Did you know you can make your home safer with 'ST Vision'?"
     */
    text: string;
    /** @example "ff808080" */
    textColor: string;
  };
  button: {
    /** @example "View Detail" */
    text: string;
    /** @example "ff808080" */
    textColor: string;
  };
}

export interface PostinoIconTextTemplate {
  background: {
    /** @example "ff808080" */
    color: string;
  };
  body: {
    /**
     * The recommendation card text displayed on the client.
     * @example "Did you know you can make your home safer with 'ST Vision'?"
     */
    text: string;
    /** @example "ff808080" */
    textColor: string;
    /** @example "https://example.com" */
    iconUrl: string;
  };
  button: {
    /** @example "View Detail" */
    text: string;
    /** @example "ff808080" */
    textColor: string;
  };
}

export interface PostinoThumbnailTextTemplate {
  background: {
    /** @example "ff808080" */
    color: string;
  };
  body: {
    /**
     * The recommendation card text displayed on the client.
     * @example "Did you know you can make your home safer with 'ST Vision'?"
     */
    text: string;
    /** @example "ff808080" */
    textColor: string;
    /** @example "https://example.com" */
    iconUrl: string;
  };
  button: {
    /** @example "View Detail" */
    text: string;
    /** @example "ff808080" */
    textColor: string;
  };
}

export interface PostinoBackgroundTypeTemplate {
  background: {
    /** @example "https://example.com" */
    imageUrl: string;
  };
  body: {
    /**
     * The recommendation card text displayed on the client.
     * @example "Did you know you can make your home safer with 'ST Vision'?"
     */
    text: string;
    /** @example "ff808080" */
    textColor: string;
  };
}

export interface PostinoRecommendationAction {
  type: 'RECIPE' | 'WEB_LINK' | 'PLUGIN' | 'DEEP_LINK';
  /** Recipe object */
  recipe?: object;
  /** Web link action */
  webLink?: PostinoWebLinkAction;
  /** Deep link action */
  deepLink?: PostinoDeepLinkAction;
  /** Plugin action */
  plugin?: PostinoPluginAction;
}

/** Web link action */
export interface PostinoWebLinkAction {
  /** @example "https://www.smartthings.com/" */
  uri: string;
}

/** Deep link action */
export interface PostinoDeepLinkAction {
  /** @example "samsungconnect://launch?action=dashboard" */
  uri: string;
}

/** Plugin action */
export interface PostinoPluginAction {
  type?: 'DEVICE_PLUGIN' | 'SERVICE_PLUGIN';
  /** Device Plugin Action */
  devicePlugin?: PostinoDevicePluginAction;
  /** Device Plugin Action */
  servicePlugin?: PostinoServicePluginAction;
}

/** Device Plugin Action */
export interface PostinoDevicePluginAction {
  /** @example "847c3e31-c5d6-4623-953a-2b757f6f1ad9" */
  deviceId: string;
  /** @example "wwst://com.samsung.hcw" */
  pluginId: string;
  /**
   * This field is an custom data area. This structure is a map. A plugin will parse it.
   * @example {"uri":"launch_hcw_setting"}
   */
  data: object;
}

/** Device Plugin Action */
export interface PostinoServicePluginAction {
  /** @example "wwst://com.samsung.hcw" */
  pluginId: string;
  /** @example "847c3e31-c5d6-4623-953a-2b757f6f1ad9" */
  endpointAppId: string;
  /**
   * This filed is existed only 'silentInstall' is true.
   * @example "r:devices:*|w:devices:*|x:devices:*"
   */
  permissions?: string;
  /** @default false */
  silentInstall: boolean;
  /**
   * This field is an custom data area. This structure is a map. A plugin will parse it.
   * @example {"uri":"launch_hcw_setting"}
   */
  data: object;
}

export interface PostinoRecommendationPreference {
  /** If it is false, recommendations wont be returned by getRecommendations API. */
  enableRecommendations?: boolean;
}

export interface RecommendationCampaign {
  /**
   * Campaign Id generated from recommendation Admin Portal
   * @example "MISSED_ACTION_RECOMMENDATION"
   */
  campaignId: string;
  /**
   * Recommendation Id to deliver, if set postino do not choose the recommendation to deliver
   * @example "0c89ea14-7ea7-4ba5-af62-80fa93073b66"
   */
  recommendationId?: string;
  /**
   * Time to Live in utc milliseconds
   * @format int64
   * @example 1573526524641
   */
  ttl?: number;
  users: RecommendationUserDetail[];
}

export interface RecommendationUserDetail {
  /** @example "78d2558e-f13f-11e9-81b4-2a2ae2dbcce4" */
  stUserId: string;
  /**
   * Optional. Installed app id used in Pabal deepLink
   * @example "66d2558e-f13f-11e9-81b4-2a2ae2dbcca2"
   */
  installedAppId?: string;
  /** @example "88d2558e-f13f-11e9-81b4-2a2ae2dbcca2" */
  locationId: string;
}

export type RecommendationCampaignWithAction = {
  action?: 'INSERT' | 'DELETE';
} & RecommendationCampaign;

export interface PostinoGDPRRequest {
  /**
   * samsung user id
   * @example "uo0z1tkd5j"
   */
  saguid: string;
  /**
   * gdpr transaction_id for the request, unique for every request
   * @example "request-uuid-1"
   */
  gdpr_id: string;
  /**
   * gdpr title for the request
   * @example "Right to restrict"
   */
  title: string;
  /**
   * url to send callback to
   * @example "www.url.com"
   */
  callback_url?: string;
}

export interface SendCampaignEmailsRequest {
  /**
   * Campaign Id
   * @example "MISSED_ACTION_RECOMMENDATION"
   */
  campaignId: string;
  /**
   * List of email to be sent for the specified campaign
   * @maxItems 1000
   * @minItems 1
   */
  emails: {
    /**
     * recipient email address
     * @example "bob@smith.com"
     */
    recipientEmail: string;
    /**
     * recipient name
     * @example "Robert Smith"
     */
    recipientName: string;
    /**
     * email content locale
     * @example "en-US"
     */
    locale: string;
    /** any email template variables */
    data?: object;
  }[];
}

export interface Action {
  command?: CommandAction;
  location?: LocationAction;
  toggle?: ToggleAction;
  notification?: NotificationAction;
  type?: ActionType;
}

export interface CommandAction {
  devices: string[];
  commands: DeviceCommand[];
  /** The sequence in which the commands are to be executed i.e. Serial or Parallel (default) */
  sequence?: CommandSequence;
}

export interface LocationAction {
  /**
   * locationId is required for "User level rule". (It's optional for "Location level rule")
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  mode?: string;
  security?: SecurityState;
}

export interface ToggleAction {
  devices: string[];
  component: string;
  capability: string;
  attribute: string;
}

export interface NotificationAction {
  push?: PushNotification;
  audio?: AudioNotification;
  custom?: CustomNotification;
  sms?: SmsNotification;
  image?: ImageNotification;
  type?: NotificationType;
}

export enum NotificationType {
  Push = 'push',
  Audio = 'audio',
  Custom = 'custom',
  Sms = 'sms',
  Image = 'image',
}

export interface PushNotification {
  /** Push notification title */
  title?: string;
  /** Push notification message */
  message: string;
  target?: NotificationTarget;
}

export interface AudioNotification {
  /** Audio notification title */
  title?: string;
  /** Audio notification message */
  message: string;
  /** Device list where audio to be played */
  devices: string[];
  /**
   * Number of times to repeat the message, default is one
   * @format int64
   * @min 1
   * @max 10
   */
  repeat?: number;
  /**
   * Volume level
   * @format int64
   * @min 1
   * @max 100
   */
  level?: number;
  ttsProvider?: TtsProvider;
}

export interface TtsProvider {
  /** Voice provider name, Bixby (default), Polly */
  provider?: string;
  /** Language code, “en-us” (default), “ko-kr” */
  locale?: string;
  /** Voice code, “M01”, “M02” (default), “F05” */
  profile?: string;
  /** Audio encoding properties that will be used by TTS service to prepare the audio */
  output?: Output;
}

export interface Output {
  /** Encoding type. Default “PCM” */
  format?: string;
  /** Bitrate of the audio. Default 24 */
  bitrate?: number;
  /** Channel supported. Default “Mono” */
  channel?: string;
  /** Frequency supported. Default 24000 */
  freq?: number;
}

export interface CustomNotification {
  /** Default(when recipientType is not filled out or 'DEVICE' ),Device ids that would receive this noti(mobile client id) or that is used at 'Rule'(mobile presence id). If recipientType is 'LOCATION', recipients should be location id. If recipientType is 'USER' recipients should be user uuid. */
  recipients: string[];
  /** Custom notification message in pabal request format */
  message: object;
  /** DEVICE - recipients must be 'deviceId' LOCATION - recipients must be 'locationId' / USER - recipients must be 'userUuid' */
  recipientType?: RecipientType;
}

/** @example {"recipients":["sms:+19999999999"]} */
export interface SmsNotification {
  /** Sms notification message */
  message: string;
  /** List of recipients phone number. Format - ['sms:<Phone Number>'] */
  recipients: string[];
  /** Installed App Id to be added in the response */
  entityId?: string;
  /** Installed app config ID to be added in the response */
  messageGroupSet?: string;
  /** Response from Hermes API Client, To be included in the Response */
  messageGroupKey?: string;
}

/** @example {"device":{"devices":["device1"],"component":"main","capability":"imageCapture","attribute":"image","subscriptionMode":"Never"}} */
export interface ImageNotification {
  /** Image notification title */
  title?: string;
  /** Image notification message. Would be sent when image capture fails. */
  message: string;
  /** Camera list that would capture and produce event. Event musth be mentioned and triggerMode must be "NEVER" */
  device: DeviceOperand;
  /** Mention that this action is for only sending image notification or sending image take device command together. Default false. */
  onlyNoti?: boolean;
  target?: NotificationTarget;
}

export interface NotificationTarget {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  locationId?: string;
  userUuids?: string[];
}

export enum RecipientType {
  DEVICE = 'DEVICE',
  LOCATION = 'LOCATION',
  USER = 'USER',
}

export interface OperandBase {
  boolean?: boolean;
  /** @format double */
  decimal?: number;
  /** @format int64 */
  integer?: number;
  string?: string;
  array?: ArrayOperand;
  map?: MapOperand;
  device?: DeviceOperand;
  location?: LocationOperand;
  date?: DateOperand;
  /** TimeOperand is restricted to returning a value between 0 and 86399 seconds. This means that adding an offset that potentially drives the integer value outside the range of [0..86399] will cause an adjustment to bring the value back in that range */
  time?: TimeOperand;
  datetime?: DateTimeOperand;
}

export enum OperandType {
  Array = 'array',
  Boolean = 'boolean',
  Date = 'date',
  Datetime = 'datetime',
  Decimal = 'decimal',
  Device = 'device',
  Integer = 'integer',
  Location = 'location',
  Map = 'map',
  String = 'string',
  IndexedString = 'indexedString',
  Time = 'time',
}

export type Operand = OperandBase & {
  indexedString?: IndexedStringOperand;
  type?: OperandType;
};

export interface ArrayOperand {
  operands: Operand[];
  aggregation?: OperandAggregationMode;
}

export interface DateOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @format int32 */
  year?: number;
  /**
   * @format int32
   * @min 1
   * @max 12
   */
  month?: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  day?: number;
  reference?: DateReference;
}

export interface DateTimeOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  /**
   * Location ID for location actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @format int32 */
  year?: number;
  /**
   * @format int32
   * @min 1
   * @max 12
   */
  month?: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  day?: number;
  /** @default "Midnight" */
  reference: TimeReference;
  offset?: Interval;
}

export interface DeviceOperand {
  devices: string[];
  component: string;
  capability: string;
  attribute: string;
  path?: string;
  aggregation?: OperandAggregationMode;
  trigger?: TriggerMode;
}

export interface LocationOperand {
  /**
   * Required for User level rule, optional for Location level in request. Will always be present in response for both.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Only valid for the attribute 'WeatherAlertSeverity' */
  postalCode?: string;
  attribute: LocationAttribute;
  trigger?: TriggerMode;
}

export type MapOperand = Record<string, Operand>;

/** TimeOperand is restricted to returning a value between 0 and 86399 seconds. This means that adding an offset that potentially drives the integer value outside the range of [0..86399] will cause an adjustment to bring the value back in that range */
export interface TimeOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @default "Midnight" */
  reference: TimeReference;
  offset?: Interval;
}

export interface IndexedStringOperand {
  value: Operand;
  indices: string[];
}

export enum Sequence {
  Serial = 'Serial',
  Parallel = 'Parallel',
}

export interface ActionSequence {
  actions?: Sequence;
}

export interface CommandSequence {
  commands?: Sequence;
  devices?: Sequence;
}

/** @default "Interrupt" */
export enum Strategy {
  Ignore = 'Ignore',
  Interrupt = 'Interrupt',
}

export enum ExecutionResult {
  Success = 'Success',
  Failure = 'Failure',
  Ignored = 'Ignored',
}

export enum CommandExecutionResult {
  Success = 'Success',
  Failure = 'Failure',
  Offline = 'Offline',
}

/** The result of a command action execution */
export interface CommandActionExecutionResult {
  result: CommandExecutionResult;
  /**
   * Device ID for device actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
}

/** The result of a location action execution */
export interface LocationActionExecutionResult {
  result: ExecutionResult;
  /**
   * Location ID for location actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

/** The result of a notification action execution */
export interface NotificationActionExecutionResult {
  result: ExecutionResult;
  type: NotificationType;
}

export enum LightEffectExecutionStatus {
  Started = 'Started',
  Stopped = 'Stopped',
  Canceled = 'Canceled',
}

/** The result of an action execution */
export interface ActionExecutionResult {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  actionId: string;
  /** The result of a location action execution */
  location?: LocationActionExecutionResult;
  command?: CommandActionExecutionResult[];
  /** The result of a notification action execution */
  notification?: NotificationActionExecutionResult;
  type?: ActionType;
}

/** @default "None" */
export enum OperandAggregationMode {
  None = 'None',
}

/** @default "Auto" */
export enum TriggerMode {
  Auto = 'Auto',
  Always = 'Always',
  Never = 'Never',
}

export enum LocationAttribute {
  FineDust = 'FineDust',
  FineDustIndex = 'FineDustIndex',
  Humidity = 'Humidity',
  Mode = 'Mode',
  Security = 'Security',
  Temperature = 'Temperature',
  TemperatureC = 'TemperatureC',
  TemperatureF = 'TemperatureF',
  UltraFineDust = 'UltraFineDust',
  UltraFineDustIndex = 'UltraFineDustIndex',
  Weather = 'Weather',
  WeatherAlertSeverity = 'WeatherAlertSeverity',
}

export enum ArmState {
  ArmedStay = 'ArmedStay',
  ArmedAway = 'ArmedAway',
  Disarmed = 'Disarmed',
}

export interface SecurityState {
  armState: ArmState;
  monitoring?: boolean;
}

export enum DateReference {
  Today = 'Today',
}

export enum TimeReference {
  Now = 'Now',
  Midnight = 'Midnight',
  Sunrise = 'Sunrise',
  Noon = 'Noon',
  Sunset = 'Sunset',
}

export enum DayOfWeek {
  Sun = 'Sun',
  Mon = 'Mon',
  Tue = 'Tue',
  Wed = 'Wed',
  Thu = 'Thu',
  Fri = 'Fri',
  Sat = 'Sat',
}

export interface Interval {
  value: Operand;
  unit: IntervalUnit;
}

export enum IntervalUnit {
  Second = 'Second',
  Minute = 'Minute',
  Hour = 'Hour',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}

export interface SceneAdhocRequest {
  /** The user-defined name of the Scene */
  name?: string;
  /** List of actions (CommandAction + LocationAction) to be executed */
  actions: Action[];
  /** The sequence in which the actions are to be executed i.e. Serial or Parallel (default) */
  sequence?: ActionSequence;
  /** Unstructured object for client to store additional data */
  meta?: object;
}

/** The result of a Scene execution */
export interface SceneExecutionResponse {
  /**
   * Unique identifier of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  executionId: string;
  /** Result of the execution of scene (Success/Failure) */
  result: ExecutionResult;
  /** List of actions' execution results */
  actions?: ActionExecutionResult[];
}

/**
 * The owner of the rule is either a location or user
 * @default "Location"
 */
export enum OwnerType {
  Location = 'Location',
  User = 'User',
}

/** The creator name who create the behavior */
export enum Creator {
  SMARTTHINGS = 'SMARTTHINGS',
  ARB = 'ARB',
  RECIPE = 'RECIPE',
  UNDEFINED = 'UNDEFINED',
}

/** Request to create a virtual device. You can either specify a `deviceProfileId` or `deviceProfile` definition that will be automatically provisioned. */
export type VirtualDeviceCreateRequest = {
  owner: DeviceOwner;
  /** Device profile identifier for a virtual device. Required unless the `deviceProfile` field is populated. */
  deviceProfileId?: DeviceProfileId;
  deviceProfile?: DeviceProfile;
  /** The name of the device. */
  name: Name;
  /**
   * ID of the room to install the device into. Only applicable for `LOCATION` owned devices.
   * @format uuid
   */
  roomId?: string;
  commandMappings?: CommandMappings;
  /** The environmental context in which this device executes. */
  executionTarget?: ExecutionTarget;
  /** Identifier for the hub associated with a virtual device (only applicable for locally executing devices). */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** the ID of the Edge channel containing the driver ID. */
  channelId?: ChannelId;
};

export type DeviceOwner = {
  /** The type of owner the device will be installed with. Currently only `LOCATION` is available, but with the intention of supporting `USER` later on. */
  ownerType?: DeviceOwnerType;
  /** The owner ID for the device. */
  ownerId?: OwnerId;
};

export interface DeviceComponentRequest {
  /** UTF-8 label for the component. */
  label?: string;
  /**
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   * @example "main"
   */
  id: string;
  /**
   * A list of `[ 1..20 ]` capabilities for this component.
   * @maxItems 20
   * @minItems 1
   */
  capabilities: CapabilityReferenceRequest[];
  categories: DeviceCategory[];
  /** A typed model which describes a restriction pertaining to a platform entity. */
  restrictions?: Restriction;
}

/** @example {"title":"Temperature Offset","description":"The offset for a particular temperature setting","required":false,"preferenceType":"number","definition":{"minimum":-10,"maximum":10,"default":0}} */
export interface PreferenceRequest {
  /** The ID of the preference */
  preferenceId?: string;
  /**
   * An alphanumeric English language name for this preference. Will be appended to a namespace to generate the full preference id.
   * @pattern ^[a-zA-Z0-9][a-zA-Z0-9 ]{1,35}$
   * @example "tempOffset"
   */
  name: string;
  /**
   * A short description for this preference.
   * @example "Temperature Offset"
   */
  title: string;
  /**
   * A long description for this preference.
   * @example "The offset for a particular temperature setting"
   */
  description?: string;
  /**
   * A flag describing whether this preference is explicit, or inline.
   * @default false
   */
  explicit?: boolean;
  /**
   * A flag describing whether this property is required or not.
   * @default false
   */
  required?: boolean;
  /** The type of preference this is. */
  preferenceType: PreferenceType;
  /** The definition of this preference. */
  definition: {
    /**
     * Minimum value a preference may be set to. Only valid for `integer` and `number` preference types.
     * @format double
     */
    minimum?: number;
    /**
     * Maximum value a preference may be set to. Only valid for `integer` and `number` preference types.
     * @format double
     */
    maximum?: number;
    /** Minimum length a string may be set to. Only valid for `string` preference type. */
    minLength?: number;
    /** Maximum length a string may be set to. Only valid for `string` preference type. */
    maxLength?: number;
    /** Default value for a preference. */
    default?: any;
    /** The type of a string preference. `text` is a normal preference, `password` encrypts the values, and `paragraph` is for documentation purposes. */
    stringType?: 'text' | 'password' | 'paragraph';
    /** The available selections for an `enumeration` preference. */
    options?: Record<string, string>;
  };
}

export interface DeviceProfileConfig {
  /** Provides custom configuration for the automation view associated with the implicitly generated device configuration. */
  automation?: AutomationConfiguration;
}

/** Provides custom configuration for the automation view associated with the implicitly generated device configuration. */
export interface AutomationConfiguration {
  /** Provides custom configuration for each automation action item. */
  actions?: AutomationActionItemConfiguration[];
}

/** Provides custom configuration for an automation action item. For example, this configuration may be used exclude specific capabilities from an automation action item. */
export interface AutomationActionItemConfiguration {
  /** ID of the capability associated with the action */
  capability: string;
  config: {
    exclusion?: {
      exclude?: ExcludedActionItem[];
    };
  };
}

export interface ExcludedActionItem {
  /** @example "pictureMode" */
  capability?: string;
}

/**
 * Device profile identifier for a virtual device. Required unless the `deviceProfile` field is populated.
 * @format uuid
 */
export type DeviceProfileId = string;

/**
 * The name of the device.
 * @example "Virtual Switch"
 */
export type Name = string;

/** The owner ID for the device. */
export type OwnerId = string;

/**
 * The type of owner the device will be installed with. Currently only `LOCATION` is available, but with the intention of supporting `USER` later on.
 * @example "LOCATION"
 */
export enum DeviceOwnerType {
  LOCATION = 'LOCATION',
}

/**
 * Identifier for the hub associated with a virtual device (only applicable for locally executing devices).
 * @format uuid
 */

// removed this line because it is a duplicate definition
// export type HubId = string;

/**
 * the ID of the Edge channel containing the driver ID.
 * @format uuid
 */
export type ChannelId = string;

/**
 * The environmental context in which this device executes.
 * @default "CLOUD"
 * @example "CLOUD"
 */
export enum ExecutionTarget {
  CLOUD = 'CLOUD',
  LOCAL = 'LOCAL',
}

/** Request to create a virtual device from a prototype. */
export type VirtualDeviceFromPrototypeRequest = {
  /** The name of the device. */
  name: Name;
  /**
   * The prototype type, or template, that will determine the kind of device created.
   * @example "VIRTUAL_SWITCH"
   */
  prototype:
    | 'VIRTUAL_BUTTON'
    | 'VIRTUAL_CAMERA'
    | 'VIRTUAL_COLOR_BULB'
    | 'VIRTUAL_CONTACT_SENSOR'
    | 'VIRTUAL_DIMMER'
    | 'VIRTUAL_DIMMER_SWITCH'
    | 'VIRTUAL_GARAGE_DOOR_OPENER'
    | 'VIRTUAL_HUMIDITY_SENSOR'
    | 'VIRTUAL_LOCK'
    | 'VIRTUAL_METERED_SWITCH'
    | 'VIRTUAL_MOTION_SENSOR'
    | 'VIRTUAL_MULTI_SENSOR'
    | 'VIRTUAL_PRESENCE_SENSOR'
    | 'VIRTUAL_REFRIGERATOR'
    | 'VIRTUAL_REMOTE'
    | 'VIRTUAL_RGBW_BULB'
    | 'VIRTUAL_SIREN'
    | 'VIRTUAL_SMOKE_DETECTOR'
    | 'VIRTUAL_SWITCH'
    | 'VIRTUAL_TEMPERATURE_SENSOR'
    | 'VIRTUAL_THERMOSTAT'
    | 'VIRTUAL_WATER_SENSOR'
    | 'VIRTUAL_WATER_VALVE'
    | 'VIRTUAL_WHITE_BULB'
    | 'VIRTUAL_WINDOW_TREATMENT';
  owner: DeviceOwner;
  /**
   * ID of the room to install the device into. Only applicable for `LOCATION` owned devices.
   * @format uuid
   */
  roomId?: string;
  /** The environmental context in which this device executes. */
  executionTarget?: ExecutionTarget;
  /** Identifier for the hub associated with a virtual device (only applicable for locally executing devices). */
  hubId?: HubId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** the ID of the Edge channel containing the driver ID. */
  channelId?: ChannelId;
};

export interface PostinoPresetRoutinesList {
  /**
   * The ID of the location in which the routines was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId?: string;
  items: PostinoPresetCategory[];
}

export interface PostinoPresetCategory {
  /**
   * Unique identifier of the preset category
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  categoryId: string;
  /**
   * Translated text for category title(Based on Accept-Language Header)
   * @example "Arriving and Leaving"
   */
  categoryTitle: string;
  /**
   * Translated text for category description(Based on Accept-Language Header)
   * @example "Description for Arriving and Leaving."
   */
  categoryDescription: string;
  /**
   * image URL for category icon
   * @example "http://icon-example.com"
   */
  categoryIcon: string;
  /** CategoryImage of light and dark CategoryImageUrl. */
  categoryImage: PostinoPresetCategoryImage;
  /** List of Preset */
  preset: PostinoPreset[];
}

/** CategoryImage of light and dark CategoryImageUrl. */
export interface PostinoPresetCategoryImage {
  /** @example "http://lightcategoryimage-example.com" */
  lightCategoryImageUrl: string;
  /** @example "http://darkcategoryimage-example.com" */
  darkCategoryImageUrl: string;
}

export interface PostinoPreset {
  /**
   * Unique identifier of the preset
   * @example "522e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  presetId: string;
  /** @example "431e28ca-c33b-49c9-a5a1-dce40e41f8a4" */
  routineTemplateId: string;
  /**
   * Translated text for preset title(Based on Accept-Language Header)
   * @example "Notify when someone arrive"
   */
  presetTitle: string;
  /**
   * Translated text for preset description(Based on Accept-Language Header)
   * @example "Description for Notify when someone arrive."
   */
  presetDescription: string;
  /**
   * version of rule
   * @example "0.0.1"
   */
  ruleVersion: string;
  /** Recommended routine body template(from rabbit) */
  routineTemplate: RuleRequest;
}

export type RuleRequest = RuleRequestBase & {
  /** Unstructured object for client to store additional data */
  meta?: object;
  /** The status of the Rule */
  status?: Status;
  /** The location where the rule is executing, either local or cloud */
  executionLocation?: ExecutionLocation;
};

export interface RuleRequestBase {
  /** The name for the Rule. Limit 100 characters. */
  name: string;
  actions: Action[];
  /** The sequence in which the actions are to be executed (i.e. Serial (default) or Parallel). */
  sequence?: ActionSequence;
  /** The time zone ID for this Rule. This overrides the Location time zone ID, but is overridden by time zone ID provided by each operand individually. */
  timeZoneId?: string;
}

/**
 * The status of the Rule
 * @default "Enabled"
 */
export enum Status {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

/** The location where the rule is executing, either local or cloud */
export enum ExecutionLocation {
  Cloud = 'Cloud',
  Local = 'Local',
}

export interface GetActivityHistoriesParams {
  /** One Location ID. */
  location: string;
  /** List of device IDs. e.g. device=f33cc984-cde7-4d61-b3b7-a78de9ab5a37&device=f33cc984-cde7-4d61-b3b7-a78de9ab5a37 */
  device?: string[];
  /**
   * Paging parameter for going to previous page. Before epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate previous page) with event time before the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  before?: number;
  /**
   * Paging parameter for going to previous page. Before Hash (long). This needs to be specified when 'before' is specified.
   *  Please put in associated hash value of the record specified by the 'before' parameter.
   * @format int64
   */
  beforeHash?: number;
  /**
   * Paging parameter for going to next page. After epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate next page) with event time after the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  after?: number;
  /**
   * Paging parameter for going to next page. After Hash (long). this needs to be specified when 'after' is specified.
   *  Please put in associated hash value of the record specified by the 'after' parameter.
   * @format int64
   */
  afterHash?: number;
  /**
   * Number of records to return. Default is 20.
   * @default 20
   */
  limit?: number;
  /** Optional. This controls ordering of results. When not specified or 'oldestFirst=false', server will list newest history first, aka descending order.  */
  oldestFirst?: boolean;
  /** Optional parameter to filter by activities type, defaults to include everything. */
  include?: ('device' | 'execution' | 'mode')[];
  /**
   * Optional parameter that determines whether to include history of user level device.
   * @default false
   */
  includeUserLevelDeviceHistory?: boolean;
  /**
   * Optional parameter that determines whether to include rule execution of user level device.
   * @default false
   */
  includeUserLevelExecutionHistory?: boolean;
  /**
   * Optional parameter that determines whether to include native app history.
   * @default false
   */
  includeNativeAppHistory?: boolean;
}

export interface GetExecutionActionsParams {
  /**
   * Paging parameter for going to previous page. Before epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate previous page) with event time before the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  before?: number;
  /**
   * Paging parameter for going to previous page. Before Hash (long). This needs to be specified when 'before' is specified.
   *  Please put in associated hash value of the record specified by the 'before' parameter.
   * @format int64
   */
  beforeHash?: number;
  /**
   * Paging parameter for going to next page. After epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate next page) with event time after the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  after?: number;
  /**
   * Paging parameter for going to next page. After Hash (long). this needs to be specified when 'after' is specified.
   *  Please put in associated hash value of the record specified by the 'after' parameter.
   * @format int64
   */
  afterHash?: number;
  /**
   * Number of records to return. Default is 20. Max is 100.
   * @default 20
   */
  limit?: number;
  /** Optional. This controls ordering of results. When not specified or 'oldestFirst=false', server will list newest history first, aka descending order.  */
  oldestFirst?: boolean;
  /** execution's Location ID */
  locationId: string;
  /** Execution ID */
  executionId: string;
}

export interface QueryVersionOnServerParams {
  deviceType: string;
}

export interface GetCamerasParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface RecordPayload {
  /**
   * The IS0-8601 date time string in UTC for the start time.
   * @example "2018-02-14T12:44:18+00:00"
   */
  startTime: string;
  /**
   * The IS0-8601 date time string in UTC for the capture time.
   * @example "2018-02-14T12:44:18+00:00"
   */
  captureTime: string;
  /**
   * The IS0-8601 date time string in UTC for the end time.
   * @example "2018-02-14T12:44:18+00:00"
   */
  endTime: string;
}

export interface ListConnectedServicesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Denotes the principal type. */
  principalType?: 'LOCATION' | 'USER_LEVEL';
}

export interface UninstallConnectedServiceParams {
  /** The type of the connected service to uninstall */
  type?: 'SMARTAPP' | 'ENDPOINTAPP' | 'VIPER';
  /** The id of the connected service to uninstall */
  id: string;
}

export interface ListSortOrderRoomParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** the room ID */
  roomId: string;
}

export interface UpdateSortOrderRoomParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** the room ID */
  roomId: string;
}

export interface ListSortOrderRoomsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface UpdateSortOrderRoomsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface ListSortOrderScenesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type UpdateSortOrderScenesPayload = string[];

export interface UpdateSortOrderScenesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface ListSortOrderLightingGroupsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface UpdateSortOrderLightingGroupsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface ListSortOrderCameraGroupsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface UpdateSortOrderCameraGroupsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface ListDeviceGroupsParams {
  /** The device group locations to filter the results by. */
  locationId?: string[];
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface GetDevicesParams {
  /**
   * If true will return hidden devices, else they will be filtered out.
   * @default false
   */
  includeHidden?: boolean;
  /**
   * The device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The device locations to filter the results by. */
  locationId?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /**
   * Include the status of the device's capabilities where permission is adequate to view them.
   * This requires `r:devices` permission.
   */
  includeStatus?: boolean;
  /** Include the Health status of the device. This requires `r:devices` permission. */
  includeHealth?: boolean;
  /** The device types to filter the results by. */
  type?: string[];
  /** The device categories to filter the results by. */
  category?: string[];
  /**
   * Treat all capability filter query params as a logical "or" or "and" with a default of "and".
   * @default "and"
   */
  capabilitiesMode?: 'or' | 'and';
  /**
   * Restricted devices are hidden by default. This query parameter will reveal them. Device status will
   * not be provided if the token does not have sufficient access level to view the device status even
   * if includeStatus parameter is set to true.
   */
  includeRestricted?: boolean;
  /** Only list devices accessible by the given accessLevel. */
  accessLevel?: number;
  /**
   * User-level devices are devices that are not tied to a location, but are instead tied to the user. In order
   * to include these devices in the list, a flag is needed to differentiate from devices listed by location.
   */
  includeUserDevices?: boolean;
  /**
   * GROUP type devices are devices that represent Device Groups. In order to include these devices in the list,
   * a flag needs to be included.
   */
  includeGroups?: boolean;
  /** Use this in conjunction with includeUserDevices to get only User-level devices. */
  excludeLocationDevices?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
}

export interface GetDeviceParams {
  /**
   * Include the status of the device's capabilities where permission is adequate to view them.
   * This requires `r:devices` permission.
   */
  includeStatus?: boolean;
  /** Expand the child device details nested in the device's description. */
  includeChildren?: boolean;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
  /** Include the Health status of the device. This requires `r:devices` permission. */
  includeHealth?: boolean;
  /** The device's id */
  deviceId: string;
}

export interface UpdateDeviceParams {
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
  deviceId: string;
}

export interface ListDeviceHealthByLocationIdParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Include the actions permitted by this token's access for each individual resource. */
  includeAllowedActions?: boolean;
}

export interface ListDeviceStatusesParams {
  /** The Locations to filter the results by. */
  locationId?: string[];
  /**
   * The device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /** If the device status should include data. */
  includeData?: boolean;
  /** Limit status results to only include capabilities found in the capability query. */
  filterByCapabilities?: boolean;
}

export interface ListDeviceGroupStatusesParams {
  /** The Locations to filter the results by. */
  locationId?: string[];
  /**
   * The device capabilities to filter the results by.
   * If present, only statuses for capabilties in this list will be returned.
   */
  capability?: string[];
  /** If the device status should include data. */
  includeData?: boolean;
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface GetCapabilityAttributeIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The capability ID for the icon. */
  capabilityId: string;
  /** The attribute name for the icon. */
  attributeName: string;
}

export interface GetOcfDeviceTypeIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The OCF Device Type for the icon. */
  ocfDeviceType: string;
}

export interface GetSceneIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The Scene key for the icon. */
  sceneIcon: string;
}

export interface GetOneuiIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The oneui icon key for the icon. */
  oneuiIcon: string;
  /** The oneui state for the icon. */
  oneuiIconState: string;
}

export interface GetPreloadIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The preload icon key for the icon. */
  preloadIcon: string;
  /** The preload state for the icon. */
  preloadIconState: string;
}

export interface GetGroupIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The group icon key for the icon. */
  groupIcon: string;
  /** The group state for the icon. */
  groupIconState: string;
}

export interface ListInstalledAppSummariesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** A filter for only fetching apps of some types */
  appType?: ('SMARTAPP' | 'ENDPOINTAPP')[];
  /** If set to true, endpoint apps may include the allow list property */
  allowed?: boolean;
}

export interface UninstallInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface PauseInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface ResumeInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface OtaUpgradePayload {
  /**
   * URL of the OTA version to upgrade to
   * @example "http://version.broadlink.com/firmware/download/12345.bin"
   */
  url?: string;
}

export interface UpdateRoomsAndDevicesForLocationParams {
  locationId: string;
}

export interface GetInvitesParams {
  /** Filter by invitation status. Default is PENDING. */
  status?: string;
}

export interface GetAllModesParams {
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
}

export interface GetAllCurrentModesParams {
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
}

export interface CreateLocationParams {
  /**
   * If set to true, the response may contain the allowed list property.  Note that setting this to true may significantly slow the response time.  If you are creating a location for your own account, then you know you will have all these permissions and can avoid the trouble of passing in this parameter.
   * @default false
   */
  allowed?: boolean;
}

export interface UpdateLocationParams {
  locationId: string;
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
}

export interface GetNotificationsParams {
  /** One or more Location ID. */
  location: string[];
  /** Optional. List of device IDs. e.g. device=f33cc984-cde7-4d61-b3b7-a78de9ab5a37&device=f33cc984-cde7-4d61-b3b7-a78de9ab5a37 */
  device?: string[];
  /**
   * Paging parameter for going to previous page. Before epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate previous page) with event time before the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  before?: number;
  /**
   * Paging parameter for going to previous page. Before Hash (long). This needs to be specified when 'before' is specified.
   *  Please put in associated hash value of the record specified by the 'before' parameter.
   * @format int64
   */
  beforeHash?: number;
  /**
   * Paging parameter for going to next page. After epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate next page) with event time after the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  after?: number;
  /**
   * Paging parameter for going to next page. After Hash (long). this needs to be specified when 'after' is specified.
   *  Please put in associated hash value of the record specified by the 'after' parameter.
   * @format int64
   */
  afterHash?: number;
  /**
   * Optional. Number of records to return. Default is 20.
   * @default 20
   */
  limit?: number;
  /** Optional parameter to filter by notification type, defaults to include everything. */
  include?: ('device' | 'others')[];
  /**
   * Optional parameter that determines whether to include notification of user level device.
   * @default false
   */
  includeUserLevelNotificationHistory?: boolean;
}

export interface Link6 {
  /** The device group locations to filter the results by. */
  locationId?: string[];
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface GetPiperLogsParams {
  /** The log type. */
  logType?: 'EASYSETUP' | 'HUB' | 'DEVICE';
  /** max number to retrieve items for pagination */
  limit?: number;
  /** The index where the items should be fetched from */
  offset?: number;
  /** A key that is identified by client as a searching option */
  key?: string;
}

export interface GetRecommendationsParams {
  /**
   * Id of the location
   * @format UUID
   */
  locationId: string;
}

export interface GetPresetRoutinesParams {
  /**
   * Id of the location
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Selected translation code from user device , ex: en-US */
  locale?: string;
  /** TestMode for testing and return routine when status are approve and active */
  testMode?: boolean;
}

export interface ListScenesParams {
  /**
   * The ID of the location to list the scenes for.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** The owner of the scene (USER | LOCATION) */
  ownerType?: 'LOCATION' | 'USER';
  /**
   * If set to true, the items in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
  /** The max number of scenes to fetch */
  max?: number;
  /** The start index of scenes to fetch */
  offset?: number;
  /** Creator who created the behavior */
  creators?: ('SMARTTHINGS' | 'ARB' | 'RECIPE' | 'UNDEFINED')[];
}

export interface CreateSceneParams {
  /**
   * The ID of the location in which to create the scene in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * If set to true, the item in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
}

export interface DeleteAllScenesParams {
  /**
   * The ID of the location in which the scenes must be deleted.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetSceneParams {
  /**
   * The ID of the location to list the scenes for.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * If set to true, the items in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
  /**
   * The ID of a Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
}

export interface UpdateSceneParams {
  /**
   * The ID of the location in which to update the scene in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * If set to true, the item in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
  /**
   * The ID of a Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
}

export interface DeleteSceneParams {
  /**
   * The ID of the location in which to delete the scene in.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of a Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
}

export interface ExecuteAdhocSceneParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface ExecuteSceneParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of a Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
}

export interface GetSwatchesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The time stamp of the last partial response */
  since?: string;
}

export interface GetSwatchStatusesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetUiMetadataParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Specify testmode or normalmode. */
  mode?: 'TEST' | 'NORMAL';
  /** Parameter for UI Metadata version. */
  metaVersion?: string;
  /** Parameter for UI Metadata Device version. */
  deviceVersion?: string;
}

export interface GetUiMetadataByDeviceIdParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Specify testmode or normalmode. */
  mode?: 'TEST' | 'NORMAL';
  /** Parameter for UI Metadata version. */
  metaVersion?: string;
  /** Parameter for UI Metadata Device version. */
  deviceVersion?: string;
  /** The Device ID */
  deviceId: string;
}

export interface GetUiMetadataByMnmnVidParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Specify testmode or normalmode. */
  mode?: 'TEST' | 'NORMAL';
  /** Parameter for UI Metadata version. */
  metaVersion?: string;
  /** Parameter for UI Metadata Device version. */
  deviceVersion?: string;
  mnmn: string;
  vid: string;
}

export interface GetUiMetadataDeviceVersionParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Parameter for UI Metadata version. */
  metaVersion?: string;
  mnmn: string;
  vid: string;
}

export interface GetDevicesByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /**
   * Response of getOauthCallback API depends on this query parameter. If true, returns an HTML page with redirect link else returns an HTML page with "connection successful/failed" text.
   * @default false
   */
  redirectRequested?: boolean;
  /** isaId of the user. */
  isaId: string;
}

export interface PutIsaByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /** isaId */
  isaId: string;
}

export interface DeleteIsaByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /** isaId of the user. */
  isaId: string;
}

export interface GetPagesParams {
  /** page type */
  type: string;
  /** location id of the user */
  locationId: string;
  /**
   * Response of getOauthCallback API depends on this query parameter. If true, returns an HTML page with redirect link else returns an HTML page with "connection successful/failed" text.
   * @default false
   */
  redirectRequested?: boolean;
  /** SmartThings Schema App id */
  endpointAppId: string;
}

export interface GetVoiceAssistantsParams {
  /**
   * Country code in ISO Alpha-2 format
   * @format [A-Z]{2}
   * @default "US"
   */
  country?: string;
}

export interface GetLocationWallpaperParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface UpdateLocationWallpaperParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface MigrateWallpapersParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetValidWallpapersParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetRoomWallpapersParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetRoomWallpaperParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** the room ID */
  roomId: string;
}

export interface UpdateRoomWallpaperParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** the room ID */
  roomId: string;
}

export interface GetWeatherDataParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type CreateWidgetFavoritesPayload = CreateSceneWidgetFavoriteRepresentation[];

export interface ListVirtualDevicesParams {
  /**
   * The ID of the Location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://client.smartthings.com';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Client API
 * @version 3.0
 * @baseUrl https://client.smartthings.com
 *
 * API endpoints for mobile clients
 */
export class ClientV3Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  activities = {
    /**
     * @description Retrieve device and execution activity history. Can be filtered by location IDs and/or a list of device IDs. Location filter will apply to all events. Other filtering are based on source of event (device, execution, or location mode). For example if device IDs is specified, only device activities will be returned. When both location and devices filter are specified, only device activities in the specified locations will be returned.
     *
     * @tags activities
     * @name GetActivityHistories
     * @summary Retrieve device, execution, mode and native activity history
     * @request GET:/activities
     * @secure
     */
    getActivityHistories: (query: GetActivityHistoriesParams, request: ActivitiesRequest, params: RequestParams = {}) =>
      this.request<ActivityHistoryPage, void>({
        path: `/activities`,
        method: 'GET',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve list of execution action
     *
     * @tags activities
     * @name GetExecutionActions
     * @summary Retrieve execution action details
     * @request GET:/activities/{locationId}/executions/{executionId}/actions
     * @deprecated
     * @secure
     */
    getExecutionActions: (
      { locationId, executionId, ...query }: GetExecutionActionsParams,
      params: RequestParams = {},
    ) =>
      this.request<ExecutionActionsResponse, void>({
        path: `/activities/${locationId}/executions/${executionId}/actions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  broadlink = {
    /**
     * No description
     *
     * @tags broadlink
     * @name GetDevType
     * @summary Get device types
     * @request GET:/broadlink/devtype
     */
    getDevType: (params: RequestParams = {}) =>
      this.request<DevTypes, any>({
        path: `/broadlink/devtype`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetBrand
     * @summary Get brands
     * @request GET:/broadlink/devtype/{devTypeId}/brand
     */
    getBrand: (devTypeId: string, params: RequestParams = {}) =>
      this.request<Brands, any>({
        path: `/broadlink/devtype/${devTypeId}/brand`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetIrCode
     * @summary Get ircode info
     * @request GET:/broadlink/devtype/{devTypeId}/brand/{brandId}/ircode
     */
    getIrCode: (devTypeId: string, brandId: string, params: RequestParams = {}) =>
      this.request<IrCodes, any>({
        path: `/broadlink/devtype/${devTypeId}/brand/${brandId}/ircode`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetLocate
     * @summary Get location information
     * @request GET:/broadlink/location/{locationId}
     */
    getLocate: (locationId: string, params: RequestParams = {}) =>
      this.request<SubAreaInfo, any>({
        path: `/broadlink/location/${locationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetProvider
     * @summary Get provider info for a location
     * @request GET:/broadlink/location/{locationId}/provider
     */
    getProvider: (locationId: string, params: RequestParams = {}) =>
      this.request<Providers, any>({
        path: `/broadlink/location/${locationId}/provider`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetProviderBrand
     * @summary Get full list of provider brands
     * @request GET:/broadlink/provider/brand
     */
    getProviderBrand: (params: RequestParams = {}) =>
      this.request<ProviderBrands, any>({
        path: `/broadlink/provider/brand`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetChannel
     * @summary Get list of channels for a location and provider
     * @request GET:/broadlink/location/{locationId}/provider/{providerId}/channel
     */
    getChannel: (locationId: string, providerId: string, params: RequestParams = {}) =>
      this.request<Channels, any>({
        path: `/broadlink/location/${locationId}/provider/${providerId}/channel`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name MatchIrCode
     * @summary Match IR Code
     * @request GET:/broadlink/dnacode/{dnaCode}
     */
    matchIrCode: (dnaCode: string, params: RequestParams = {}) =>
      this.request<MatchIRCode, any>({
        path: `/broadlink/dnacode/${dnaCode}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name QueryVersionOnServer
     * @summary Query the OTA version on server
     * @request GET:/broadlink/ota/version/server
     */
    queryVersionOnServer: (query: QueryVersionOnServerParams, params: RequestParams = {}) =>
      this.request<OTAVersions, any>({
        path: `/broadlink/ota/version/server`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  cameras = {
    /**
     * @description Get list of cameras suitable for use with SHM for a location
     *
     * @tags cameras
     * @name GetCameras
     * @summary Get list of cameras for a location
     * @request GET:/cameras
     * @secure
     */
    getCameras: (query: GetCamerasParams, params: RequestParams = {}) =>
      this.request<Camera[], any>({
        path: `/cameras`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description start recording for the camera
     *
     * @tags cameras
     * @name Record
     * @summary Start recording for the camera
     * @request POST:/cameras/{deviceId}/record
     */
    record: (deviceId: string, recordingParams: RecordPayload, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/cameras/${deviceId}/record`,
        method: 'POST',
        body: recordingParams,
        type: ContentType.Json,
        ...params,
      }),
  };
  connectedservices = {
    /**
     * @description Fetch a list of ConnectedServices. Only one of PrincipalType or locationId can be sent as parameter. Never both
     *
     * @tags connectedservices
     * @name ListConnectedServices
     * @summary List Connected Services
     * @request GET:/connectedservices
     * @secure
     */
    listConnectedServices: (query: ListConnectedServicesParams, params: RequestParams = {}) =>
      this.request<ConnectedServiceSummary[], void>({
        path: `/connectedservices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Uninstall the connected service for the given id. Type is optional and functions as advice to cloud for where the app should be removed resulting in an optimization. If there are only errored results, and at least one is not HTTP 403, throw an ApiException with the highest error code.
     *
     * @tags connectedservices
     * @name UninstallConnectedService
     * @summary Uninstall
     * @request DELETE:/connectedservices/{id}
     * @secure
     */
    uninstallConnectedService: ({ id, ...query }: UninstallConnectedServiceParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, ErrorResponse>({
        path: `/connectedservices/${id}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  detailsPage = {
    /**
     * @description Get all device Ids for a given room of a location in sorted order.
     *
     * @tags detailsPage
     * @name ListSortOrderRoom
     * @summary Sort ordered list of device Ids
     * @request GET:/detailsPage/sortOrder/room/{roomId}
     * @secure
     */
    listSortOrderRoom: ({ roomId, ...query }: ListSortOrderRoomParams, params: RequestParams = {}) =>
      this.request<DeviceList, void>({
        path: `/detailsPage/sortOrder/room/${roomId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of device Ids for a room.  Must provide all device Ids for a room.
     *
     * @tags detailsPage
     * @name UpdateSortOrderRoom
     * @summary Update sort order of deviceIds for a room
     * @request PUT:/detailsPage/sortOrder/room/{roomId}
     * @secure
     */
    updateSortOrderRoom: (
      { roomId, ...query }: UpdateSortOrderRoomParams,
      jsonBody: string[],
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/detailsPage/sortOrder/room/${roomId}`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        ...params,
      }),

    /**
     * @description Get all rooms for a given location in sorted order.
     *
     * @tags detailsPage
     * @name ListSortOrderRooms
     * @summary Sort ordered list of rooms
     * @request GET:/detailsPage/sortOrder/rooms
     * @secure
     */
    listSortOrderRooms: (query: ListSortOrderRoomsParams, params: RequestParams = {}) =>
      this.request<DeviceList, void>({
        path: `/detailsPage/sortOrder/rooms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of room Ids for a locations.  Must provide all room Ids.
     *
     * @tags detailsPage
     * @name UpdateSortOrderRooms
     * @summary Update rooms sort order for a location
     * @request PUT:/detailsPage/sortOrder/rooms
     * @secure
     */
    updateSortOrderRooms: (query: UpdateSortOrderRoomsParams, jsonBody: string[], params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/detailsPage/sortOrder/rooms`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        ...params,
      }),

    /**
     * @description Get all scene Ids from a location in sorted order.
     *
     * @tags detailsPage
     * @name ListSortOrderScenes
     * @summary Sort ordered list of scene Ids
     * @request GET:/detailsPage/sortOrder/scenes
     * @secure
     */
    listSortOrderScenes: (query: ListSortOrderScenesParams, params: RequestParams = {}) =>
      this.request<DeviceList, void>({
        path: `/detailsPage/sortOrder/scenes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of scene Ids for a location.  Must provide all scene Ids for a location.
     *
     * @tags detailsPage
     * @name UpdateSortOrderScenes
     * @summary Update sort order of Scenes
     * @request PUT:/detailsPage/sortOrder/scenes
     * @secure
     */
    updateSortOrderScenes: (
      query: UpdateSortOrderScenesParams,
      jsonBody: UpdateSortOrderScenesPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/detailsPage/sortOrder/scenes`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get all deviceGroup Ids that are lighting groups from a location in sorted order.
     *
     * @tags detailsPage
     * @name ListSortOrderLightingGroups
     * @summary Sort ordered list of lighting groups.
     * @request GET:/detailsPage/sortOrder/lightingGroups
     * @secure
     */
    listSortOrderLightingGroups: (query: ListSortOrderLightingGroupsParams, params: RequestParams = {}) =>
      this.request<DeviceList, void>({
        path: `/detailsPage/sortOrder/lightingGroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of deviceGroup Ids that are lighting groups for a location.  Must provide all deviceGroup Ids of light groups for a location.
     *
     * @tags detailsPage
     * @name UpdateSortOrderLightingGroups
     * @summary Update sort order of lighting groups.
     * @request PUT:/detailsPage/sortOrder/lightingGroups
     * @secure
     */
    updateSortOrderLightingGroups: (
      query: UpdateSortOrderLightingGroupsParams,
      jsonBody: string[],
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/detailsPage/sortOrder/lightingGroups`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        ...params,
      }),

    /**
     * @description Get all deviceGroup Ids that are camera groups from a location in sorted order.
     *
     * @tags detailsPage
     * @name ListSortOrderCameraGroups
     * @summary Sort ordered list of camera groups.
     * @request GET:/detailsPage/sortOrder/cameraGroups
     * @secure
     */
    listSortOrderCameraGroups: (query: ListSortOrderCameraGroupsParams, params: RequestParams = {}) =>
      this.request<DeviceList, void>({
        path: `/detailsPage/sortOrder/cameraGroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of deviceGroup Ids that are camera groups for a location.  Must provide all deviceGroups Ids that are camera groups for a location.
     *
     * @tags detailsPage
     * @name UpdateSortOrderCameraGroups
     * @summary Update sort order of camera groups.
     * @request PUT:/detailsPage/sortOrder/cameraGroups
     * @secure
     */
    updateSortOrderCameraGroups: (
      query: UpdateSortOrderCameraGroupsParams,
      jsonBody: string[],
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/detailsPage/sortOrder/cameraGroups`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        ...params,
      }),
  };
  devicegroups = {
    /**
     * @description Get a list of device groups
     *
     * @tags devicegroups
     * @name ListDeviceGroups
     * @summary List all device groups for the user
     * @request GET:/devicegroups
     * @secure
     */
    listDeviceGroups: (query: ListDeviceGroupsParams, params: RequestParams = {}) =>
      this.request<PagedDeviceGroups, ErrorResponse>({
        path: `/devicegroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new device group Upon group creation, the group type is decided based on the given input and the capabilities of the included devices; the resulting group type may not be what is passed in.
     *
     * @tags devicegroups
     * @name CreateDeviceGroup
     * @summary create a device group
     * @request POST:/devicegroups
     * @secure
     */
    createDeviceGroup: (request: DeviceGroupCreateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, ErrorResponse>({
        path: `/devicegroups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of device group statuses with optional filtering by location, capability and group type
     *
     * @tags devicegroups
     * @name ListDeviceGroupStatuses
     * @summary Get a list of device group statuses
     * @request GET:/devicegroups/status
     * @secure
     */
    listDeviceGroupStatuses: (query: ListDeviceGroupStatusesParams, params: RequestParams = {}) =>
      this.request<FlatDeviceGroupStatusPagedResult, ErrorResponse>({
        path: `/devicegroups/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devices = {
    /**
     * @description Get a list of devices.
     *
     * @tags Devices
     * @name GetDevices
     * @summary List devices.
     * @request GET:/devices
     * @secure
     */
    getDevices: (query: GetDevicesParams, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a device's description.
     *
     * @tags Devices
     * @name GetDevice
     * @summary Get a device's description.
     * @request GET:/devices/{deviceId}
     * @secure
     */
    getDevice: ({ deviceId, ...query }: GetDeviceParams, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the properties of a Device. If the OAuth token used for this call is for a SmartApp that created the Device you are attempting to update, the call implicitly has permission for this API.
     *
     * @tags Devices
     * @name UpdateDevice
     * @summary Update a Device
     * @request PUT:/devices/{deviceId}
     * @secure
     */
    updateDevice: (
      { deviceId, ...query }: UpdateDeviceParams,
      updateDeviceRequest: UpdateDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<Device, ErrorResponse>({
        path: `/devices/${deviceId}`,
        method: 'PUT',
        query: query,
        body: updateDeviceRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description updates device icon. Also updates device category. Will return 400 if the icon is not valid for the device type
     *
     * @tags devices
     * @name UpdateDeviceIcon
     * @summary update device icon
     * @request PUT:/devices/{deviceId}/icon
     * @secure
     */
    updateDeviceIcon: (deviceId: string, jsonBody: IconData, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/devices/${deviceId}/icon`,
        method: 'PUT',
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get a paginated list of all device's health status.
     *
     * @tags devices
     * @name ListDeviceHealthByLocationId
     * @summary Get the health status of all devices
     * @request GET:/devices/health
     * @secure
     */
    listDeviceHealthByLocationId: (query: ListDeviceHealthByLocationIdParams, params: RequestParams = {}) =>
      this.request<
        {
          items?: DeviceHealthResponse[];
          links?: Links;
        },
        ErrorResponse
      >({
        path: `/devices/health`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of device statuses. If locationIds are provided, the list of Device statuses will be filtered to only those locations.
     *
     * @tags devices
     * @name ListDeviceStatuses
     * @summary Get a list of device statuses
     * @request GET:/devices/status
     * @secure
     */
    listDeviceStatuses: (query: ListDeviceStatusesParams, params: RequestParams = {}) =>
      this.request<FlatDeviceStatusPagedResult, ErrorResponse>({
        path: `/devices/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  icons = {
    /**
     * @description Fetch a capability icon given a capability and an attribute.
     *
     * @tags icons
     * @name GetCapabilityAttributeIcon
     * @summary Fetch a capability attribute icon
     * @request GET:/icons/capabilities/{capabilityId}/{attributeName}
     */
    getCapabilityAttributeIcon: (
      { capabilityId, attributeName, ...query }: GetCapabilityAttributeIconParams,
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/icons/capabilities/${capabilityId}/${attributeName}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch an OCF Device Type Icon.
     *
     * @tags icons
     * @name GetOcfDeviceTypeIcon
     * @summary Fetch an OCF Device Type Icon
     * @request GET:/icons/ocfDeviceType/{ocfDeviceType}
     */
    getOcfDeviceTypeIcon: ({ ocfDeviceType, ...query }: GetOcfDeviceTypeIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/ocfDeviceType/${ocfDeviceType}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Scene Icon.
     *
     * @tags icons
     * @name GetSceneIcon
     * @summary Fetch a Scene Icon
     * @request GET:/icons/scenes/{sceneIcon}
     */
    getSceneIcon: ({ sceneIcon, ...query }: GetSceneIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/scenes/${sceneIcon}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Oneui Icon.
     *
     * @tags icons
     * @name GetOneuiIcon
     * @summary Fetch a Oneui Icon
     * @request GET:/icons/oneui/{oneuiIcon}/{oneuiIconState}
     */
    getOneuiIcon: ({ oneuiIcon, oneuiIconState, ...query }: GetOneuiIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/oneui/${oneuiIcon}/${oneuiIconState}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Preload Icon.
     *
     * @tags icons
     * @name GetPreloadIcon
     * @summary Fetch a Preload Icon
     * @request GET:/icons/preload/{preloadIcon}/{preloadIconState}
     */
    getPreloadIcon: ({ preloadIcon, preloadIconState, ...query }: GetPreloadIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/preload/${preloadIcon}/${preloadIconState}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Device Group Icon.
     *
     * @tags icons
     * @name GetGroupIcon
     * @summary Fetch a Device Group Icon
     * @request GET:/icons/group/{groupIcon}/{groupIconState}
     */
    getGroupIcon: ({ groupIcon, groupIconState, ...query }: GetGroupIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/group/${groupIcon}/${groupIconState}`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  installedapps = {
    /**
     * @description Fetch a list of Installed App Summaries. This request combines results from the public API and legacy SmartApps
     *
     * @tags installedapps
     * @name ListInstalledAppSummaries
     * @summary List Installed App Summaries
     * @request GET:/installedapps
     * @secure
     */
    listInstalledAppSummaries: (query: ListInstalledAppSummariesParams, params: RequestParams = {}) =>
      this.request<InstalledAppSummary[], void>({
        path: `/installedapps`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Uninstall the installed app for the given installedAppId
     *
     * @tags installedapps
     * @name UninstallInstalledApp
     * @summary Uninstall
     * @request DELETE:/installedapps/{installedAppId}
     * @secure
     */
    uninstallInstalledApp: ({ installedAppId, ...query }: UninstallInstalledAppParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, void>({
        path: `/installedapps/${installedAppId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Pause the installed app for the given installedAppId
     *
     * @tags installedapps
     * @name PauseInstalledApp
     * @summary Pause
     * @request PUT:/installedapps/{installedAppId}/pause
     * @secure
     */
    pauseInstalledApp: ({ installedAppId, ...query }: PauseInstalledAppParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, void>({
        path: `/installedapps/${installedAppId}/pause`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Resume the paused installed app for the given installedAppId
     *
     * @tags installedapps
     * @name ResumeInstalledApp
     * @summary Resume
     * @request PUT:/installedapps/{installedAppId}/resume
     * @secure
     */
    resumeInstalledApp: ({ installedAppId, ...query }: ResumeInstalledAppParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, void>({
        path: `/installedapps/${installedAppId}/resume`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  irdevices = {
    /**
     * @description List all of the parent and child devices filtered by logged in user
     *
     * @tags irdevices
     * @name ListIrDevices
     * @summary list devices
     * @request GET:/irdevices
     * @secure
     */
    listIrDevices: (params: RequestParams = {}) =>
      this.request<PagedIRDevices, ErrorResponse>({
        path: `/irdevices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new IR Blaster device.
     *
     * @tags irdevices
     * @name CreateIrDevice
     * @summary Create an IR Device
     * @request POST:/irdevices
     * @secure
     */
    createIrDevice: (createDevice: CreateIrDevice, params: RequestParams = {}) =>
      this.request<IrDevice, ErrorResponse>({
        path: `/irdevices`,
        method: 'POST',
        body: createDevice,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the details of the device.
     *
     * @tags irdevices
     * @name GetIrDevice
     * @summary Get device details
     * @request GET:/irdevices/{deviceId}
     * @secure
     */
    getIrDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<IrDevice, ErrorResponse>({
        path: `/irdevices/${deviceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the device record. Examples include switching device profiles in response to capability changes, syncing and device supplied data.
     *
     * @tags irdevices
     * @name UpdateIrDevice
     * @summary Update an IR device
     * @request PUT:/irdevices/{deviceId}
     * @secure
     */
    updateIrDevice: (deviceId: string, updateDevice: IrUpdateRequest, params: RequestParams = {}) =>
      this.request<IrDevice, any>({
        path: `/irdevices/${deviceId}`,
        method: 'PUT',
        body: updateDevice,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name DeleteIrDevice
     * @request DELETE:/irdevices/{deviceId}
     * @secure
     */
    deleteIrDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/irdevices/${deviceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Get all the children for a given device.
     *
     * @tags irdevices
     * @name GetIrDeviceChildren
     * @summary Get all the children for a given device
     * @request GET:/irdevices/{deviceId}/children
     * @secure
     */
    getIrDeviceChildren: (deviceId: string, params: RequestParams = {}) =>
      this.request<PagedIRChildDevices, ErrorResponse>({
        path: `/irdevices/${deviceId}/children`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name StudyIrCode
     * @summary Put an IR Device into a learning state
     * @request PUT:/irdevices/{parentDeviceId}/learning
     */
    studyIrCode: (parentDeviceId: string, enterLearningState: IrLearningRequest, params: RequestParams = {}) =>
      this.request<CancelResponse, any>({
        path: `/irdevices/${parentDeviceId}/learning`,
        method: 'PUT',
        body: enterLearningState,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name GetIrCode
     * @summary Get the IR Code that was just learned
     * @request GET:/irdevices/{parentDeviceId}/ircode/{childDevicePid}
     */
    getIrCode: (parentDeviceId: string, childDevicePid: string, params: RequestParams = {}) =>
      this.request<
        {
          /**
           * IR Code
           * @example "260050...000"
           */
          code?: string;
        },
        any
      >({
        path: `/irdevices/${parentDeviceId}/ircode/${childDevicePid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Partial update of the values you want to update. Each value will be added to existing values.
     *
     * @tags irdevices
     * @name PatchDevice
     * @summary Partial update of a device's metadata and commands
     * @request PATCH:/irdevices/{childDeviceId}
     */
    patchDevice: (childDeviceId: string, body: DevicePatch, params: RequestParams = {}) =>
      this.request<CancelResponse, any>({
        path: `/irdevices/${childDeviceId}`,
        method: 'PATCH',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name ExecuteFunction
     * @summary Execute a function on a device
     * @request POST:/irdevices/{parentDeviceId}/control
     */
    executeFunction: (parentDeviceId: string, body: Function, params: RequestParams = {}) =>
      this.request<CancelResponse, any>({
        path: `/irdevices/${parentDeviceId}/control`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name QueryVersion
     * @summary Query the OTA version by Device
     * @request GET:/irdevices/{deviceId}/ota/version
     */
    queryVersion: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceOTAVersion, any>({
        path: `/irdevices/${deviceId}/ota/version`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name OtaUpgrade
     * @summary Upgrade the OTA Version
     * @request PUT:/irdevices/{deviceId}/ota/version
     */
    otaUpgrade: (deviceId: string, body: OtaUpgradePayload, params: RequestParams = {}) =>
      this.request<CancelResponse, any>({
        path: `/irdevices/${deviceId}/ota/version`,
        method: 'PUT',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  locations = {
    /**
     * @description This endpoint merely proxies to SIAM.  You should be using https://librarian-regionals.smartthingsgdev.com/api/siam.st.internal.v20200320#operation/queryUsers for lower latency.
     *
     * @tags Locations
     * @name GetLocationUsers
     * @summary This endpoint merely proxies to SIAM.  You should be using https://librarian-regionals.smartthingsgdev.com/api/siam.st.internal.v20200320#operation/queryUsers for lower latency.
     * @request GET:/locations/{pathLocationId}/users
     * @secure
     */
    getLocationUsers: (pathLocationId: string, params: RequestParams = {}) =>
      this.request<LocationUsersResponse, any>({
        path: `/locations/${pathLocationId}/users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description unshare location
     *
     * @tags locations
     * @name UnshareLocation
     * @summary Remove a user from a location
     * @request PUT:/locations/{pathLocationId}/users
     * @secure
     */
    unshareLocation: (pathLocationId: string, userToRemove: UserToRemove, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/locations/${pathLocationId}/users`,
        method: 'PUT',
        body: userToRemove,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Updates Map View Info for Rooms and Devices in the payload
     *
     * @tags shepherd, locations
     * @name UpdateRoomsAndDevicesForLocation
     * @summary Update MapView Info for Rooms and Devices
     * @request PUT:/locations/{locationId}/rooms_and_devices
     * @secure
     */
    updateRoomsAndDevicesForLocation: (
      { locationId, ...query }: UpdateRoomsAndDevicesForLocationParams,
      mapViewData: RoomsAndDevicesMapViewData,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/locations/${locationId}/rooms_and_devices`,
        method: 'PUT',
        query: query,
        body: mapViewData,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Create Invitations for a single, specified user.  While the request payload suggests that multiple invitees are accepted, they are not.
     *
     * @tags Invitations
     * @name CreateInvitation
     * @summary Create a Invitation.
     * @request POST:/locations/invitations
     * @secure
     */
    createInvitation: (createInvitationRequest: CreateInvitationRequest, params: RequestParams = {}) =>
      this.request<Invitation, ErrorResponse>({
        path: `/locations/invitations`,
        method: 'POST',
        body: createInvitationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a list of invites for an invitee
     *
     * @tags locations
     * @name GetInvites
     * @summary Get invites for an invitee
     * @request GET:/locations/invitations/invitee
     * @secure
     */
    getInvites: (query: GetInvitesParams, params: RequestParams = {}) =>
      this.request<PagedInvitations, any>({
        path: `/locations/invitations/invitee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Accept a specific Invitation.  If inviter and invitee regions do not match, a 422 will be returned.
     *
     * @tags locations
     * @name AcceptInvitation
     * @summary Accept an Invitation.
     * @request POST:/locations/invitations/{invitationId}/accept
     * @secure
     */
    acceptInvitation: (invitationId: string, consentBody: AcceptInvitationRequest, params: RequestParams = {}) =>
      this.request<AcceptInvitationResponse, ErrorResponse>({
        path: `/locations/invitations/${invitationId}/accept`,
        method: 'POST',
        body: consentBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a list of all users for all locations this user is a member of.
     *
     * @tags Locations
     * @name GetAllLocationUsers
     * @summary Get all users for all locations a user owns.
     * @request GET:/locations/users
     * @secure
     */
    getAllLocationUsers: (params: RequestParams = {}) =>
      this.request<LocationUsersResponseWithLocationId[], ErrorResponse>({
        path: `/locations/users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all Rooms currently available in all locations for a user.
     *
     * @tags Rooms
     * @name ListAllRooms
     * @summary List Rooms
     * @request GET:/locations/rooms
     * @secure
     */
    listAllRooms: (params: RequestParams = {}) =>
      this.request<PagedRooms, ErrorResponse>({
        path: `/locations/rooms`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the Modes of all locations from a user's account.
     *
     * @tags Modes
     * @name GetAllModes
     * @summary Get the Modes of all locations.
     * @request GET:/locations/modes
     * @secure
     */
    getAllModes: (query: GetAllModesParams, params: RequestParams = {}) =>
      this.request<ModesWithLocationIdResponse[], ErrorResponse>({
        path: `/locations/modes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of all current modes.
     *
     * @tags Modes
     * @name GetAllCurrentModes
     * @summary Get a list of all current Location Modes.
     * @request GET:/locations/modes/current
     * @secure
     */
    getAllCurrentModes: (query: GetAllCurrentModesParams, params: RequestParams = {}) =>
      this.request<ModeWithLocationId[], ErrorResponse>({
        path: `/locations/modes/current`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all Locations currently available in a user account.
     *
     * @tags locations
     * @name ListLocations
     * @summary List Locations.
     * @request GET:/locations
     * @secure
     */
    listLocations: (params: RequestParams = {}) =>
      this.request<PagedPublicLocations, ErrorResponse>({
        path: `/locations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a location in account with rooms and wallpapers.
     *
     * @tags locations
     * @name CreateLocation
     * @summary Create a location.
     * @request POST:/locations
     * @secure
     */
    createLocation: (
      query: CreateLocationParams,
      createLocation: CreateLocationWithRoomsAndWallpapers,
      params: RequestParams = {},
    ) =>
      this.request<LocationWithRoomsAndWallpapers, ErrorResponse>({
        path: `/locations`,
        method: 'POST',
        query: query,
        body: createLocation,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a location together with location modes and location wallpaper
     *
     * @tags locations
     * @name UpdateLocation
     * @summary Update a location with modes.
     * @request PUT:/locations/{locationId}
     * @secure
     */
    updateLocation: (
      { locationId, ...query }: UpdateLocationParams,
      updateLocationBody: UpdateLocationWithModesAndWallpaperRequest,
      params: RequestParams = {},
    ) =>
      this.request<LocationWithModesAndWallpaper, ErrorResponse>({
        path: `/locations/${locationId}`,
        method: 'PUT',
        query: query,
        body: updateLocationBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the default Location for a User. If no default location exists, creates a new location to be derived as default.
     *
     * @tags internal
     * @name GetInternalDefaultLocation
     * @summary Get the default Location for a User.
     * @request GET:/locations/default
     * @secure
     */
    getInternalDefaultLocation: (params: RequestParams = {}) =>
      this.request<DefaultLocation, ErrorResponse>({
        path: `/locations/default`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  locationsRooms = {
    /**
     * @description List all Locations and Rooms currently available in a user account. Does not read/write through to DM.
     *
     * @tags internal
     * @name ListInternalLocationsAndRooms
     * @summary List Locations and Rooms.
     * @request GET:/locations_rooms
     * @secure
     */
    listInternalLocationsAndRooms: (params: RequestParams = {}) =>
      this.request<InternalLocationsAndRooms, ErrorResponse>({
        path: `/locations_rooms`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  migrate = {
    /**
     * @description Installs and authorizes an app given an appId, locationId, and configuration. If an existing install is found, will return a 409.
     *
     * @tags migrate
     * @name MigrateInstall
     * @summary Install and authorizes an app
     * @request POST:/migrate/install
     * @secure
     */
    migrateInstall: (migrationInstallRequest: MigrationInstallRequest, params: RequestParams = {}) =>
      this.request<InstallSummary, Error | void>({
        path: `/migrate/install`,
        method: 'POST',
        body: migrationInstallRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  notification = {
    /**
     * @description Retrieve notification history, can be filtered by location IDs and/or device IDs, both optional. Newest notification will be listed first.
     *
     * @tags notification
     * @name GetNotifications
     * @summary Retrieve notification history
     * @request GET:/notification
     * @secure
     */
    getNotifications: (query: GetNotificationsParams, request: NotificationRequest, params: RequestParams = {}) =>
      this.request<NotificationPage, void>({
        path: `/notification`,
        method: 'GET',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ocfdevicegroups = {
    /**
     * @description Get a list of device groups
     *
     * @tags ocfdevicegroups
     * @name ListDeviceGroups
     * @summary List all device groups for the user
     * @request GET:/ocfdevicegroups
     * @secure
     */
    listDeviceGroups: (query: Link6, params: RequestParams = {}) =>
      this.request<PagedDeviceGroups, void | Error>({
        path: `/ocfdevicegroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new device group
     *
     * @tags ocfdevicegroups
     * @name CreateDeviceGroup
     * @summary Create a device group
     * @request POST:/ocfdevicegroups
     * @secure
     */
    createDeviceGroup: (request: DeviceGroupCreateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, void | Error>({
        path: `/ocfdevicegroups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute a device group command or get the status of a device group.
     *
     * @tags ocfdevicegroups
     * @name DeviceGroupCommandRequest
     * @summary Take OCF command or status request
     * @request POST:/ocfdevicegroups/request
     * @secure
     */
    deviceGroupCommandRequest: (executeDeviceGroupCommand: OcfDeviceGroupsCommandRequest, params: RequestParams = {}) =>
      this.request<OcfDeviceGroupsCommandResponse, void | Error>({
        path: `/ocfdevicegroups/request`,
        method: 'POST',
        body: executeDeviceGroupCommand,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single device group by Id
     *
     * @tags ocfdevicegroups
     * @name GetDeviceGroup
     * @summary Show device group by id
     * @request GET:/ocfdevicegroups/{deviceGroupId}
     * @secure
     */
    getDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, void | Error>({
        path: `/ocfdevicegroups/${deviceGroupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description update device group with a new set of devices or name. Keep same id.
     *
     * @tags ocfdevicegroups
     * @name UpdateDeviceGroup
     * @summary Update device group with a new set of devices or a name. Keep same id.
     * @request PUT:/ocfdevicegroups/{deviceGroupId}
     * @secure
     */
    updateDeviceGroup: (deviceGroupId: string, request: DeviceGroupUpdateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, void | Error>({
        path: `/ocfdevicegroups/${deviceGroupId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete device group based on deviceGroupId
     *
     * @tags ocfdevicegroups
     * @name DeleteDeviceGroup
     * @summary Delete device group based on deviceGroupId
     * @request DELETE:/ocfdevicegroups/{deviceGroupId}
     * @secure
     */
    deleteDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupDeleteResponse, void | Error>({
        path: `/ocfdevicegroups/${deviceGroupId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  piper = {
    /**
     * @description Send client logs to data platform piper service. NOTE: The payload is required to be compressed with gzip.
     *
     * @tags piper
     * @name PostPiperLogs
     * @summary Post client logs
     * @request POST:/piper/logs
     * @secure
     */
    postPiperLogs: (PiperLogsRequest: PiperLogsRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/piper/logs`,
        method: 'POST',
        body: PiperLogsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get client logs from data platform piper service
     *
     * @tags piper
     * @name GetPiperLogs
     * @summary Retrieve the list of client logs
     * @request GET:/piper/logs
     * @secure
     */
    getPiperLogs: (query: GetPiperLogsParams, params: RequestParams = {}) =>
      this.request<PagedPiperGetLogsResponse, ErrorResponse>({
        path: `/piper/logs`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send client click events to data platform piper service. NOTE: The payload is required to be compressed with gzip.
     *
     * @tags piper
     * @name PostPiperClicks
     * @summary Post client click events
     * @request POST:/piper/clicks
     * @secure
     */
    postPiperClicks: (PiperClicksRequest: PiperClicksRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/piper/clicks`,
        method: 'POST',
        body: PiperClicksRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Send hub logs to data platform piper service. Pre-signed URL returned to client for uploading the logs.
     *
     * @tags piper
     * @name PostPiperHubLogs
     * @summary Post hub logs file
     * @request POST:/piper/hub/logs
     * @secure
     */
    postPiperHubLogs: (PiperHubLogsRequest: PiperHubLogsRequest, params: RequestParams = {}) =>
      this.request<PiperHubLogsResponse, ErrorResponse>({
        path: `/piper/hub/logs`,
        method: 'POST',
        body: PiperHubLogsRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send device logs to data platform piper service. Pre-signed URL returned to client for uploading the logs.
     *
     * @tags piper
     * @name PostPiperDeviceLogs
     * @summary Post device logs file
     * @request POST:/piper/device/logs
     * @secure
     */
    postPiperDeviceLogs: (PiperDeviceLogsRequest: PiperDeviceLogsRequest, params: RequestParams = {}) =>
      this.request<PiperDeviceLogsResponse, ErrorResponse>({
        path: `/piper/device/logs`,
        method: 'POST',
        body: PiperDeviceLogsRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get available recommendations from Postino
     *
     * @tags piper
     * @name GetRecommendations
     * @summary Get recommendations
     * @request GET:/piper/recommendations
     * @secure
     */
    getRecommendations: (query: GetRecommendationsParams, params: RequestParams = {}) =>
      this.request<PostinoRecommendationList, ErrorResponse>({
        path: `/piper/recommendations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Change recommendation preferences
     *
     * @tags piper
     * @name ChangeRecommendationPreference
     * @summary Change recommendation preferences
     * @request POST:/piper/recommendations/preferences
     * @secure
     */
    changeRecommendationPreference: (PreferenceRequest: PostinoRecommendationPreference, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/piper/recommendations/preferences`,
        method: 'POST',
        body: PreferenceRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get preset routines from Postino
     *
     * @tags piper
     * @name GetPresetRoutines
     * @summary Get preset routines
     * @request GET:/piper/preset-routines
     * @secure
     */
    getPresetRoutines: (query: GetPresetRoutinesParams, params: RequestParams = {}) =>
      this.request<PostinoPresetRoutinesList, any>({
        path: `/piper/preset-routines`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  preauthorize = {
    /**
     * @description Installs and authorizes a preauthorized app given an appId, locationId, and configuration. If the app is not preauthorized or an existing install is found, it will return a 409.
     *
     * @tags preauthorize
     * @name PreauthorizeInstall
     * @summary Install and authorizes a preauthorized app
     * @request POST:/preauthorize/install
     * @secure
     */
    preauthorizeInstall: (preauthorizeInstallRequest: InstallRequest, params: RequestParams = {}) =>
      this.request<InstallSummary, Error | void>({
        path: `/preauthorize/install`,
        method: 'POST',
        body: preauthorizeInstallRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  scenes = {
    /**
     * @description List of scenes for the given token principal. Either a locationId or ownerType is required. If no locationId is provided, then list all scenes for all locations accessible by the principle.
     *
     * @tags scenes
     * @name ListScenes
     * @summary Scenes list
     * @request GET:/scenes
     * @secure
     */
    listScenes: (query: ListScenesParams, params: RequestParams = {}) =>
      this.request<ScenePagedResult, void | Error>({
        path: `/scenes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a scene for the location and token principal
     *
     * @tags scenes
     * @name CreateScene
     * @summary Create a scene
     * @request POST:/scenes
     * @secure
     */
    createScene: (query: CreateSceneParams, request: SceneRequest, params: RequestParams = {}) =>
      this.request<Scene, void | Error>({
        path: `/scenes`,
        method: 'POST',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete all scenes in a location
     *
     * @tags scenes
     * @name DeleteAllScenes
     * @summary Delete all scenes
     * @request DELETE:/scenes
     * @secure
     */
    deleteAllScenes: (query: DeleteAllScenesParams, params: RequestParams = {}) =>
      this.request<void, void | Error>({
        path: `/scenes`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Get a scene
     *
     * @tags scenes
     * @name GetScene
     * @summary Get a Scene
     * @request GET:/scenes/{sceneId}
     * @secure
     */
    getScene: ({ sceneId, ...query }: GetSceneParams, params: RequestParams = {}) =>
      this.request<Scene, void | Error>({
        path: `/scenes/${sceneId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a scene
     *
     * @tags scenes
     * @name UpdateScene
     * @summary Update a scene
     * @request PUT:/scenes/{sceneId}
     * @secure
     */
    updateScene: ({ sceneId, ...query }: UpdateSceneParams, request: SceneRequest, params: RequestParams = {}) =>
      this.request<Scene, void | Error>({
        path: `/scenes/${sceneId}`,
        method: 'PUT',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a scene
     *
     * @tags scenes
     * @name DeleteScene
     * @summary Delete a scene
     * @request DELETE:/scenes/{sceneId}
     * @secure
     */
    deleteScene: ({ sceneId, ...query }: DeleteSceneParams, params: RequestParams = {}) =>
      this.request<Scene, void | Error>({
        path: `/scenes/${sceneId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Trigger Adhoc Scene execution
     *
     * @tags scenes
     * @name ExecuteAdhocScene
     * @summary Execute adhoc scene
     * @request POST:/scenes/execute
     * @secure
     */
    executeAdhocScene: (query: ExecuteAdhocSceneParams, request: SceneAdhocRequest, params: RequestParams = {}) =>
      this.request<SceneExecutionResponse, void | Error>({
        path: `/scenes/execute`,
        method: 'POST',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Trigger Scene execution given a scene ID
     *
     * @tags scenes
     * @name ExecuteScene
     * @summary Execute a scene
     * @request POST:/scenes/execute/{sceneId}
     * @secure
     */
    executeScene: ({ sceneId, ...query }: ExecuteSceneParams, params: RequestParams = {}) =>
      this.request<SceneExecutionResponse, void | Error>({
        path: `/scenes/execute/${sceneId}`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description returns list of icons available for scenes with id and url
     *
     * @tags scenes
     * @name GetSceneIcons
     * @summary returns list of icons available for scenes
     * @request GET:/scenes/icons
     * @secure
     */
    getSceneIcons: (params: RequestParams = {}) =>
      this.request<
        {
          items?: SceneIcon[];
          links?: Links;
        },
        any
      >({
        path: `/scenes/icons`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  strongman = {
    /**
     * @description Begin installation or update of an installed app. Returns the installed app and a `STAGED` configuration. The returned configuration has been initialized with either the current `AUTHORIZED` configuration, if available, or the most recent `DONE`/`STAGED` configuration. | The optional installedAppId (request body) will indicate whether to create a new installed app (without installedAppId) or edit an existing installed app (with installedAppId). Additionally, if the app is a singleton and an installed app already exists, a request without an installedAppId will be treated as an edit to the existing installed app.
     *
     * @tags Installedapps
     * @name InitializeInstall
     * @summary Begin installation or update of an installed app.
     * @request PUT:/strongman/installedapps/initialize
     * @secure
     */
    initializeInstall: (initializeRequest: InitializeRequest, params: RequestParams = {}) =>
      this.request<InitializeResponse, ErrorResponse>({
        path: `/strongman/installedapps/initialize`,
        method: 'PUT',
        body: initializeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Cancel installation or update of an installed app by revoking a `STAGED` configuration for an `AUTHORIZED` installed app, or deleting the installed app if it has not been `AUTHORIZED`.
     *
     * @tags Installedapps
     * @name CancelInstall
     * @summary Cancel installation or update of an installed app.
     * @request PUT:/strongman/installedapps/{installedAppId}/cancel
     * @secure
     */
    cancelInstall: (installedAppId: string, cancelRequest: CancelRequest, params: RequestParams = {}) =>
      this.request<CancelResponse, ErrorResponse>({
        path: `/strongman/installedapps/${installedAppId}/cancel`,
        method: 'PUT',
        body: cancelRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Starts the process of completing an Endpoint App installation. If the app is preauthorized, the configuration provided in the request will be marked as authorized and an install/update lifecycle event will be sent. The endpoint will respond with a JSON body containing message:"success". No further action is required. If the app is not preauthorized, a JSON response containing a URL to consigliere will be provided. This URL is used to confirm the permissions and will redirect to the strongman install/finalize endpoint to mark the configuration as authorized and send an install/update lifecycle event. The config sent in the request must not be null or empty.
     *
     * @tags strongman
     * @name InstallComplete
     * @summary Start the process of completing an Endpoint App installation.
     * @request POST:/strongman/install/complete
     * @secure
     */
    installComplete: (serviceInstallCompleteRequest: ServiceAppCompleteRequest, params: RequestParams = {}) =>
      this.request<ServiceAppCompleteResponse, Error | void>({
        path: `/strongman/install/complete`,
        method: 'POST',
        body: serviceInstallCompleteRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  swatches = {
    /**
     * @description Get a paginated list of DeviceSwatches that have been added, modified, or deleted since the provided time stamp. If `_links.next` is populated, clients must recursively fetch more results by calling the url exactly as specified until `_links.next` is not specified. Both `updated` and `deleted` are paginated so they must both be processed for all subsequent requests.
     *
     * @tags swatches
     * @name GetSwatches
     * @summary Get a partial list of DeviceSwatches
     * @request GET:/swatches
     * @secure
     */
    getSwatches: (query: GetSwatchesParams, params: RequestParams = {}) =>
      this.request<PartialDeviceSwatchResponse, ErrorResponse>({
        path: `/swatches`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of Swatch Statuses.
     *
     * @tags swatches
     * @name GetSwatchStatuses
     * @summary Get a paginated list of Swatch Statuses
     * @request GET:/swatches/status
     * @secure
     */
    getSwatchStatuses: (query: GetSwatchStatusesParams, params: RequestParams = {}) =>
      this.request<SwatchStatusPagedResult, ErrorResponse>({
        path: `/swatches/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  uimetadata = {
    /**
     * @description Get UiMetadata for all devices in given location
     *
     * @tags uimetadata
     * @name GetUiMetadata
     * @summary Get UiMetadata for all devices in given location
     * @request GET:/uimetadata
     * @secure
     */
    getUiMetadata: (query: GetUiMetadataParams, params: RequestParams = {}) =>
      this.request<UiMetadata[], ErrorResponse>({
        path: `/uimetadata`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get UiMetadata for given device id
     *
     * @tags uimetadata
     * @name GetUiMetadataByDeviceId
     * @summary Get UiMetadata for given device id
     * @request GET:/uimetadata/{deviceId}
     * @secure
     */
    getUiMetadataByDeviceId: ({ deviceId, ...query }: GetUiMetadataByDeviceIdParams, params: RequestParams = {}) =>
      this.request<UiMetadata, ErrorResponse>({
        path: `/uimetadata/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get UiMetadata for given mnmn and vid
     *
     * @tags uimetadata
     * @name GetUiMetadataByMnmnVid
     * @summary Get UiMetadata for given mnmn and vid
     * @request GET:/uimetadata/{mnmn}/{vid}
     * @secure
     */
    getUiMetadataByMnmnVid: ({ mnmn, vid, ...query }: GetUiMetadataByMnmnVidParams, params: RequestParams = {}) =>
      this.request<UiMetadata, ErrorResponse>({
        path: `/uimetadata/${mnmn}/${vid}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get UiMetadata device version info for given mnmn/vid
     *
     * @tags uimetadata
     * @name GetUiMetadataDeviceVersion
     * @summary Get UiMetadata device version info
     * @request GET:/uimetadata/{mnmn}/{vid}/version
     * @secure
     */
    getUiMetadataDeviceVersion: (
      { mnmn, vid, ...query }: GetUiMetadataDeviceVersionParams,
      params: RequestParams = {},
    ) =>
      this.request<UiMetadataVersionData[], ErrorResponse>({
        path: `/uimetadata/${mnmn}/${vid}/version`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  viper = {
    /**
     * @description Get devices and app related info for the given isaId. If relogin is not required then the pageType will be set to "loggedIn" and we return the isaId, devices, partnerName, appName and icons. If relogin is needed, the pageType will be set to "requiresLogin" and only the "oauthLink" value will be populated in the response. Used by mobile
     *
     * @tags viper
     * @name GetDevicesByIsaId
     * @request GET:/viper/isa/{isaId}
     */
    getDevicesByIsaId: ({ isaId, ...query }: GetDevicesByIsaIdParams, params: RequestParams = {}) =>
      this.request<Isa, void>({
        path: `/viper/isa/${isaId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates specified isaId related information.
     *
     * @tags viper
     * @name PutIsaByIsaId
     * @request PUT:/viper/isa/{isaId}
     */
    putIsaByIsaId: (
      { isaId, ...query }: PutIsaByIsaIdParams,
      PutIsaBody: PutIsaBody,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/viper/isa/${isaId}`,
        method: 'PUT',
        query: query,
        body: PutIsaBody,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes specified isaId and associated devices with isaId.
     *
     * @tags viper
     * @name DeleteIsaByIsaId
     * @request DELETE:/viper/isa/{isaId}
     */
    deleteIsaByIsaId: ({ isaId, ...query }: DeleteIsaByIsaIdParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/viper/isa/${isaId}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Gets installed SchemaApps for the specified locationId
     *
     * @tags viper
     * @name GetIsaByLocationId
     * @request GET:/viper/isa/location/{locationId}
     */
    getIsaByLocationId: (locationId: string, params: RequestParams = {}) =>
      this.request<LocationIsa, void>({
        path: `/viper/isa/location/${locationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Requests page to start app install for the user. The pageType will be set to "requiresLogin" and only the "oauthLink" value will be populated in the response. If the app is already installed and relogin in not required then the pageType will be set to "loggedIn" and we return the isaId, devices, partnerName, appName and icons. Used by mobile app.
     *
     * @tags viper
     * @name GetPages
     * @request GET:/viper/pages/{endpointAppId}
     */
    getPages: ({ endpointAppId, ...query }: GetPagesParams, params: RequestParams = {}) =>
      this.request<Isa, void>({
        path: `/viper/pages/${endpointAppId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  voiceassistants = {
    /**
     * @description Get Voice Assitant apps
     *
     * @tags voiceassistants
     * @name GetVoiceAssistants
     * @summary Get Voice Assistant apps
     * @request GET:/voiceassistants
     * @secure
     */
    getVoiceAssistants: (query: GetVoiceAssistantsParams, params: RequestParams = {}) =>
      this.request<
        {
          items?: VoiceAssistantApp[];
          links?: Links;
        },
        any
      >({
        path: `/voiceassistants`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  wallpaper = {
    /**
     * @description Get wallpaper for a location
     *
     * @tags wallpaper
     * @name GetLocationWallpaper
     * @summary Get wallpaper for a location
     * @request GET:/wallpaper
     * @secure
     */
    getLocationWallpaper: (query: GetLocationWallpaperParams, params: RequestParams = {}) =>
      this.request<WrappedLocationWallpaper, void>({
        path: `/wallpaper`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update wallpaper ID for a location
     *
     * @tags wallpaper
     * @name UpdateLocationWallpaper
     * @summary Update wallpaper ID for a location
     * @request PUT:/wallpaper
     * @secure
     */
    updateLocationWallpaper: (
      query: UpdateLocationWallpaperParams,
      jsonBody: UpdateWallpaperBodyObject,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/wallpaper`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        ...params,
      }),

    /**
     * @description Migrate wallpapers for a location
     *
     * @tags wallpaper
     * @name MigrateWallpapers
     * @summary migrate wallpapers for location and all rooms
     * @request POST:/wallpaper
     * @secure
     */
    migrateWallpapers: (
      query: MigrateWallpapersParams,
      jsonBody: MigrateWallpapersBodyObject,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/wallpaper`,
        method: 'POST',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get valid wallpapers for this location
     *
     * @tags wallpaper
     * @name GetValidWallpapers
     * @summary Get valid wallpapers for this location
     * @request GET:/wallpaper/list
     * @secure
     */
    getValidWallpapers: (query: GetValidWallpapersParams, params: RequestParams = {}) =>
      this.request<WrappedWallpaper[], void>({
        path: `/wallpaper/list`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get wallpapers for all rooms in a location
     *
     * @tags wallpaper
     * @name GetRoomWallpapers
     * @summary Get wallpapers for all rooms in a location
     * @request GET:/wallpaper/rooms
     * @secure
     */
    getRoomWallpapers: (query: GetRoomWallpapersParams, params: RequestParams = {}) =>
      this.request<WrappedRoomWallpaper[], void>({
        path: `/wallpaper/rooms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get wallpaper for a room
     *
     * @tags wallpaper
     * @name GetRoomWallpaper
     * @summary Get wallpaper for a room
     * @request GET:/wallpaper/rooms/{roomId}
     * @secure
     */
    getRoomWallpaper: ({ roomId, ...query }: GetRoomWallpaperParams, params: RequestParams = {}) =>
      this.request<WrappedRoomWallpaper, void>({
        path: `/wallpaper/rooms/${roomId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update wallpaper ID for a room
     *
     * @tags wallpaper
     * @name UpdateRoomWallpaper
     * @summary Update wallpaper ID for a room
     * @request PUT:/wallpaper/rooms/{roomId}
     * @secure
     */
    updateRoomWallpaper: (
      { roomId, ...query }: UpdateRoomWallpaperParams,
      jsonBody: UpdateWallpaperBodyObject,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/wallpaper/rooms/${roomId}`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        ...params,
      }),
  };
  wallpapers = {
    /**
     * @description Get Wallpapers for all locations
     *
     * @tags wallpapers
     * @name GetLocationWallpapers
     * @summary Get wallpapers for all locations
     * @request GET:/wallpapers
     * @secure
     */
    getLocationWallpapers: (params: RequestParams = {}) =>
      this.request<WrappedLocationWallpaper[], any>({
        path: `/wallpapers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  weatherdata = {
    /**
     * @description Get weather data for a location
     *
     * @tags weatherdata
     * @name GetWeatherData
     * @summary Get Weather Data for a location
     * @request GET:/weatherdata
     * @secure
     */
    getWeatherData: (query: GetWeatherDataParams, params: RequestParams = {}) =>
      this.request<WeatherData, any>({
        path: `/weatherdata`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  widget = {
    /**
     * @description Fetch a list of widget favorites to be displayed
     *
     * @tags widget
     * @name ListWidgetFavorites
     * @summary List widgetFavorites
     * @request GET:/widget/favorites
     * @secure
     */
    listWidgetFavorites: (params: RequestParams = {}) =>
      this.request<
        {
          items?: SceneWidgetFavoriteRepresentation[];
          links?: Links;
        },
        any
      >({
        path: `/widget/favorites`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create the widget favorites.  Replaces all favorites that may have already been set and stores them in the provided order.
     *
     * @tags widget
     * @name CreateWidgetFavorites
     * @summary Create Widget Favorites
     * @request PUT:/widget/favorites
     * @secure
     */
    createWidgetFavorites: (createWidgetFavorites: CreateWidgetFavoritesPayload, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/widget/favorites`,
        method: 'PUT',
        body: createWidgetFavorites,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  virtualdevices = {
    /**
     * @description Create a virtual device in a location you have access to.
     *
     * @tags Virtualdevices
     * @name CreateVirtualDevice
     * @summary Onboard virtual device
     * @request POST:/virtualdevices
     * @secure
     */
    createVirtualDevice: (createVirtualDeviceRequest: VirtualDeviceCreateRequest, params: RequestParams = {}) =>
      this.request<Device, ErrorResponse>({
        path: `/virtualdevices`,
        method: 'POST',
        body: createVirtualDeviceRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List virtual devices you own, or list virtual devices for a location.
     *
     * @tags Virtualdevices
     * @name ListVirtualDevices
     * @summary List virtual devices.
     * @request GET:/virtualdevices
     * @secure
     */
    listVirtualDevices: (query: ListVirtualDevicesParams, params: RequestParams = {}) =>
      this.request<PagedDevices, ErrorResponse>({
        path: `/virtualdevices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Onboard a virtual device from a prototype. Device must be in a location for which you have device installation privileges.
     *
     * @tags Virtualdevices
     * @name CreateVirtualDeviceByPrototype
     * @summary Onboard a prefabricated virtual device from a built-in template.
     * @request POST:/virtualdevices/prototypes
     * @secure
     */
    createVirtualDeviceByPrototype: (
      createVirtualDeviceFromPrototypeRequest: VirtualDeviceFromPrototypeRequest,
      params: RequestParams = {},
    ) =>
      this.request<Device, ErrorResponse>({
        path: `/virtualdevices/prototypes`,
        method: 'POST',
        body: createVirtualDeviceFromPrototypeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
